(function() {
    'use strict';

    angular
        .module('tmgApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'angularjs-dropdown-multiselect',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('TechnicienHomeStat', TechnicienHomeStat);

    TechnicienHomeStat.$inject = ['$resource', 'DateUtils'];

    function TechnicienHomeStat ($resource, DateUtils) {
        var resourceUrl =  'api/technicien-home-stat';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$filter', 'Principal', 'LoginService', '$state', 'TechnicienHomeStat', 'ExportPraxedo', 'DateUtils'];

    function HomeController ($scope, $filter, Principal, LoginService, $state, TechnicienHomeStat, ExportPraxedo, DateUtils) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.isAdmin = false;
        vm.login = LoginService.open;
        vm.progressBarMax = 200;
        vm.register = register;
        vm.getBackgroundColor = getBackgroundColor;
        vm.findCalendarDayInfo = findCalendarDayInfo;
        vm.viewCalendar = viewCalendar;
        vm.formatDayFr = formatDayFr;
        vm.formatMonthFr = formatMonthFr;
        vm.formatDate = formatDate;
        vm.theoricalPercentageDay = new Date().setDate(new Date().getDate() - 1);
        vm.dateStart = null;
        vm.dateEnd = null;
        vm.previousMonth = previousMonth;
        vm.actualMonth = actualMonth;
        vm.nextMonth = nextMonth;
        vm.isEquipeInWeekRange = isEquipeInWeekRange;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        function getBackgroundColor(day, calendarInfos) {
            var dayInfo = vm.findCalendarDayInfo(day, calendarInfos);
            if(moment(day).isFerie()){
                return " tdGreySunday";
            }
            if (dayInfo) {
                if (dayInfo.astreinteId) {
                    return 'tdYellow';
                }
                if (dayInfo.conges && dayInfo.conges.length > 0) {
                    if (!dayInfo.conges[0].validate) {
                        return 'tdRed';
                    } else {
                        switch (dayInfo.conges[0].status) {
                            case "AT":
                                return "tdPink";
                            case "CHP":
                                return "tdGrey";
                            case "CP":
                                return "tdBlue";
                            case "JR":
                                return "tdGreen";
                            case "JD":
                                return "tdOrange";
                            case "GD":
                                return "tdPurple";
                            default:
                                return 'none';
                        }
                    }
                }
                if (dayInfo.astreintePlanifie && dayInfo.astreintePlanifie.length > 0) {
                    switch (dayInfo.astreintePlanifie[0].type) {
                        case "CUIVRE":
                            return "tdGreen";
                        case "FIBRE_CHEF_EQUIPE_BINOME":
                            return "tdYellowChef";
                        case "FIBRE_BINOME":
                            return "tdBeigeBinome";
                        case "FIBRE_CHEF_MONOME":
                            return "tdLightBrown";
                        default:
                            return 'none';
                    }
                }
            }
            return 'none';
        }

        function findCalendarDayInfo(day, calendarInfos) {
            var formattedDay = $filter('date')(day, 'yyyy-MM-dd');
            for (var i = 0; i < calendarInfos.length; i++) {
                if (calendarInfos[i].date === formattedDay) {
                    return calendarInfos[i];
                }
            }
            return undefined;
        }

        function viewCalendar(stat){
            if (stat.display == undefined || stat.display == null){
                stat.display = true;
            }else {
                stat.display = !stat.display;
            }
        }

        DateUtils.loadCutoffDay().then(function () {
            getAccount().then(function() {
                if(vm.isAuthenticated){
                    getAllDates();
                    loadStats();
                    loadLastImportsDates();
                }
            });
        });

        function loadStats() {
            // Format local (pas toISOString/UTC) : un Date à minuit local serait
            // converti a la veille en UTC+2 et la plage chevaucherait 2 periodes de paie.
            var filter = {
                dateFrom: $filter('date')(vm.dateStart, 'yyyy-MM-dd'),
                dateTo: $filter('date')(vm.dateEnd, 'yyyy-MM-dd'),
                civilMonth: true
            }

            TechnicienHomeStat.query(filter,onSuccess, onError);
        }

        function loadLastImportsDates() {
            ExportPraxedo.getLastImports({},
                function onSuccess(data){
                    vm.lastImportFiles = data;
                },
                onError)
        }

        function onSuccess(data, headers) {
            vm.technicienHomeStats = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function previousMonth() {
            var prev = new Date(vm.dateStart.getFullYear(), vm.dateStart.getMonth() - 1, vm.dateStart.getDate());
            vm.dateStart = DateUtils.getFirstDayOfPayrollPeriod(prev);
            vm.dateEnd = DateUtils.getLastDayOfPayrollPeriod(prev);
            vm.month = vm.dateStart;
            getWeeks();
            loadStats();
        }

        function actualMonth() {
            getAllDates();
            loadStats();
        }

        function nextMonth() {
            var next = new Date(vm.dateStart.getFullYear(), vm.dateStart.getMonth() + 1, vm.dateStart.getDate());
            vm.dateStart = DateUtils.getFirstDayOfPayrollPeriod(next);
            vm.dateEnd = DateUtils.getLastDayOfPayrollPeriod(next);
            vm.month = vm.dateStart;
            getWeeks();
            loadStats();
        }

        function getAllDates() {
            var now = new Date();

            vm.dateStart = DateUtils.getFirstDayOfPayrollPeriod(now);
            vm.dateEnd = DateUtils.getLastDayOfPayrollPeriod(now);
            vm.month = vm.dateStart;
            getWeeks();
        }

        function getWeeks() {
            var startDate = new Date(vm.dateStart);
            var endDate = new Date(vm.dateEnd);

            startDate.setHours(0,0,0,0);
            endDate.setHours(0,0,0,0);

            var weeks = {};
            var currentWeek = [];
            var weekCounter = 1;
            var d = new Date(startDate);

            while (d <= endDate) {
                if (d.getDay() !== 0) {
                    currentWeek.push(new Date(d));
                }
                if (d.getDay() === 6 || d.getTime() === endDate.getTime()) {
                    weeks['Semaine ' + weekCounter] = currentWeek;
                    currentWeek = [];
                    weekCounter++;
                }
                d.setDate(d.getDate() + 1);
            }
            vm.weeks = weeks;
        }

        function isEquipeInWeekRange(equipe, week) {
            var equipeStart = new Date(equipe.dateStart);

            for (var i = 0; i < week.length; i++) {
                var weekDate = new Date(week[i]);
                if (weekDate.toDateString() === equipeStart.toDateString()) {
                    return true;
                }
            }

            return false;
        }

        function formatDayFr(day) {
            var days = ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"];
            return days[day.getDay()];
        }

        function formatMonthFr(isoDateString) {
            var date = new Date(isoDateString);
            var options = { month: 'long' };
            return date.toLocaleString('fr-FR', options);
        }

        function formatDate(timestamp) {
            return $filter('date')(timestamp, 'yyyy-MM-dd');
        }

        function getAccount() {
            return Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated();
                Principal.hasAuthority('ROLE_ADMIN').then(function (isAdmin) {
                    vm.isAdmin = isAdmin;
                });
                return account;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ValorisationDialogController', ValorisationDialogController);

    ValorisationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'Valorisation', 'Technicien'];

    function ValorisationDialogController($timeout, $scope, $stateParams, $uibModalInstance, $uibModal, entity, Valorisation, Technicien) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.valorisation.technicien = $(this).val();
            });
        });
        var vm = this;
        vm.valorisation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.deleteValorisation = deleteValorisation;

        loadTechniciens();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.valorisation.id !== null) {
                Valorisation.update(vm.valorisation, onSaveSuccess, onSaveError);
            } else {
                Valorisation.save(vm.valorisation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tmgApp:valorisationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadTechniciens() {
        	Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function deleteValorisation(id) {
            $uibModal.open({
                templateUrl: 'entities/valorisation/valorisation-delete-dialog.html',
                controller: 'ValorisationDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Valorisation', function (Valorisation) {
                        return Valorisation.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                $uibModalInstance.close(true);
                $scope.go($state.current, {}, {reload: true});
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ValorisationDetailController', ValorisationDetailController);

    ValorisationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function ValorisationDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.valorisation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:valorisationUpdate', function(event, result) {
            vm.valorisation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ValorisationDeleteController',ValorisationDeleteController);

    ValorisationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Valorisation'];

    function ValorisationDeleteController($uibModalInstance, entity, Valorisation) {
        var vm = this;

        vm.valorisation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Valorisation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('valorisation', {
            parent: 'technicienMenu',
            url: '/valorisation?page&sort&technicien&date&type&annee&semaine',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.valorisation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/valorisation/valorisation.html',
                    controller: 'ValorisationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        technicien: $stateParams.technicien,
                        date: $stateParams.date,
                        type: $stateParams.type,
                        annee: $stateParams.annee,
                        semaine: $stateParams.semaine,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('valorisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('valorisation-detail', {
            parent: 'valorisation',
            url: '/valorisation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.valorisation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/valorisation/valorisation-detail.html',
                    controller: 'ValorisationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('valorisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Valorisation', function ($stateParams, Valorisation) {
                    return Valorisation.get({id: $stateParams.id}).$promise;
                }],
                previousState: ['$state', function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'valorisation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('valorisation.new', {
            parent: 'valorisation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valorisation/valorisation-dialog.html',
                    controller: 'ValorisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                technicien: null,
                                date: null,
                                commentary: null,
                                point: null,
                                type: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('valorisation', null, { reload: 'valorisation' });
                }, function() {
                    $state.go('valorisation');
                });
            }]
        })
        .state('valorisation.edit', {
            parent: 'valorisation',
            url: '{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valorisation/valorisation-dialog.html',
                    controller: 'ValorisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Valorisation', function(Valorisation) {
                            return Valorisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('valorisation', null, { reload: 'valorisation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('valorisation.delete', {
            parent: 'valorisation',
            url: '{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valorisation/valorisation-delete-dialog.html',
                    controller: 'ValorisationDeleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Valorisation', function(Valorisation) {
                            return Valorisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('valorisation', null, { reload: 'valorisation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .factory('Valorisation', Valorisation);

    Valorisation.$inject = ['$resource','DateUtils'];

    function Valorisation ($resource, DateUtils) {
        var resourceUrl =  'api/valorisations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                hasBody: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                hasBody: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    console.log(copy);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ValorisationController', ValorisationController);

    ValorisationController.$inject = ['$state', 'Valorisation', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ValorisationController($state, Valorisation, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.filterTechnicien = pagingParams.technicien;
        vm.filterType = pagingParams.type;
        vm.filterAnnee = pagingParams.annee;
        vm.filterSemaine = pagingParams.semaine;

        vm.techniciens = [];
        vm.typeDispo = ['PRIME_OBJECTIF', 'PRIME_REALISEE', 'STAT_TECHNICIEN'];
        vm.yearDispo = [];
        vm.semaineDispo = [];

        loadAll();
        loadTechniciens();
        createArrayOfYear();
        createArrayOfWeek();

        function loadAll() {
            Valorisation.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                type: vm.filterType,
                annee: vm.filterAnnee,
                semaine: vm.filterSemaine,
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.valorisations = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search() {
            vm.page = 1;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                technicien: vm.filterTechnicien,
                type: vm.filterType,
                annee: vm.filterAnnee,
                semaine: vm.filterSemaine,
            });
        }

        function loadTechniciens() {
            Technicien.technicienEnabledHistory({ }, function onSuccess(data) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function createArrayOfYear() {
            var currentDate = new Date();
            for (var i = 2020; i <= currentDate.getFullYear() + 1; i++) {
                vm.yearDispo.push(i);
            }
        }

        function createArrayOfWeek() {
            for (var i = 1; i <= 53; i++) {
                vm.semaineDispo.push(i);
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tmgsettings', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('technicienMenu', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('TechnicienDialogController', TechnicienDialogController);

    TechnicienDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Technicien'];

    function TechnicienDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Technicien) {
        var vm = this;

        vm.technicien = entity;
        if (vm.technicien && (vm.technicien.fleetDailySubstraction === null || vm.technicien.fleetDailySubstraction === undefined)) {
            vm.technicien.fleetDailySubstraction = 0.5;
        }
        vm.clear = clear;
        vm.save = save;
        vm.addAlias = addAlias;
        vm.removeAlias = removeAlias;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.technicien.id !== null) {
                Technicien.update(vm.technicien, onSaveSuccess, onSaveError);
            } else {
                Technicien.save(vm.technicien, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:technicienUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

         function addAlias() {
          	if(vm.technicien.aliases && vm.technicien.aliases.length>0){
          		if(vm.technicien.aliases[vm.technicien.aliases.length-1]!=''){
            		vm.technicien.aliases.push('');
            	}
            }else{
            	//Tableau vide
          		vm.technicien.aliases=[''];
          	}
        }

        function removeAlias(index){
         	vm.technicien.aliases.splice(index,1);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('TechnicienDetailController', TechnicienDetailController);

    TechnicienDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Technicien'];

    function TechnicienDetailController($scope, $rootScope, $stateParams, previousState, entity, Technicien) {
        var vm = this;

        vm.technicien = entity;
        vm.previousState = previousState.name;
        vm.verifyAliase = verifyAliase;

        var unsubscribe = $rootScope.$on('tmgApp:technicienUpdate', function(event, result) {
            vm.technicien = result;
        });
        $scope.$on('$destroy', unsubscribe);

         function verifyAliase() {
             Technicien.verifyAliase({id: entity.id}, function (s) {
                 console.log(s);
             }, function (error) {
                 AlertService.error(error.data.message);
             });
         }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('TechnicienDeleteController',TechnicienDeleteController);

    TechnicienDeleteController.$inject = ['$uibModalInstance', 'entity', 'Technicien'];

    function TechnicienDeleteController($uibModalInstance, entity, Technicien) {
        var vm = this;

        vm.technicien = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Technicien.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('technicien', {
            parent: 'gestion',
            url: '/technicien?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.technicien.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/technicien/techniciens.html',
                    controller: 'TechnicienController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('technicien');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('technicien-detail', {
            parent: 'technicien',
            url: '/technicien/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.technicien.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/technicien/technicien-detail.html',
                    controller: 'TechnicienDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('technicien');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Technicien', function($stateParams, Technicien) {
                    return Technicien.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'technicien',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('technicien-detail.edit', {
            parent: 'technicien-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-dialog.html',
                    controller: 'TechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Technicien', function(Technicien) {
                            return Technicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('technicien.new', {
            parent: 'technicien',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-dialog.html',
                    controller: 'TechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                displayname: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                enabled: false,
                                aliases: [''],
                                cost: null,
                                astreinteCost: null,
                                costDetail: null,
                                id: null,
                                planningEquipe: true
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('technicien', null, { reload: 'technicien' });
                }, function() {
                    $state.go('technicien');
                });
            }]
        })
        .state('technicien.edit', {
            parent: 'technicien',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-dialog.html',
                    controller: 'TechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Technicien', function(Technicien) {
                            return Technicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('technicien', null, { reload: 'technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('technicien.delete', {
            parent: 'technicien',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-delete-dialog.html',
                    controller: 'TechnicienDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Technicien', function(Technicien) {
                            return Technicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('technicien', null, { reload: 'technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Technicien', Technicien);

    Technicien.$inject = ['$resource', 'DateUtils'];

    function Technicien ($resource, DateUtils) {
        var resourceUrl =  'api/techniciens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'technicienEnabled': {
                method: 'GET',
                isArray: true,
                url: 'api/techniciens/enabled'
            },
            'technicienEnabledHistory': {
                method: 'GET',
                isArray: true,
                url: 'api/techniciens/history'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
                'verifyAliase' : {
                url: 'api/interventions/verifyAliases/:id',
                method : 'GET',
                hasBody: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAvailableForPlanning': {
                method: 'GET',
                url: 'api/availableTechniciensForPlanning',
                params: {
                    date: '@date',
                },
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAvailableTechByDatesForPlanning': {
                method: 'GET',
                url: 'api/availableTechByDatesForPlanning',
                params: {
                    dateStart: '@dateStart',
                    dateEnd: '@dateEnd'
                },
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].date = DateUtils.convertLocalDateFromServer(data[i].date);
                        }
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('TechnicienController', TechnicienController);

    TechnicienController.$inject = ['$state', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TechnicienController($state, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterSearch = pagingParams.search;
        loadAll();

        function loadAll () {
            Technicien.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                search: vm.filterSearch,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.techniciens = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search() {
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.filterSearch
            });
        }

        vm.reset = function(){
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: null
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stat-technicien', {
            parent: 'technicienMenu',
            url: '/stat-technicien?dateFrom&dateTo&technicien&comparaisonStatus',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.statTechnicien.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stat-technicien/stat-techniciens.html',
                    controller: 'StatTechnicienController',
                    controllerAs: 'vm'
                }
            },
            params: {
                dateFrom: null,
                dateTo: null,
                technicien: null,
                comparaisonStatus: []
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        dateFrom: $stateParams.dateFrom,
                        dateTo: $stateParams.dateTo,
                        technicien: $stateParams.technicien,
                        comparaisonStatus: Array.isArray($stateParams.comparaisonStatus) ? $stateParams.comparaisonStatus: [$stateParams.comparaisonStatus]
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('intervention');
                	$translatePartialLoader.addPart('statTechnicien');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('stat-technicien-detail', {
            parent: 'stat-technicien',
            url: '/stat-technicien/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.statTechnicien.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-detail.html',
                    controller: 'StatTechnicienDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statTechnicien');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'StatTechnicien', function($stateParams, StatTechnicien) {
                    return StatTechnicien.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'stat-technicien',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('stat-technicien-detail.edit', {
            parent: 'stat-technicien-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-dialog.html',
                    controller: 'StatTechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatTechnicien', function(StatTechnicien) {
                            return StatTechnicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stat-technicien.new', {
            parent: 'stat-technicien',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-dialog.html',
                    controller: 'StatTechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                code: null,
                                yearMonth: null,
                                qty: null,
                                price: null,
                                qtyBonus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('stat-technicien', null, { reload: 'stat-technicien' });
                }, function() {
                    $state.go('stat-technicien');
                });
            }]
        })
        .state('stat-technicien.edit', {
            parent: 'stat-technicien',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-dialog.html',
                    controller: 'StatTechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatTechnicien', function(StatTechnicien) {
                            return StatTechnicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stat-technicien', null, { reload: 'stat-technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stat-technicien.delete', {
            parent: 'stat-technicien',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-delete-dialog.html',
                    controller: 'StatTechnicienDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatTechnicien', function(StatTechnicien) {
                            return StatTechnicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stat-technicien', null, { reload: 'stat-technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('StatTechnicien', StatTechnicien);

    StatTechnicien.$inject = ['$resource'];

    function StatTechnicien ($resource) {
        var resourceUrl =  'api/stat-techniciens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('StatTechnicienController', StatTechnicienController);

    StatTechnicienController.$inject = ['$state','StatTechnicien','Technicien','$filter','pagingParams', 'Principal'];

    function StatTechnicienController($state, StatTechnicien,Technicien,$filter, pagingParams, Principal) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicien').on('select2:select', function (e) {
                vm.filterTechnicien = $('#filterTechnicien').val();
                vm.search();
            });
        });

        var vm = this;
        vm.isAdmin = false;

        Principal.identity().then(function(account) {
            if(account.authorities.indexOf("ROLE_ADMIN") === 1) {
                vm.isAdmin = true;
            }
        });

        vm.filterTechnicien = pagingParams.technicien;
        vm.statTechniciens = [];
        vm.filterComparaisonStatus = !pagingParams.comparaisonStatus ? ['CLOSE','CLOSE_MANUEL','CLOSE_NOT_FACTURABLE'] : pagingParams.comparaisonStatus;

        if (!pagingParams.dateFrom && !pagingParams.dateTo) {
            var date = new Date();
            changeDateMonth(date);
        }else {
            var date = new Date(pagingParams.dateFrom);
        }


        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.search=search;
        vm.transition = transition;
		vm.numberWithSpace = numberWithSpace;
        vm.getTotalPoints=getTotalPoints;
        vm.getTotalChiffre=getTotalChiffre;
        vm.filterDateTo = pagingParams.dateTo;
        vm.filterDateFrom = pagingParams.dateFrom;

        loadTechniciens();
        loadAll();

        function loadAll() {
            StatTechnicien.query({
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: vm.filterTechnicien,
                comparaisonStatus: vm.filterComparaisonStatus
            },onSuccess, onError);
        }
        function onSuccess(data, headers) {
            vm.statTechniciens = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

       function search(){
           transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: vm.filterTechnicien,
                comparaisonStatus: vm.filterComparaisonStatus
            });
        }

        function loadTechniciens(){
        	Technicien.technicienEnabledHistory ({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.previousMonth=function(){
            date.setMonth(date.getMonth()-1);
            changeDateMonth(date);

        }
        vm.nextMonth=function(){
            date.setMonth(date.getMonth()+1);
            changeDateMonth(date);
        }
        vm.previousDay=function (){
            date.setDate(date.getDate() - 1);
            var tmpDateTo = new Date(vm.filterDateTo);
            tmpDateTo.setDate(tmpDateTo.getDate() - 1);
            vm.filterDateFrom = $filter('date')(date,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(tmpDateTo,'yyyy-MM-dd');
            transition();
        }
        vm.nextDay=function (){
            date.setDate(date.getDate() + 1);
            var tmpDate = new Date(vm.filterDateTo);
            tmpDate.setDate(tmpDate.getDate() + 1);
            vm.filterDateFrom = $filter('date')(date,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(tmpDate,'yyyy-MM-dd');
            transition();
        }

        function changeDateMonth(date){
            var firstDayOfMonth=new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDayOfMonth=new Date(date.getFullYear(), date.getMonth()+1, 0);
            vm.filterDateFrom = $filter('date')(firstDayOfMonth,'yyyy-MM-dd');//pagingParams.dateFrom;
            vm.filterDateTo = $filter('date')(lastDayOfMonth,'yyyy-MM-dd');//pagingParams.dateTo;
            transition();
        }

        function getTotalPoints(){
        	var totalPoints=0;
        	if(vm.statTechniciens){
        		vm.statTechniciens.forEach(function(statTechnicien) {
        			if(statTechnicien.totalPoints){
        				totalPoints+=statTechnicien.totalPoints;
        			}
        		});
        	}
        	return totalPoints.toFixed(2);
        }

		function numberWithSpace(x) {
			if(x){
			    var parts = x.toString().split(".");
			    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
			    return parts.join(".");
			}else{
				return null;
			}
		}

		function getTotalChiffre(){
        	var totalChiffre=0;
        	if(vm.statTechniciens){
        		vm.statTechniciens.forEach(function(statTechnicien) {
        			if(statTechnicien.price){
        				totalChiffre+=statTechnicien.price;
        			}
        		});
        	}
        	return numberWithSpace(totalChiffre.toFixed(2));
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stat-facturation-mensuel', {
            parent: 'entity',
            url: '/stat-facturation-mensuel',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.statFacturationMensuel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stat-facturation-mensuel/stat-facturation-mensuels.html',
                    controller: 'StatFacturationMensuelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statFacturationMensuel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('StatFacturationMensuel', StatFacturationMensuel);

    StatFacturationMensuel.$inject = ['$resource', 'DateUtils'];

    function StatFacturationMensuel ($resource, DateUtils) {
        var resourceUrl =  'api/stat-facturation-mensuels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateStart = DateUtils.convertLocalDateFromServer(data.dateStart);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateStart = DateUtils.convertLocalDateToServer(copy.dateStart);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateStart = DateUtils.convertLocalDateToServer(copy.dateStart);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('StatFacturationMensuelController', StatFacturationMensuelController);

    StatFacturationMensuelController.$inject = ['StatFacturationMensuel','$filter'];

    function StatFacturationMensuelController(StatFacturationMensuel,$filter) {

        var vm = this;

        vm.statFacturationMensuels = [];
        
        var date = new Date();
    	changeDateMonth(date);
        
        vm.search = search;
        
        var date = new Date();
        var firstDayOfMonth=new Date(date.getFullYear(), date.getMonth(), 1);
        vm.filterDateFrom = $filter('date')(firstDayOfMonth,'yyyy-MM-dd');//pagingParams.dateFrom;
        vm.filterDateTo = null;//pagingParams.dateTo;


        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        
        loadAll();

        function loadAll() {
            StatFacturationMensuel.query({
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo
            },function(result) {
                vm.statFacturationMensuels = result;
                vm.searchQuery = null;
            });
        }
        
        function search(){
        	loadAll();
        }
        
        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        vm.previousMonth=function(){
        	date.setMonth(date.getMonth()-1);
        	changeDateMonth(date);
        }
        vm.nextMonth=function(){
        	date.setMonth(date.getMonth()+1);
        	changeDateMonth(date);
        }
        
        function changeDateMonth(date){
        	var firstDayOfMonth=new Date(date.getFullYear(), date.getMonth(), 1);
	        var lastDayOfMonth=new Date(date.getFullYear(), date.getMonth()+1, 0);
	        vm.filterDateFrom = $filter('date')(firstDayOfMonth,'yyyy-MM-dd');//pagingParams.dateFrom;
	        vm.filterDateTo = $filter('date')(lastDayOfMonth,'yyyy-MM-dd');//pagingParams.dateTo;
	        search();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SfrFileDialogController', SfrFileDialogController);

    SfrFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'SfrFile'];

    function SfrFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, SfrFile) {
        var vm = this;

        vm.sfrFile = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sfrFile.id !== null) {
                SfrFile.update(vm.sfrFile, onSaveSuccess, onSaveError);
            } else {
                SfrFile.save(vm.sfrFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:sfrFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        vm.setFile = function ($file, sfrFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                    	sfrFile.fileName = $file.name;
                        sfrFile.file = base64Data;
                        sfrFile.fileContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SfrFileDetailController', SfrFileDetailController);

    SfrFileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'SfrFile'];

    function SfrFileDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, SfrFile) {
        var vm = this;

        vm.sfrFile = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('tmgApp:sfrFileUpdate', function(event, result) {
            vm.sfrFile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SfrFileDeleteController',SfrFileDeleteController);

    SfrFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'SfrFile'];

    function SfrFileDeleteController($uibModalInstance, entity, SfrFile) {
        var vm = this;

        vm.sfrFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SfrFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sfr-file', {
            parent: 'import',
            url: '/sfr-file?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.sfrFile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sfr-file/sfr-files.html',
                    controller: 'SfrFileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sfrFile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sfr-file-detail', {
            parent: 'sfr-file',
            url: '/sfr-file/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.sfrFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sfr-file/sfr-file-detail.html',
                    controller: 'SfrFileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sfrFile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SfrFile', function($stateParams, SfrFile) {
                    return SfrFile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sfr-file',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sfr-file-detail.edit', {
            parent: 'sfr-file-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-dialog.html',
                    controller: 'SfrFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SfrFile', function(SfrFile) {
                            return SfrFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sfr-file.new', {
            parent: 'sfr-file',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-dialog.html',
                    controller: 'SfrFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: new Date(),
                                fileName: null,
                                file: null,
                                fileContentType: null,
                                nbInterventions: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sfr-file', null, { reload: 'sfr-file' });
                }, function() {
                    $state.go('sfr-file');
                });
            }]
        })
        .state('sfr-file.edit', {
            parent: 'sfr-file',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-dialog.html',
                    controller: 'SfrFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SfrFile', function(SfrFile) {
                            return SfrFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sfr-file', null, { reload: 'sfr-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sfr-file.delete', {
            parent: 'sfr-file',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sfr-file/sfr-file-delete-dialog.html',
                    controller: 'SfrFileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SfrFile', function(SfrFile) {
                            return SfrFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sfr-file', null, { reload: 'sfr-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('SfrFile', SfrFile);

    SfrFile.$inject = ['$resource', 'DateUtils'];

    function SfrFile ($resource, DateUtils) {
        var resourceUrl =  'api/sfr-files/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'process': { 
            	url:'api/sfr-files/:id/process',
            	method: 'PUT',
            	hasBody:false
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SfrFileController', SfrFileController);

    SfrFileController.$inject = ['$state', 'DataUtils', 'SfrFile', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SfrFileController($state, DataUtils, SfrFile, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.process = process;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            SfrFile.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sfrFiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function process(id){
        	SfrFile.process({id:id},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('resultat-technicien', {
                url: '/resultat-technicien?technicien&type&dateFrom&dateTo',
                parent: 'gestion',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Resultat technicien'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/resultat-technicien/resultat-technicien.html',
                        controller: 'ResultatTechnicienController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    dateFrom: null,
                    dateTo: null,
                    technicien: null,
                    type: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            dateFrom: $stateParams.dateFrom,
                            dateTo: $stateParams.dateTo,
                            technicien: $stateParams.technicien,
                            type: $stateParams.type,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('ResultatTechnicien', ResultatTechnicien);

    ResultatTechnicien.$inject = ['$resource', 'DateUtils'];

    function ResultatTechnicien ($resource, DateUtils) {
        var resourceUrl =  'api/resultat-technicien/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ResultatTechnicienController', ResultatTechnicienController);

    ResultatTechnicienController.$inject = ['$state', 'ParseLinks', 'AlertService', 'pagingParams', '$filter', 'paginationConstants', 'ResultatTechnicien', 'Technicien', 'DateUtils', 'ChargeTechnicien', 'Config'];

    function ResultatTechnicienController($state, ParseLinks, AlertService, pagingParams, $filter, paginationConstants, ResultatTechnicien, Technicien, DateUtils, ChargeTechnicien, Config) {
        var vm = this;

        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.filterTechnicien = pagingParams.technicien;
        vm.filterType = pagingParams.type;
        vm.filterDateTo = new Date(pagingParams.dateTo);
        vm.filterDateFrom = new Date(pagingParams.dateFrom);

        vm.getTotal = getTotal;
        vm.getCATotal = getCATotal;
        vm.getChargeTotal = getChargeTotal;
        vm.search = search;
        vm.addChargePreviousMonth = addChargePreviousMonth;
        vm.transition = transition;
        vm.reportChargeBtnDisable = false;

        DateUtils.loadCutoffDay().then(function () {
            if (!pagingParams.dateFrom && !pagingParams.dateTo) {
                getAllDates();
            }
            loadAll();
            loadTechniciens();
            getLastMonthChargeReportDate();
        });

        function loadAll() {
            vm.filterType = vm.filterType === "" ? null : vm.filterType;
            // Format local (pas toISOString/UTC) : un Date à minuit local serait
            // converti a la veille en UTC+2 et la plage chevaucherait 2 periodes de paie.
            ResultatTechnicien.query({
                dateFrom: $filter('date')(vm.filterDateFrom, 'yyyy-MM-dd'),
                dateTo: $filter('date')(vm.filterDateTo, 'yyyy-MM-dd'),
                technicien: vm.filterTechnicien,
                type: vm.filterType,
                civilMonth: true
            },onSuccess, onError);
        }

        function addChargePreviousMonth() {
            ChargeTechnicien.addChargePreviousMonth({}, function onSuccess(data, headers) {
                getLastMonthChargeReportDate();
                loadAll();
                AlertService.success("Charges ajoutées avec succès");
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function getLastMonthChargeReportDate() {
            Config.getByName({name: 'date_dernier_mois_creation_charge'}, function onSuccess(data, headers) {
                var dateString = data.value;
                var parts = dateString.split("-");
                var date = new Date(parts[0], parts[1] - 1, parts[2]);
                vm.lastMonthChargeReportDate = date;
                adaptReportChargeBtn();
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory ({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function onSuccess(data, headers) {
            vm.resultatTechniciens = data;
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getTotal(){
            var total=0;
            if(vm.resultatTechniciens){
                vm.resultatTechniciens.forEach(function(resultat) {
                    if(resultat.price){
                        total+=resultat.price;
                    }
                });
            }
            return numberWithSpace(total.toFixed(2));
        }

        function adaptReportChargeBtn() {
            var now = new Date();
            var firstDayOfPeriod = DateUtils.getFirstDayOfPayrollPeriod(now);
            var lastDayOfPeriod = DateUtils.getLastDayOfPayrollPeriod(now);
            lastDayOfPeriod.setHours(23,59,59,999);

            if (firstDayOfPeriod <= vm.lastMonthChargeReportDate && vm.lastMonthChargeReportDate <= lastDayOfPeriod) {
                vm.reportChargeBtnDisable = true;
            } else {
                vm.reportChargeBtnDisable = false;
            }
        }

        function getCATotal(){
            var ca=0;
            if(vm.resultatTechniciens){
                vm.resultatTechniciens.forEach(function(resultat) {
                    if(resultat.price && resultat.price > 0){
                        ca+=resultat.price;
                    }
                });
            }
            return numberWithSpace(ca.toFixed(2));
        }

        function getChargeTotal(){
            var charge=0;
            if(vm.resultatTechniciens){
                vm.resultatTechniciens.forEach(function(resultat) {
                    if(resultat.price && resultat.price < 0){
                        charge+=resultat.price;
                    }
                });
            }
            return numberWithSpace(charge.toFixed(2));
        }

        function numberWithSpace(x) {
            if(x){
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            }else{
                return null;
            }
        }

        function getAllDates() {
            var now = new Date();
            vm.filterDateFrom = DateUtils.getFirstDayOfPayrollPeriod(now);
            vm.filterDateTo = DateUtils.getLastDayOfPayrollPeriod(now);
        }

        vm.previousMonth=function(){
            var next = new Date(vm.filterDateFrom.getFullYear(), vm.filterDateFrom.getMonth() + 1, 1);
            vm.filterDateFrom = DateUtils.getFirstDayOfPayrollPeriod(next);
            vm.filterDateTo = DateUtils.getLastDayOfPayrollPeriod(next);
            vm.filterDateFrom = $filter('date')(vm.filterDateFrom,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(vm.filterDateTo,'yyyy-MM-dd');
            transition();
        }

        vm.nextMonth=function(){
            var next = new Date(vm.filterDateFrom.getFullYear(), vm.filterDateFrom.getMonth() + 1, 1);
            vm.filterDateFrom = DateUtils.getFirstDayOfPayrollPeriod(next);
            vm.filterDateTo = DateUtils.getLastDayOfPayrollPeriod(next);
            vm.filterDateFrom = $filter('date')(vm.filterDateFrom,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(vm.filterDateTo,'yyyy-MM-dd');
            transition();
        }

        vm.previousDay=function (){
            var date = new Date(vm.filterDateFrom);
            date.setDate(date.getDate() - 1);
            var tmpDateTo = new Date(vm.filterDateTo);
            tmpDateTo.setDate(tmpDateTo.getDate() - 1);
            vm.filterDateFrom = $filter('date')(date,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(tmpDateTo,'yyyy-MM-dd');
            transition();
        }

        vm.nextDay=function (){
            var date = new Date(vm.filterDateFrom);
            date.setDate(date.getDate() + 1);
            var tmpDate = new Date(vm.filterDateTo);
            tmpDate.setDate(tmpDate.getDate() + 1);
            vm.filterDateFrom = $filter('date')(date,'yyyy-MM-dd');
            vm.filterDateTo = $filter('date')(tmpDate,'yyyy-MM-dd');
            transition();
        }

        function search(){
            transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: vm.filterTechnicien,
                type: vm.filterType,
            });
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PointDialogController', PointDialogController);

    PointDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Point'];

    function PointDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Point) {
        var vm = this;

        vm.point = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.point.id !== null) {
                Point.update(vm.point, onSaveSuccess, onSaveError);
            } else {
                Point.save(vm.point, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:pointUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PointDetailController', PointDetailController);

    PointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Point', 'AlertService'];

    function PointDetailController($scope, $rootScope, $stateParams, previousState, entity, Point, AlertService) {
        var vm = this;

        vm.point = entity;
        vm.previousState = previousState.name;
        vm.adaptInterventions = adaptInterventions;

        var unsubscribe = $rootScope.$on('tmgApp:pointUpdate', function(event, result) {
            vm.point = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function adaptInterventions() {
            Point.adaptInterventions({id: vm.point.id}, function onSuccess() {
            }, function onError(error) {
                AlertService.error('Erreur lors de l\'adaptation des interventions: ' + error.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PointDeleteController',PointDeleteController);

    PointDeleteController.$inject = ['$uibModalInstance', 'entity', 'Point'];

    function PointDeleteController($uibModalInstance, entity, Point) {
        var vm = this;

        vm.point = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Point.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('point', {
            parent: 'gestion',
            url: '/point?page&sort&search&category&activity',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.point.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/point/points.html',
                    controller: 'PointController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                category: null,
                activity: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        category: $stateParams.category,
                        activity: $stateParams.activity
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('point');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('point-detail', {
            parent: 'point',
            url: '/point/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.point.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/point/point-detail.html',
                    controller: 'PointDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('point');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Point', function($stateParams, Point) {
                    return Point.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'point',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('point-detail.edit', {
            parent: 'point-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/point/point-dialog.html',
                    controller: 'PointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Point', function(Point) {
                            return Point.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('point.new', {
            parent: 'point',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/point/point-dialog.html',
                    controller: 'PointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                activity: null,
                                pointChefMonome: null,
                                pointChefBinome: null,
                                pointTechnicien: null,
                                averagePrice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('point', null, { reload: 'point' });
                }, function() {
                    $state.go('point');
                });
            }]
        })
        .state('point.edit', {
            parent: 'point',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/point/point-dialog.html',
                    controller: 'PointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Point', function(Point) {
                            return Point.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('point', null, { reload: 'point' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('point.delete', {
            parent: 'point',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/point/point-delete-dialog.html',
                    controller: 'PointDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Point', function(Point) {
                            return Point.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('point', null, { reload: 'point' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Point', Point);

    Point.$inject = ['$resource'];

    function Point ($resource) {
        var resourceUrl =  'api/points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
            ,'multiple': {
            	url:'api/points/multiple',
            	method: 'POST'
            },
            'categories': {
            	url:'api/points/categories',
            	isArray: true,
            	method: 'GET'
            },
            'categoryTMG': {
            	url:'api/points/categoryTMG',
            	isArray: true,
            	method: 'GET'
            },
            'export': {
                url:'api/points/export',
                isArray: true,
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'adaptInterventions': {
                url:'api/points/:id/regex/adaptInterventions',
                method: 'POST',
                params: {id: '@id'}
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PointController', PointController);

    PointController.$inject = ['$state', 'Point', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PointController($state, Point, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.importMultiple = importMultiple;
        vm.export = exportData;
        vm.showDerivedPoints = false;
        vm.filterCategory=pagingParams.category;
        vm.filterActivity=pagingParams.activity;

        vm.categories=[];

        loadAll();

        function loadAll () {
            Point.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                category: vm.filterCategory,
                activity: vm.filterActivity
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.points = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
            Point.categories(function(data){
            	vm.categories=data;
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                category : vm.filterCategory,
                activity: vm.filterActivity
            });
        }

        function importMultiple() {
        	var jsonPoints = prompt("Please enter json", "{}");

        	if (jsonPoints != null) {
        	    var points=JSON.parse(jsonPoints);
        	    Point.multiple(points,function(){
        	    	loadAll();
        	    });
        	}
        }

        function exportData() {
            Point.export(onSuccess);

            function onSuccess(data) {
                delete data.$promise;
                delete data.$resolved;
                download("export.json",JSON.stringify(data));
            }
        }

        function download(filename, text) {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        }

        vm.search=transition;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PaieDialogController', PaieDialogController);

    PaieDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Paie'];

    function PaieDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Paie) {
        var vm = this;

        vm.paie = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paie.id !== null) {
                Paie.update(vm.paie, onSaveSuccess, onSaveError);
            } else {
                Paie.save(vm.paie, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:paieUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError (result) {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.month = false;
        vm.datePickerOpenStatus.monthPrime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PaieDetailController', PaieDetailController);

    PaieDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Paie'];

    function PaieDetailController($scope, $rootScope, $stateParams, previousState, paieResponseDTO, Paie) {
        var vm = this;

        vm.paie = paieResponseDTO.paie;
        vm.conges = paieResponseDTO.conges;
        vm.astreintes = paieResponseDTO.astreintes;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:paieUpdate', function(event, result) {
            vm.paie = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PaieDeleteController',PaieDeleteController);

    PaieDeleteController.$inject = ['$uibModalInstance', 'entity', 'Paie'];

    function PaieDeleteController($uibModalInstance, entity, Paie) {
        var vm = this;

        vm.paie = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Paie.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('paie', {
            parent: 'gestion',
            url: '/paie?page&sort&search&technicien&datePaie&datePrime',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.paie.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paie/paies.html',
                    controller: 'PaieController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                technicien: null,
                datePaie: null,
                datePrime: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        technicien: $stateParams.technicien,
                        datePaie: $stateParams.datePaie,
                        datePrime: $stateParams.datePrime,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paie');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('paie-detail', {
            parent: 'paie',
            url: '/paie/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.paie.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/paie/paie-detail.html',
                    controller: 'PaieDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('paie');
                    $translatePartialLoader.addPart('conges');
                    $translatePartialLoader.addPart('astreinte');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Paie', function($stateParams, Paie) {
                    return Paie.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'paie',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('paie-detail.edit', {
            parent: 'paie-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-dialog.html',
                    controller: 'PaieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Paie', function(Paie) {
                            return Paie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paie.new', {
            parent: 'paie',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-dialog.html',
                    controller: 'PaieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                month: null,
                                technicien: null,
                                activity: null,
                                pointChefMonome: null,
                                pointChefBinome: null,
                                pointSupportBinome: null,
                                monthPrime: null,
                                totalPoint: null,
                                primeRendement: null,
                                primeExceptionnelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('paie', null, { reload: 'paie' });
                }, function() {
                    $state.go('paie');
                });
            }]
        })
        .state('paie.edit', {
            parent: 'paie',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-dialog.html',
                    controller: 'PaieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Paie', function(Paie) {
                            return Paie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paie', null, { reload: 'paie' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('paie.delete', {
            parent: 'paie',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/paie/paie-delete-dialog.html',
                    controller: 'PaieDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Paie', function(Paie) {
                            return Paie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('paie', null, { reload: 'paie' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Paie', Paie);

    Paie.$inject = ['$resource', 'DateUtils'];

    function Paie ($resource, DateUtils) {
        var resourceUrl =  'api/paies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.month = DateUtils.convertLocalDateFromServer(data.month);
                        data.monthPrime = DateUtils.convertLocalDateFromServer(data.monthPrime);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.month = DateUtils.convertLocalDateToServer(copy.month);
                    copy.monthPrime = DateUtils.convertLocalDateToServer(copy.monthPrime);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.month = DateUtils.convertLocalDateToServer(copy.month);
                    copy.monthPrime = DateUtils.convertLocalDateToServer(copy.monthPrime);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PaieController', PaieController);

    PaieController.$inject = ['$state', 'Paie', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PaieController($state, Paie, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicien').on('select2:select', function (e) {
                vm.filterTechnicien = $('#filterTechnicien').val();
                vm.search();
            });
        });

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filterDatePaie = pagingParams.datePaie;
        vm.filterDatePrime = pagingParams.datePrime;
        vm.filterTechnicien = pagingParams.technicien;

        vm.search = search;
        vm.techniciens = pagingParams.techniciens;

        vm.datePickers = {};
        vm.openCalendar = openCalendar;

        loadAll();
        loadTechniciens();

        function loadAll () {
            Paie.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                datePrime: vm.filterDatePrime,
                datePaie: vm.filterDatePaie
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.paies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadTechniciens(){
        	Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function openCalendar (date) {
            vm.datePickers[date] = true;
        }


        function search(){
        	vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                technicien: vm.filterTechnicien,
                datePaie: vm.filterDatePaie,
                datePrime: vm.filterDatePrime
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('OutilDialogController', OutilDialogController);

    OutilDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Outil', 'Config', 'Technicien'];

    function OutilDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Outil, Config, Technicien) {
        var vm = this;

        vm.outil = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;
        vm.monthlyToDailyPrice = monthlyToDailyPrice;
        vm.dailyToMonthlyPrice = dailyToMonthlyPrice;
        vm.loadTechniciens = loadTechniciens;

        getConfig();
        loadTechniciens();

        vm.newOutil = null;

        function save() {
            vm.isSaving = true;
            vm.outil.technicien = vm.outil.technicien === "" ? null : vm.outil.technicien;
            if (vm.outil.id !== null){
                Outil.update(vm.outil, onSaveSuccess, onSaveError);
            } else {
                Outil.save(vm.outil, onSaveSuccess, onSaveError);
            }
        }

        function loadTechniciens(){
            Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function monthlyToDailyPrice() {
            if(vm.outil.monthlyPrice){
                vm.outil.dailyPrice = parseFloat((vm.outil.monthlyPrice * vm.configRatioMensuelJournalier).toFixed(2));
            }
        }

        function dailyToMonthlyPrice() {
            if(vm.outil.dailyPrice){
                vm.outil.monthlyPrice = parseFloat((vm.outil.dailyPrice / vm.configRatioMensuelJournalier).toFixed(2));
            }
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getConfig() {
            Config.getByName({name: "ratio_mensuel_journalier"}, onSuccess, onError);
            function onSuccess(data) {
                vm.configRatioMensuelJournalier = +data.value;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('OutilDetailController', OutilDetailController);

    OutilDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Outil'];

    function OutilDetailController($scope, $rootScope, $stateParams, previousState, entity, Outil) {
        var vm = this;

        vm.outil = entity;
        vm.previousState = previousState.name;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('OutilDeleteController',OutilDeleteController);

    OutilDeleteController.$inject = ['$uibModalInstance', 'entity', 'Outil'];

    function OutilDeleteController($uibModalInstance, entity, Outil) {
        var vm = this;

        vm.outil = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Outil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outil', {
                url: '/outil',
                parent: 'gestion',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Outil'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/outil/outil.html',
                        controller: 'OutilController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('outil.new', {
                parent: 'outil',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/outil/outil-dialog.html',
                        controller: 'OutilDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    name: null,
                                    code: null,
                                    description: null,
                                    monthlyPrice: null,
                                    dailyPrice: null,
                                    enabled: true,
                                    technicien: null,
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('outil', null, { reload: 'outil' });
                    }, function() {
                        $state.go('outil');
                    });
                }]
            })
            .state('outil.edit', {
                parent: 'outil',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/outil/outil-dialog.html',
                        controller: 'OutilDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Outil', function(Outil) {
                                return Outil.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('outil', null, { reload: 'outil' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('outil-detail', {
                parent: 'outil',
                url: '/outil/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    // pageTitle: 'tmgApp.groupePlanning.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/outil/outil-detail.html',
                        controller: 'OutilDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Outil', function($stateParams, Outil) {
                        return Outil.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'outil',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('outil.delete', {
                parent: 'outil',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/outil/outil-delete-dialog.html',
                        controller: 'OutilDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Outil', function(Outil) {
                                return Outil.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('outil', null, { reload: 'outil' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Outil', Outil);

    Outil.$inject = ['$resource', 'DateUtils'];

    function Outil ($resource, DateUtils) {
        var resourceUrl =  'api/outil/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'getEnabled': {
                method: 'GET',
                isArray: true,
                url: resourceUrl + '/get-enabled'
            },
            'update': { method:'PUT' }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('OutilController', OutilController);

    OutilController.$inject = ['$state', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'Outil'];

    function OutilController($state, ParseLinks, AlertService, pagingParams, paginationConstants, Outil) {
        var vm = this;

        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.transition = transition;

        loadAll();

        function loadAll () {
            Outil.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),];
                result.push('id');
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.outils = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionRegulDialogController', InterventionRegulDialogController);

    InterventionRegulDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'activityCode', 'Intervention', 'ChargeTechnicien', 'Point'];

    function InterventionRegulDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, activityCode, Intervention, ChargeTechnicien, Point) {
        var vm = this;

        vm.intervention = entity;
        vm.activityCode = activityCode;
        vm.qty = 1;
        vm.newPoint = null;
        vm.clear = clear;
        vm.regulCharge = regulCharge;
        vm.getActivity = getActivity;

        loadPoints();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function getActivity() {
            for (var i = 0; i < vm.intervention.activities.length; i++) {
                if (vm.intervention.activities[i].code === vm.activityCode) {
                    return vm.intervention.activities[i];
                }
            }
        }

        function loadPoints(){
            Point.categoryTMG({ }, function onSuccess(data, headers) {
                vm.pointsTMG = data;
            });
        }

        function regulCharge() {
            vm.isSaving = true

            var regulRequest = {
                interventionId: vm.intervention.id,
                activity: getActivity(),
                qty: vm.qty,
                newActivityCode: vm.newPoint
            }

            ChargeTechnicien.regulChargeForActivity(regulRequest, onSuccess, onError);
        }

        function onSuccess () {
            $uibModalInstance.close();
            vm.isSaving = false;
        }

        function onError (error) {
            AlertService.error(error.data.message);
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionDialogController', InterventionDialogController);

    InterventionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Intervention', 'Technicien', 'Point'];

    function InterventionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Intervention, Technicien, Point) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.newTech = $('#field_technicien :selected').val();
            });
        });
        var vm = this;

        vm.intervention = entity;
        vm.bonus = {
            point:null,
            qty:1
        };
        vm.customFormError = true
        vm.isSaving = false;
        vm.pointsTMG = [];
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.addTech = addTech;
        vm.removeTech = removeTech;
        vm.addBonus = addBonus;
        vm.removeBonus = removeBonus;

        loadTechniciens();
        loadPoints();
        adaptCustomFormError();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if(vm.intervention.equipes.length <= 2 && vm.intervention.equipes.length > 0){
                vm.intervention.technicien = vm.intervention.equipes[0];
            }
            vm.isSaving = true;
            if (vm.intervention.id !== null) {
                Intervention.update(vm.intervention, onSaveSuccess, onSaveError);
            } else {
                Intervention.save(vm.intervention, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:interventionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadPoints(){
            Point.categoryTMG({ }, function onSuccess(data, headers) {
                vm.pointsTMG = data;
            });
        }

        function addTech() {
            if(vm.intervention.equipes == null){
                vm.intervention.equipes = [];
            }

            //verifie si le technicien a déjà été ajouté
            if (vm.intervention.equipes.indexOf(vm.newTech) === -1) {
                vm.intervention.equipes.push(vm.newTech);
                vm.intervention.tailleEquipe = vm.intervention.equipes.length;
                adaptCustomFormError();
            }
        }

        function addBonus() {
            if (vm.intervention.activities == null){
                vm.intervention.activities = [];
            }

            var newAct = {};
            newAct.code = vm.bonus.point;
            newAct.qty = vm.bonus.qty;

            vm.intervention.activities.push(newAct);
            adaptCustomFormError();
        }

        function adaptCustomFormError() {
            vm.customFormError = !(vm.intervention.tailleEquipe > 0 && vm.intervention.activities && vm.intervention.activities.length > 0);
        }

        function removeTech(technicien) {
            var index = vm.intervention.equipes.indexOf(technicien);
            if (index !== -1) {
                vm.intervention.equipes.splice(index, 1);
                vm.intervention.tailleEquipe = vm.intervention.equipes.length;
                adaptCustomFormError();
            }
        }

        function removeBonus(bonus){
            var index = vm.intervention.activities.indexOf(bonus);
            if (index !== -1) {
                vm.intervention.activities.splice(index, 1);
                adaptCustomFormError();
            }
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionDetailController', InterventionDetailController);

    InterventionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Intervention', 'AlertService','$state','Technicien', 'Principal','Point', 'ChargeTechnicien', 'DateUtils'];

    function InterventionDetailController($scope, $rootScope, $stateParams, previousState, entity, Intervention, AlertService, $state,Technicien, Principal, Point, ChargeTechnicien, DateUtils) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.newTech = $('#field_technicien :selected').val();
            });
        });
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.bonus = {
			point:null,
			qty:1
		};
        vm.intervention = entity;
        vm.previousState = previousState.name;
        vm.manualClose = manualClose;
        vm.facturationFight = facturationFight;
        vm.removeTech = removeTech;
        vm.checkIfCanDelete = checkIfCanDelete;
        vm.removeCommentary = removeCommentary;
        vm.addBonDeCommande = addBonDeCommande;
        vm.removeBonDeCommande = removeBonDeCommande;
        vm.newTech= null;
        vm.newCharge = null;
        vm.editedTechPercentage = null;
        vm.newBonDeCommande = null;
        vm.newBonDeCommandeComment = null;
        vm.getBonDeCommandeComment = getBonDeCommandeComment;
        vm.pointsTMG = [];

        vm.addTech = addTech;
        vm.addBonus = addBonus;
        vm.addCharge = addCharge;
        vm.removeCharge = removeCharge;
        vm.removeBonus = removeBonus;
        vm.manualClose = manualClose;
        vm.removeTech = removeTech;
        vm.changeFactureForActivity = changeFactureForActivity;
        vm.changeCaTechnicienForActivity = changeCaTechnicienForActivity;
        vm.getPrixMoyenTechnicien = getPrixMoyenTechnicien;
        vm.isAdmin = false;
		vm.editDate = false;
        vm.editTechPercentage = false;
        vm.techPercentageError = false;

        vm.toggleEditTechPercentage = toggleEditTechPercentage;
        vm.saveAllPercentages = saveAllPercentages;
        vm.openCalendar = openCalendar;
		vm.saveNewDate = saveNewDate;
        vm.isInMonthRange = isInMonthRange;
        vm.isDateFuture = isDateFuture;

        Principal.identity().then(function(account) {
            if(account.authorities.indexOf("ROLE_ADMIN") === 1) {
                vm.isAdmin = true;
            }
        });

        var unsubscribe = $rootScope.$on('tmgApp:interventionUpdate', function(event, result) {
            vm.intervention = result;
        });
        $scope.$on('$destroy', unsubscribe);


        getAllDates();
        loadTechniciens();
        loadPoints();
        loadCharges();

        function isInMonthRange() {
            var d = new Date(vm.intervention.date);
            var start = new Date(vm.dateStart);
            var end = new Date(vm.dateEnd);

            start.setHours(0,0,0,0);
            end.setHours(23,59,59,999);
            d.setHours(12,0,0,0);

            return d >= start && d <= end;
        }

        function removeTech(technicien) {
            Intervention.removeTech({id: vm.intervention.id,tech: technicien},onSuccess, onError);
        }

        function removeCommentary(commentary) {
            Intervention.removeCommentary({id: vm.intervention.id,commentary: commentary},onSuccess, onError);
        }

        function addBonDeCommande() {
            Intervention.addBonDeCommande({id: vm.intervention.id, bonDeCommande: vm.newBonDeCommande, commentaire: vm.newBonDeCommandeComment}, onSuccess, onError);
        }

        function getBonDeCommandeComment(intervention, bonDeCommande) {
            if (!intervention || !intervention.listCommentary || !intervention.listCommentary.length) {
                return null;
            }
            var needle = "Bon de commande " + bonDeCommande;
            for (var i = intervention.listCommentary.length - 1; i >= 0; i--) {
                var c = intervention.listCommentary[i];
                if (c && c.indexOf(needle) !== -1) {
                    return c;
                }
            }
            return null;
        }

        function removeBonDeCommande(bonDeCommande){
            Intervention.removeBonDeCommande({id: vm.intervention.id, bonDeCommande: bonDeCommande},onSuccess, onError);
        }

        function changeFactureForActivity(activity){
            if(!vm.isSaving){
                vm.isSaving = true
                Intervention.changeActivityFacture({id: vm.intervention.id, activityCode: activity.code},onSuccess, onError);
            }
        }

        function changeCaTechnicienForActivity(activity){
            if(!vm.isSaving){
                vm.isSaving = true
                Intervention.changeActivityCaTechnicien({id: vm.intervention.id, activityCode: activity.code},onSuccess, onError);
            }
        }

        function getPrixMoyenTechnicien(activity) {
            if (!activity || !activity.point || !activity.point.averagePrice) {
                return 0;
            }
            var qty = activity.qty ? activity.qty : 1;
            return activity.point.averagePrice * qty;
        }

        function onSuccess() {
            vm.isSaving = false
            $state.go($state.current, {}, {reload: true});
        }
        function onError(error) {
            vm.isSaving = false
            AlertService.error(error.data.message);
            $state.go($state.current, {}, {reload: true});
        }

        function manualClose(id){
        	Intervention.manualClose({id:id},function(s){
        		vm.intervention.typeIntervention='MANUAL_CLOSE';
        		vm.intervention.comparaisonStatus='MANUAL_CLOSE';
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function facturationFight(id) {
            Intervention.facturationFight({id: id}, function(s){
                vm.intervention.comparaisonStatus="FACTURATION_FIGHT";
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function addTech() {
            if (vm.newTech !== undefined && vm.newTech !== null) {
                Intervention.addTech({id: vm.intervention.id,tech: vm.newTech},onSuccess, onError);
            }
        }

        function addBonus() {
            Intervention.addActivity({interventionId: vm.intervention.id, activityCode: vm.bonus.point, qty: vm.bonus.qty},onSuccess, onError);
        }

        function removeBonus(bonus) {
            Intervention.removeActivity({id: vm.intervention.id,code: bonus.code},onSuccess, onError);
        }

        function addCharge() {
            vm.newCharge.intervention = vm.intervention.id;
            vm.newCharge.techniciens = vm.intervention.equipes;
            var dateInter = new Date(vm.intervention.date);
            vm.newCharge.date = new Date(dateInter.getFullYear(), dateInter.getMonth() + 1, 1);
            ChargeTechnicien.save(vm.newCharge, onSuccess, onError);
        }

        function removeCharge(charge) {
            ChargeTechnicien.delete({id: charge.id}, onSuccess, onError);
        }

        function checkIfCanDelete() {
            return vm.intervention.equipes.length > 1;
        }

        function getAllDates() {
            var now = new Date();
            vm.dateStart = DateUtils.getFirstDayOfCivilMonth(now);
            vm.dateEnd = DateUtils.getLastDayOfCivilMonth(now);
        }

        function isDateFuture(date) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var inputDate = new Date(date);
            inputDate.setHours(0, 0, 0, 0);
            return inputDate > today;
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadCharges() {
            ChargeTechnicien.getByIntervention({ interventionId: vm.intervention.id }, function onSuccess(data, headers) {
                vm.chargesTechnicien = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadPoints(){
            Point.categoryTMG({ }, function onSuccess(data, headers) {
                vm.pointsTMG = data;
            });
        }

        function saveAllPercentages() {
            var totalPercentage = 0;

            vm.intervention.techniciens.forEach(function(technicienIntervention) {
                totalPercentage += technicienIntervention.percentage;
            });

            if (totalPercentage !== 100) {
                vm.techPercentageError = true;
            }else {
                vm.techPercentageError = false;
                Intervention.updateTechPercentages({id: vm.intervention.id}, vm.intervention.techniciens, onSuccess, onError);
            }
        };

        function toggleEditTechPercentage() {
            vm.editTechPercentage = !vm.editTechPercentage;
        };

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

		function saveNewDate() {

            var newDate = moment(vm.intervention.date).format('YYYY-MM-DD')
			Intervention.changeDate({id: vm.intervention.id,date: newDate},onSuccess, onError);
		}

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionDeleteController',InterventionDeleteController);

    InterventionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Intervention'];

    function InterventionDeleteController($uibModalInstance, entity, Intervention) {
        var vm = this;

        vm.intervention = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Intervention.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionCommentaryDialogController', InterventionCommentaryDialogController);

    InterventionCommentaryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Intervention'];

    function InterventionCommentaryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Intervention) {
        var vm = this;

        vm.intervention = entity;
        vm.listCommentary = null;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.intervention.id !== null) {
                Intervention.addCommentary({id: vm.intervention.id, commentary: vm.listCommentary}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:intervention-detail({id:'+ vm.intervention.id + '})', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('intervention', {
            parent: 'technicienMenu',
            url: '/intervention?page&sort&search&status&comparaisonStatus&dateFrom&dateTo&technicien&technicienEquipe&technicienRole&tailleEquipe&constructelFilename&dateMailImport&filename&bonDeCommande',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.intervention.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/intervention/interventions.html',
                    controller: 'InterventionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null,
                status: null,
                comparaisonStatus: null,
                dateFrom: null,
                dateTo: null,
                technicien: null,
                technicienEquipe: null,
                tailleEquipe: null,
				technicienRole: null,
                constructelFilename: null,
                dateMailImport:null,
                filename: null,
                bonDeCommande: null,
                excludeBonDeCommande: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        status: $stateParams.status,
                        comparaisonStatus: $stateParams.comparaisonStatus,
                        dateFrom: $stateParams.dateFrom,
                        dateTo: $stateParams.dateTo,
                        technicien: $stateParams.technicien,
                        technicienEquipe: $stateParams.technicienEquipe,
						technicienRole: $stateParams.technicienRole,
                        tailleEquipe: $stateParams.tailleEquipe,
                        constructelFilename: $stateParams.constructelFilename,
                        dateMailImport: $stateParams.dateMailImport,
                        filename: $stateParams.filename,
                        bonDeCommande: $stateParams.bonDeCommande,
                        excludeBonDeCommande: $stateParams.excludeBonDeCommande
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intervention');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('intervention-detail', {
            parent: 'intervention',
            url: '/intervention/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.intervention.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/intervention/intervention-detail.html',
                    controller: 'InterventionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intervention');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Intervention', function($stateParams, Intervention) {
                    return Intervention.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'intervention',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('intervention-detail.edit', {
            parent: 'intervention-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intervention/intervention-dialog.html',
                    controller: 'InterventionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xl',
                    windowClass: 'modal-xl',
                    resolve: {
                        entity: ['Intervention', function(Intervention) {
                            return Intervention.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intervention-detail.commentary', {
            parent: 'intervention-detail',
            url: '/detail/commentary',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intervention/intervention-commentary-dialog.html',
                    controller: 'InterventionCommentaryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Intervention', function(Intervention) {
                            return Intervention.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intervention-detail', null, { reload: 'intervention' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intervention.new', {
            parent: 'intervention',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intervention/intervention-dialog.html',
                    controller: 'InterventionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xl',
                    windowClass: 'modal-xl',
                    resolve: {
                        entity: function () {
                            return {
                                praxedoId: null,
                                creationDate: null,
                                clientNom: null,
                                clientTel: null,
                                siteTel: null,
                                siteAdress: null,
                                siteCP: null,
                                siteVille: null,
                                equipes: null,
                                duree: null,
                                date: null,
                                activities: null,
                                price: null,
                                id: null,
                                status: null,
                                actProd: null,
                                centralPC: null,
                                agenceNom: null,
                                otFini: null,
                                typeIntervention: null,
                                tailleEquipe: 0,
                                listCommentary: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('intervention', null, { reload: 'intervention' });
                }, function() {
                    $state.go('intervention');
                });
            }]
        })
        .state('intervention.edit', {
            parent: 'intervention',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intervention/intervention-dialog.html',
                    controller: 'InterventionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Intervention', function(Intervention) {
                            return Intervention.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intervention', null, { reload: 'intervention' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intervention.commentary', {
            parent: 'intervention',
            url: '/{id}/commentary',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intervention/intervention-commentary-dialog.html',
                    controller: 'InterventionCommentaryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Intervention', function(Intervention) {
                            return Intervention.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intervention', null, { reload: 'intervention' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intervention.delete', {
            parent: 'intervention',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intervention/intervention-delete-dialog.html',
                    controller: 'InterventionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Intervention', function(Intervention) {
                            return Intervention.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intervention', null, { reload: 'intervention' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intervention-detail.regul', {
            parent: 'intervention-detail',
            url: '/regul/{activityCode}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intervention/intervention-regul-dialog.html',
                    controller: 'InterventionRegulDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Intervention', function(Intervention) {
                            return Intervention.get({id : $stateParams.id}).$promise;
                        }],
                        activityCode: function() {
                            return $stateParams.activityCode;
                        }
                    }
                }).result.then(function() {
                    $state.go('intervention-detail', null, { reload: 'intervention' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Intervention', Intervention);

    Intervention.$inject = ['$resource', 'DateUtils'];

    function Intervention ($resource, DateUtils) {
        var resourceUrl =  'api/interventions/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                url: 'api/interventions',
                hasBody:true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'addCommentary' : {
                method: 'POST',
                url:'api/interventions/:id/commentary',
                hasBody:true,
                transformRequest: function (data) {
                    var copy = angular.fromJson(data);
                    delete copy.id;
                    return angular.toJson(copy);
                }
            },
            'update': {
                method:'PUT',
                url: 'api/interventions',
                hasBody:true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'manualClose': {
            	url:'api/interventions/:id/manualClose',
            	method: 'PUT',
            	hasBody:false
            },
            'facturationFight': {
                url:'api/interventions/:id/facturationFight',
                method: 'PUT',
                hasBody:false
            },
            'bonusMalus': {
            	url:'api/interventions/bonusMalus',
            	method: 'PUT',
            	hasBody:false
            },
            'bonusMalusIntervention': {
            	url:'api/interventions/:id/bonusMalus',
            	method: 'PUT',
            	hasBody:false
            },
            'removeTech': {
                url:'api/interventions/:id/removeTech/:tech',
                method: 'GET'
            },
            'removeCommentary': {
                url:'api/interventions/:id/removeCommentary',
                method: 'PUT',
                hasBody:true,
                transformRequest: function (data) {
                    var copy = angular.fromJson(data);
                    delete copy.id;
                    return angular.toJson(copy);
                },
                params: {id: "@id"}
            },
            'addBonDeCommande': {
                url:'api/interventions/:id/addBonDeCommande',
                method: 'POST',
                hasBody: true,
                transformRequest: function (data) {
                    var copy = angular.fromJson(data);
                    delete copy.id;
                    return angular.toJson(copy);
                },
                params: {id: "@id"}
            },
            'removeBonDeCommande': {
                url:'api/interventions/:id/removeBonDeCommande',
                method: 'PUT',
                hasBody: true,
                transformRequest: function (data) {
                    var copy = angular.fromJson(data);
                    delete copy.id;
                    return angular.toJson(copy);
                },
                params: {id: "@id"}
            },
            'addTech': {
                url:'api/interventions/:id/addTech/:tech',
                method: 'GET'
            },
            'addActivity': {
                url:'api/interventions/createActivity',
                method: 'POST',
                hasBody:true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'removeActivity': {
                url:'api/interventions/:id/removeactivity/:code',
                method: 'GET'
            },
            'changeDate': {
                url:'api/interventions/:id/changeDate',
                method: 'PUT',
                hasBody:false,
                transformRequest: function (data) {
                    var copy = angular.fromJson(data);
                    delete copy.id;
                    return angular.toJson(copy);
                },
                params: {id: "@id", date: "@date"}
            },
            'changeActivityFacture': {
                url:'api/interventions/:id/changeActivityFacture',
                method: 'PUT',
                hasBody:false,
                transformRequest: function (data) {
                    var copy = angular.fromJson(data);
                    delete copy.id;
                    return angular.toJson(copy);
                },
                params: {id: "@id", activityCode: "@activityCode"}
            },
            'changeActivityCaTechnicien': {
                url:'api/interventions/:id/changeActivityCaTechnicien',
                method: 'PUT',
                hasBody:false,
                transformRequest: function (data) {
                    var copy = angular.fromJson(data);
                    delete copy.id;
                    return angular.toJson(copy);
                },
                params: {id: "@id", activityCode: "@activityCode"}
            },
            'updateTechPercentages': {
                url:'api/interventions/:id/updateTechPercentages',
                method: 'POST',
                hasBody:true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                params: {id: "@id"}
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionController', InterventionController);

    InterventionController.$inject = ['$state', 'Intervention', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InterventionController($state, Intervention, Technicien,ParseLinks, AlertService, paginationConstants, pagingParams) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicienEquipe').select2();
        });
        $('#filterTechnicien').on('select2:select', function (e) {
            vm.search();
        });
        $('#filterTechnicienEquipe').on('select2:select', function (e) {
            vm.search();
        });
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        if(typeof pagingParams.status =='string'){
        	vm.filterStatus = [pagingParams.status];
        }else{
        	vm.filterStatus = pagingParams.status;
        }
        if(typeof pagingParams.comparaisonStatus =='string'){
        	vm.filterComparaisonStatus = [pagingParams.comparaisonStatus];
        }else{
        	vm.filterComparaisonStatus = pagingParams.comparaisonStatus;
        }
        vm.filterSearch = pagingParams.search;
        vm.filterDateFrom = pagingParams.dateFrom;
        vm.filterDateTo = pagingParams.dateTo;
        vm.filterTechnicien = pagingParams.technicien;
        vm.filterTechnicienEquipe = pagingParams.technicienEquipe;
        vm.filterTailleEquipe = pagingParams.tailleEquipe;
        vm.filterTechnicienRole = pagingParams.technicienRole;
        vm.filterConstructelFilename = pagingParams.constructelFilename;
        vm.filterDateMailImport = pagingParams.dateMailImport;
        vm.filterFilename = pagingParams.filename;
        vm.filterBonDeCommande = pagingParams.bonDeCommande;
        vm.excludeBonDeCommande = pagingParams.excludeBonDeCommande === true || pagingParams.excludeBonDeCommande === 'true';
        vm.displayReo=true;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.manualClose = manualClose;
        vm.facturationFight = facturationFight;
        vm.resetBonusMalus = resetBonusMalus;
        vm.resetBonusMalusIntervention = resetBonusMalusIntervention;
        vm.getTotalPrice = getTotalPrice;
        vm.selectPhoneNumber = selectPhoneNumber;
        vm.getBonDeCommandeComment = getBonDeCommandeComment;

        loadAll();
        loadTechniciens();

        function loadAll () {
            Intervention.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search: vm.filterSearch,
                status: vm.filterStatus,
                comparaisonStatus: vm.filterComparaisonStatus,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: vm.filterTechnicien,
                technicienEquipe: vm.filterTechnicienEquipe,
                tailleEquipe: vm.filterTailleEquipe,
				technicienRole: vm.filterTechnicienRole,
                constructelFilename: vm.filterConstructelFilename,
                dateMailImport: vm.filterDateMailImport,
                filename: vm.filterFilename,
                bonDeCommande: vm.filterBonDeCommande,
                excludeBonDeCommande: vm.excludeBonDeCommande
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                result.push('defaultSort,asc');
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.interventions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadTechniciens(){
        	Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search(){
        	vm.transition();
        }

        function transition() {
            var params = createInterventionFilter();
            params.page = vm.page;
            params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            $state.transitionTo($state.$current, params);
        }

		function createInterventionFilter(){
			return {
                search: vm.filterSearch,
                status: vm.filterStatus,
                comparaisonStatus: vm.filterComparaisonStatus,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                technicien: $('#filterTechnicien').val(),
                technicienEquipe: $('#filterTechnicienEquipe').val(),
				technicienRole: $('#filterTechnicienRole').val(),
                tailleEquipe: vm.filterTailleEquipe,
                constructelFilename: vm.filterConstructelFilename,
                dateMailImport: vm.filterDateMailImport,
                filename: vm.filterFilename,
                bonDeCommande: vm.filterBonDeCommande,
                excludeBonDeCommande: vm.excludeBonDeCommande
            }
		}

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function manualClose(id){
        	Intervention.manualClose({id:id},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function facturationFight(id) {
            Intervention.facturationFight({id:id},function(s){
                loadAll();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function getTotalPrice(){
        	var totalPrice=0;
        	if(vm.interventions){
        		vm.interventions.forEach(function(intervention) {
        			if(intervention.price){
        				totalPrice+=intervention.price;
        			}
        		});
        	}
        	return totalPrice;
        }

        function selectPhoneNumber(phoneNumber){
        	vm.filterSearch=phoneNumber;
        	vm.filterStatus=null;
        	vm.filterComparaisonStatus=null;
        	search();
        }

        vm.reset = function(){
            vm.excludeBonDeCommande = false;
        	 $state.transitionTo($state.$current, {
                 page: vm.page,
                 sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                 search: vm.filterSearch
             });
        }

        vm.getCssClass=function(intervention){
        	var cssClass='';
        	if(intervention.reo){
        		cssClass+=' warning';
        	}else{
        		for (var i = 0; i < intervention.activities.length; i++) {
        			var activitie=intervention.activities[i];
//        			if(activitie.code.indexOf('BONUS')>0){
//                		cssClass+=' success';
//        			}
        		}
        	}
        	return cssClass;
        }

        function resetBonusMalus(){
        	Intervention.bonusMalus(createInterventionFilter(),function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function resetBonusMalusIntervention(){
        	var interventionId=vm.interventions[vm.interventions.length-1].id;
        	Intervention.bonusMalusIntervention({id:interventionId},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        vm.arround = function(i) {
            return Math.ceil(i);
        }

        function getBonDeCommandeComment(intervention, bonDeCommande) {
            if (!intervention || !intervention.listCommentary || !intervention.listCommentary.length) {
                return null;
            }
            var needle = "Bon de commande " + bonDeCommande;

            for (var i = intervention.listCommentary.length - 1; i >= 0; i--) {
                var text = intervention.listCommentary[i];
                if (text && text.indexOf(needle) !== -1) {
                    var dotIdx = text.lastIndexOf(". ");
                    if (dotIdx !== -1 && dotIdx + 2 < text.length) {
                        var userComment = text.substring(dotIdx + 2).trim();
                        return userComment.length ? userComment : null;
                    }
                    return text;
                }
            }
            return null;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('IndicatorFileDialogController', IndicatorFileDialogController);

    IndicatorFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'IndicatorFile'];

    function IndicatorFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, IndicatorFile) {
        var vm = this;

        vm.indicatorFile = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        
        
        vm.zipFile = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.indicatorFile.id !== null) {
                IndicatorFile.update(vm.zipFile, onSaveSuccess, onSaveError);
            } else {
                IndicatorFile.save(vm.zipFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:indicatorFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


		 vm.setFile = function ($file, zipFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                    	zipFile.filename = $file.name;
                        zipFile.file = base64Data;
                        zipFile.fileContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('IndicatorFileDetailController', IndicatorFileDetailController);

    IndicatorFileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'IndicatorFile', '$state'];

    function IndicatorFileDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, IndicatorFile, $state) {
        var vm = this;

        vm.indicatorFile = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        vm.redownload = redownload;
        vm.disabled = disabled;

        var unsubscribe = $rootScope.$on('tmgApp:indicatorFileUpdate', function(event, result) {
            vm.indicatorFile = result;
        });
        $scope.$on('$destroy', unsubscribe);

		/*
        vm.csvJson=csvJSON(entity.csv);
        function csvJSON(csv){

        	  var lines=csv.split("\n");
        	  var result = [];
        	  var headers=lines[0].split(";");

        	  for(var i=0;i<lines.length;i++){

        	      var obj = {};
        	      var currentline=lines[i].split(";");

        	      for(var j=0;j<headers.length;j++){
        	          obj[headers[j]] = currentline[j];
        	      }

        	      result.push(obj);

        	  }
        	  return result;
        }
		*/

        function redownload(id) {
            IndicatorFile.redownload({id:id}, function(s){
                $state.go($state.current, $stateParams, {reload: true});
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function disabled(error) {
            if (error === false) {
                return "disabled";
            }
        }

		vm.download = function(){
			 IndicatorFile.downloadURL({
				id: vm.indicatorFile.id
            }, function(body){
				DataUtils.openURL(body.downloadURL);
			});
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('IndicatorFileDeleteController',IndicatorFileDeleteController);

    IndicatorFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'IndicatorFile'];

    function IndicatorFileDeleteController($uibModalInstance, entity, IndicatorFile) {
        var vm = this;

        vm.indicatorFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IndicatorFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('indicator-file', {
            parent: 'import',
            url: '/indicator-file?page&sort&search&agence&category&typeIntervention&imported&ignored&error',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.indicatorFile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicator-file/indicator-files.html',
                    controller: 'IndicatorFileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                agence: null,
                category: null,
                typeIndicator: null,
                imported: null,
                ignored: null,
                error: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        agence: $stateParams.agence,
                        category: $stateParams.category,
                        typeIndicator: $stateParams.typeIndicator,
                        imported: $stateParams.imported,
                        ignored: $stateParams.ignored,
                        error: $stateParams.error,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicatorFile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('indicator-file-detail', {
            parent: 'indicator-file',
            url: '/indicator-file/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.indicatorFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicator-file/indicator-file-detail.html',
                    controller: 'IndicatorFileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicatorFile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IndicatorFile', function($stateParams, IndicatorFile) {
                    return IndicatorFile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'indicator-file',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('indicator-file-detail.edit', {
            parent: 'indicator-file-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-dialog.html',
                    controller: 'IndicatorFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IndicatorFile', function(IndicatorFile) {
                            return IndicatorFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicator-file.new', {
            parent: 'indicator-file',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-dialog.html',
                    controller: 'IndicatorFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                filename: null,
                                agence: null,
                                category: null,
                                typeIndicator: null,
                                csv: null,
                                imported: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('indicator-file', null, { reload: 'indicator-file' });
                }, function() {
                    $state.go('indicator-file');
                });
            }]
        })
        .state('indicator-file.edit', {
            parent: 'indicator-file',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-dialog.html',
                    controller: 'IndicatorFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IndicatorFile', function(IndicatorFile) {
                            return IndicatorFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicator-file', null, { reload: 'indicator-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicator-file.delete', {
            parent: 'indicator-file',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicator-file/indicator-file-delete-dialog.html',
                    controller: 'IndicatorFileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IndicatorFile', function(IndicatorFile) {
                            return IndicatorFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicator-file', null, { reload: 'indicator-file' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('IndicatorFile', IndicatorFile);

    IndicatorFile.$inject = ['$resource'];

    function IndicatorFile ($resource) {
        var resourceUrl =  'api/indicator-files/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
            ,'importIndicators': {
            	url:'api/indicator-files/importIndicators',
            	method: 'PUT'
            },
            'resetImportFromIndicatorFilter' : {
                url: 'api/indicator-files/reimportFileIndicator',
                method: 'GET'
            },
            'importNonImportedIndicators': {
                url: 'api/indicator-files/importNonImportedIndicators',
                method: 'PUT'
            },
            'reimportFile': {
                url:'api/indicator-files/resetProcessFile/:id',
                method: 'PUT'
            },
            'redownload': {
                url:'api/indicator-files/redownload/:id',
                method: 'PUT'
            }
            ,'downloadURL':{
            	url:'api/indicator-files/:id/file',
            	method: 'GET',
            	hasBody:false
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('IndicatorFileController', IndicatorFileController);

    IndicatorFileController.$inject = ['$state', 'DataUtils', 'IndicatorFile', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function IndicatorFileController($state, DataUtils, IndicatorFile, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.resetProcess = resetProcess;
        vm.resetByFilter = resetByFilter;
        vm.importIndicators = importIndicators;
        vm.importNonImportedIndicators = importNonImportedIndicators;
        vm.reimportFile = reimportFile;
        vm.redownload = redownload;
        vm.disabled = disabled;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.search = search;
        vm.filterSearch = pagingParams.search;
        vm.filterAgence = pagingParams.agence;
        vm.filterCategory = pagingParams.category;
        vm.filterTypeIndicator = pagingParams.typeIndicator;
        vm.filterImported = pagingParams.imported;
        vm.filterIgnored = pagingParams.ignored;
        vm.filterError = pagingParams.error;

        loadAll();

        function loadAll () {
            IndicatorFile.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search: vm.filterSearch,
                agence: vm.filterAgence,
                category: vm.filterCategory,
                typeIndicator: vm.filterTypeIndicator,
                imported: vm.filterImported,
                ignored: vm.filterIgnored,
                error: vm.filterError
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.indicatorFiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search(){
        	vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.filterSearch,
                agence: vm.filterAgence,
                category: vm.filterCategory,
                typeIndicator: vm.filterTypeIndicator,
                imported: vm.filterImported,
                ignored: vm.filterIgnored,
                error: vm.filterError
            }, { reload: true });
        }

        function resetProcess(){
        	IndicatorFile.resetProcess({}, function(s){
        		transition();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function resetByFilter(){
            if (window.confirm("Êtes-vous de vouloir relancer l'import des fichiers en fonction des critères sélectionnés")) {
                IndicatorFile.resetImportFromIndicatorFilter({
                    search: vm.filterSearch,
                    agence: vm.filterAgence,
                    category: vm.filterCategory,
                    typeIndicator: vm.filterTypeIndicator,
                    imported: vm.filterImported,
                    ignored: vm.filterIgnored,
                    error: vm.filterError
                }, function (s){
                    transition();
                }, function (error) {
                    AlertService.error(error.data.message);
                });
            }
        }

         function importIndicators(){
        	IndicatorFile.importIndicators({}, function(s){
        		transition();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function reimportFile(id) {
            IndicatorFile.reimportFile({id:id}, function(s){
                transition();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function redownload(id) {
            IndicatorFile.redownload({id:id}, function(s){
                transition();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function disabled(error) {
            if (error === false) {
                return "disabled";
            }
        }

        function importNonImportedIndicators(){
            IndicatorFile.importNonImportedIndicators({}, function(s){
                transition();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ImportConstructelNewDialogController', ImportConstructelNewDialogController);

    ImportConstructelNewDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ImportConstructel','$http', 'DataUtils'];

    function ImportConstructelNewDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ImportConstructel,$http, DataUtils) {
        var vm = this;

        vm.importConstructel = entity;
        vm.clear = clear;
        vm.save = save;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.importConstructel.files.forEach(function(file){
                file.typeImport = vm.importConstructel.typeImport;
            })
            ImportConstructel.saveNewFiles(vm.importConstructel.files, onSaveSuccess, onSaveError);
        }

        vm.setFiles = function ($files, importFiles) {
            if ($files && $files.length) {
                $files.forEach(function(file) {
                    DataUtils.toBase64(file, function(base64Data) {
                        $scope.$apply(function() {
                            var importFile = {
                                fileName: file.name,
                                file: base64Data,
                                fileContentType: file.type
                            };
                            importFiles.files.push(importFile);
                        });
                    });
                });
            }
            console.log(importFiles);
        };

        vm.removeFile = function (file) {
            var index = vm.importConstructel.files.indexOf(file);
            if (index !== -1) {
                vm.importConstructel.files.splice(index, 1);
            }
        };

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:importConstructelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ImportConstructelDialogController', ImportConstructelDialogController);

    ImportConstructelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ImportConstructel'];

    function ImportConstructelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ImportConstructel) {
        var vm = this;

        vm.importConstructel = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.importConstructel.id !== null) {
                ImportConstructel.update(vm.importConstructel, onSaveSuccess, onSaveError);
            } else {
                ImportConstructel.save(vm.importConstructel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:importConstructelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateCreation = false;

        vm.setCsv = function ($file, importConstructel) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        importConstructel.name = $file.name;
                        importConstructel.csv = base64Data;
                        importConstructel.csvContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ImportConstructelDetailController', ImportConstructelDetailController);

    ImportConstructelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'ImportConstructel', 'Intervention'];

    function ImportConstructelDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, ImportConstructel, Intervention) {
        var vm = this;


        vm.predicate = 'id';
        vm.reverse = false;
        vm.importConstructel = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.transition = transition;

        vm.filterComparaisonStatus = null;

        getCorrespondingInterventions();

        var unsubscribe = $rootScope.$on('tmgApp:importConstructelUpdate', function(event, result) {
            vm.importConstructel = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function transition() {
            getCorrespondingInterventions();
        }

        function getCorrespondingInterventions() {
            Intervention.query({
                sort: sort(),
                comparaisonStatus: vm.filterComparaisonStatus,
                constructelFilename: vm.importConstructel.name,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                result.push('defaultSort,asc');
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                console.log(result)
                return result;
            }
            function onSuccess(data, headers) {
                vm.interventionsFound = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

		vm.download = function(){
			 ImportConstructel.downloadURL({
				id: vm.importConstructel.id
            }, function(body){
				DataUtils.openURL(body.downloadURL);
			});
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ImportConstructelDeleteController',ImportConstructelDeleteController);

    ImportConstructelDeleteController.$inject = ['$uibModalInstance', 'entity', 'ImportConstructel'];

    function ImportConstructelDeleteController($uibModalInstance, entity, ImportConstructel) {
        var vm = this;

        vm.importConstructel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ImportConstructel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('import-constructel', {
            parent: 'import',
            url: '/import-constructel?page&sort&search&status',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.importConstructel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/import-constructel/import-constructel.html',
                    controller: 'ImportConstructelController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'dateCreation,desc',
                    squash: true
                },
                search: null,
                status: null,
                type: null,
                dateFrom:null,
                dateTo:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        status: $stateParams.status,
                        type: $stateParams.type,
                        dateFrom: $stateParams.dateFrom,
                        dateTo: $stateParams.dateTo
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('importConstructel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('import-constructel-detail', {
            parent: 'import-constructel',
            url: '/import-constructel/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.importConstructel.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/import-constructel/import-constructel-detail.html',
                    controller: 'ImportConstructelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('importConstructel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ImportConstructel', function($stateParams, ImportConstructel) {
                    return ImportConstructel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'import-constructel',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('import-constructel-detail.edit', {
            parent: 'import-constructel-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-dialog.html',
                    controller: 'ImportConstructelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ImportConstructel', function(ImportConstructel) {
                            return ImportConstructel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('import-constructel.new', {
            parent: 'import-constructel',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-dialog.html',
                    controller: 'ImportConstructelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                dateCreation: null,
                                nbInterventions: null,
                                csv: null,
                                csvContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('import-constructel');
                });
            }]
        })
        .state('import-constructel.edit', {
            parent: 'import-constructel',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-dialog.html',
                    controller: 'ImportConstructelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ImportConstructel', function(ImportConstructel) {
                            return ImportConstructel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('import-constructel.delete', {
            parent: 'import-constructel',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-delete-dialog.html',
                    controller: 'ImportConstructelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ImportConstructel', function(ImportConstructel) {
                            return ImportConstructel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('import-constructel.newConstructel', {
            parent: 'import-constructel',
            url: '/newConstructel',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-newFile-dialog.html',
                    controller: 'ImportConstructelNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                files: [],
                                typeImport: null,
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('import-constructel');
                });
            }]
        });



    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('ImportConstructel', ImportConstructel);

    ImportConstructel.$inject = ['$resource', 'DateUtils'];

    function ImportConstructel ($resource, DateUtils) {
        var resourceUrl =  'api/constructel-file/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateCreation = DateUtils.convertDateTimeFromServer(data.dateCreation);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'process': {
            	url:'api/constructel-file/:id/process',
            	method: 'PUT',
            	hasBody:false
            },
            'paid': {
            	url:'api/constructel-file/:id/paid',
            	method: 'PUT',
            	hasBody:false
            }
            ,'resetProcess': {
            	url:'api/constructel-file/resetProcess',
            	method: 'PUT'
            }
            ,'downloadURL':{
            	url:'api/constructel-file/:id/file',
            	method: 'GET',
            	hasBody:false
            },
            'saveNewFiles': {
                url:'api/constructel-file/new-files',
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ImportConstructelController', ImportConstructelController);

    ImportConstructelController.$inject = ['$state', 'DataUtils', 'ImportConstructel', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ImportConstructelController($state, DataUtils, ImportConstructel, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.process = process;
        vm.paid = paid;
        vm.search = search;
        vm.resetProcess = resetProcess;

        vm.filterStatus = pagingParams.status;
        vm.filterType = pagingParams.type;
        vm.filterSearch = pagingParams.search;
        vm.filterDateFrom = pagingParams.dateFrom;
        vm.filterDateTo = pagingParams.dateTo;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dateFrom = false;
        vm.datePickerOpenStatus.dateTo = false;

        loadAll();

        function loadAll () {
            ImportConstructel.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                status: vm.filterStatus,
                search: vm.filterSearch,
                type: vm.filterType,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.importConstructels = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                status: vm.filterStatus,
                search: vm.filterSearch,
                type: vm.filterType,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo
            });
        }

        function process(id){
        	ImportConstructel.process({id:id},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function paid(id){
        	ImportConstructel.paid({id:id},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }


        function resetProcess(){
        	ImportConstructel.resetProcess({ }, function(s){
        		transition();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function search(){
        	vm.transition();
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('import', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('GroupePlanningDialogController', GroupePlanningDialogController);

    GroupePlanningDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GroupePlanning'];

    function GroupePlanningDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GroupePlanning) {
        var vm = this;

        vm.groupePlanning = entity;
        vm.colors = [
            "Bleu",
            "Vert",
            "Jaune",
            "Rouge",
            "Violet",
            "Orange",
            "Gris",
        ]
        vm.clear = clear;
        vm.save = save;
        vm.isSaving = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.groupePlanning.id !== null){
                GroupePlanning.update(vm.groupePlanning, onSaveSuccess, onSaveError);
            } else {
                GroupePlanning.save(vm.groupePlanning, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            // $scope.$emit('tmgApp:groupePlanningUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('GroupePlanningDetailController', GroupePlanningDetailController);

    GroupePlanningDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GroupePlanning'];

    function GroupePlanningDetailController($scope, $rootScope, $stateParams, previousState, entity, GroupePlanning) {
        var vm = this;

        vm.groupePlanning = entity;
        vm.previousState = previousState.name;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('GroupePlanningDeleteController',GroupePlanningDeleteController);

    GroupePlanningDeleteController.$inject = ['$uibModalInstance', 'entity', 'GroupePlanning'];

    function GroupePlanningDeleteController($uibModalInstance, entity, GroupePlanning) {
        var vm = this;

        vm.groupePlanning = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GroupePlanning.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('groupe-planning', {
                url: '/groupe-planning?page&sort',
                parent: 'gestion',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'tmgApp.groupe-planning.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/groupe-planning/groupe-planning.html',
                        controller: 'GroupePlanningController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('groupePlanning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('groupe-planning.new', {
                parent: 'groupe-planning',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-dialog.html',
                        controller: 'GroupePlanningDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    name: null,
                                    enabled: false,
                                    color: null,
                                    order: null,
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('groupe-planning', null, { reload: 'groupe-planning' });
                    }, function() {
                        $state.go('groupe-planning');
                    });
                }]
            })
            .state('groupe-planning.edit', {
                parent: 'groupe-planning',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-dialog.html',
                        controller: 'GroupePlanningDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['GroupePlanning', function(GroupePlanning) {
                                return GroupePlanning.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('groupe-planning', null, { reload: 'groupe-planning' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('groupe-planning-detail', {
                parent: 'groupe-planning',
                url: '/groupe-planning/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'tmgApp.groupePlanning.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-detail.html',
                        controller: 'GroupePlanningDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('groupePlanning');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'GroupePlanning', function($stateParams, GroupePlanning) {
                        return GroupePlanning.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'groupe-planning',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('groupe-planning.delete', {
                parent: 'groupe-planning',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/groupe-planning/groupe-planning-delete-dialog.html',
                        controller: 'GroupePlanningDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['GroupePlanning', function(GroupePlanning) {
                                return GroupePlanning.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('groupe-planning', null, { reload: 'groupe-planning' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('GroupePlanning', GroupePlanning);

    GroupePlanning.$inject = ['$resource'];

    function GroupePlanning ($resource) {
        var resourceUrl =  'api/groupes-planning/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getEnabled': {
                method: 'GET',
                isArray: true,
                url: '/api/groupes-planning/get-enabled'
            },
            'update': { method:'PUT' }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('GroupePlanningController', GroupePlanningController);

    GroupePlanningController.$inject = ['$state', 'GroupePlanning', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function GroupePlanningController($state, GroupePlanning, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            GroupePlanning.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),];
                result.push('id');
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.groupePlanning = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gestion', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripEditController', FleetDailyTripEditController);

    FleetDailyTripEditController.$inject = ['$uibModalInstance', '$filter', 'entity', 'FleetDailyTrip', 'Technicien', 'AlertService'];

    function FleetDailyTripEditController($uibModalInstance, $filter, entity, FleetDailyTrip, Technicien, AlertService) {
        var vm = this;

        vm.fleetDailyTrip = entity;
        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = { timeStart: false, timeEnd: false };
        vm.errorMessage = null;
        vm.isSaving = false;

        vm.techniciens = [];
        Technicien.technicienEnabled({}, function(list) {
            vm.techniciens = list;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(name) {
            vm.datePickerOpenStatus[name] = true;
        }

        function save() {
            if (!vm.fleetDailyTrip.timeStart || !vm.fleetDailyTrip.timeEnd) {
                vm.errorMessage = "Veuillez renseigner l'heure de début et l'heure de fin.";
                return;
            }
            if (vm.fleetDailyTrip.timeEnd < vm.fleetDailyTrip.timeStart) {
                vm.errorMessage = "L'heure de fin doit être postérieure à l'heure de début.";
                return;
            }
            vm.isSaving = true;
            vm.errorMessage = null;
            var payload = {
                id: vm.fleetDailyTrip.id,
                timeStart: $filter('date')(vm.fleetDailyTrip.timeStart, "yyyy-MM-dd'T'HH:mm:ss"),
                timeEnd: $filter('date')(vm.fleetDailyTrip.timeEnd, "yyyy-MM-dd'T'HH:mm:ss"),
                technicien: vm.fleetDailyTrip.technicien || null
            };
            FleetDailyTrip.update({}, payload, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError(response) {
            vm.isSaving = false;
            var msg = 'Erreur lors de la mise à jour du trajet.';
            if (response && response.data && response.data.message) {
                msg = response.data.message;
            } else if (response && response.headers) {
                var headerMsg = response.headers('X-tmgApp-error');
                if (headerMsg) {
                    msg = headerMsg;
                }
            }
            vm.errorMessage = msg;
            AlertService.error(msg);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripDialogController', FleetDailyTripDialogController);

    FleetDailyTripDialogController.$inject = ['$scope', '$uibModalInstance', 'DataUtils', 'entity', 'FleetDailyTrip', 'AlertService'];

    function FleetDailyTripDialogController ($scope, $uibModalInstance, DataUtils, entity, FleetDailyTrip, AlertService) {
        var vm = this;

        vm.fleetDailyTrip = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.setFile = setFile;
        vm.errorMessage = null;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if (!vm.fleetDailyTrip.file) {
                vm.errorMessage = "Veuillez sélectionner un fichier Excel.";
                return;
            }
            vm.isSaving = true;
            vm.errorMessage = null;
            FleetDailyTrip.importFile({}, vm.fleetDailyTrip, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            if (result && result.success === false) {
                vm.errorMessage = result.message || "Erreur lors de l'import.";
                return;
            }
            var imported = result && typeof result.imported === 'number' ? result.imported : 0;
            AlertService.success(imported + " trajet(s) importé(s)");
            $scope.$emit('tmgApp:fleetDailyTripUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError (response) {
            vm.isSaving = false;
            var msg = "Erreur lors de l'import.";
            if (response && response.data && response.data.message) {
                msg = response.data.message;
            } else if (response && response.headers) {
                var headerMsg = response.headers('X-tmgApp-error');
                if (headerMsg) {
                    msg = headerMsg;
                }
            }
            vm.errorMessage = msg;
            AlertService.error(msg);
        }

        function setFile ($file) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        vm.fleetDailyTrip.fileName = $file.name;
                        vm.fleetDailyTrip.file = base64Data;
                        vm.fleetDailyTrip.fileContentType = $file.type;
                        vm.errorMessage = null;
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripDeleteController', FleetDailyTripDeleteController);

    FleetDailyTripDeleteController.$inject = ['$uibModalInstance', 'entity', 'FleetDailyTrip'];

    function FleetDailyTripDeleteController($uibModalInstance, entity, FleetDailyTrip) {
        var vm = this;

        vm.fleetDailyTrip = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FleetDailyTrip.delete({id: id}, function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fleet-daily-trip', {
            parent: 'import',
            url: '/fleet-daily-trip?page&sort&date&technicien&withoutTechnicien',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.fleetDailyTrip.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trips.html',
                    controller: 'FleetDailyTripController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                date: null,
                technicien: null,
                withoutTechnicien: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        date: $stateParams.date,
                        technicien: $stateParams.technicien,
                        withoutTechnicien: $stateParams.withoutTechnicien
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fleetDailyTrip');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fleet-daily-trip.new', {
            parent: 'fleet-daily-trip',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trip-dialog.html',
                    controller: 'FleetDailyTripDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fileName: null,
                                file: null,
                                fileContentType: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fleet-daily-trip', null, { reload: 'fleet-daily-trip' });
                }, function() {
                    $state.go('fleet-daily-trip');
                });
            }]
        })
        .state('fleet-daily-trip.edit', {
            parent: 'fleet-daily-trip',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trip-edit-dialog.html',
                    controller: 'FleetDailyTripEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['FleetDailyTrip', function(FleetDailyTrip) {
                            return FleetDailyTrip.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-daily-trip', null, { reload: 'fleet-daily-trip' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fleet-daily-trip.delete', {
            parent: 'fleet-daily-trip',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-daily-trip/fleet-daily-trip-delete-dialog.html',
                    controller: 'FleetDailyTripDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FleetDailyTrip', function(FleetDailyTrip) {
                            return FleetDailyTrip.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-daily-trip', null, { reload: 'fleet-daily-trip' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('FleetDailyTrip', FleetDailyTrip);

    FleetDailyTrip.$inject = ['$resource', 'DateUtils'];

    function FleetDailyTrip ($resource, DateUtils) {
        var resourceUrl =  'api/fleet-daily-trips/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.timeStart = DateUtils.convertDateTimeFromServer(data.timeStart);
                        data.timeEnd = DateUtils.convertDateTimeFromServer(data.timeEnd);
                    }
                    return data;
                }
            },
            'update': {
                url: 'api/fleet-daily-trips',
                method: 'PUT'
            },
            'importFile': {
                url: 'api/fleet-daily-trips/import',
                method: 'POST'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('FleetDailyTripController', FleetDailyTripController);

    FleetDailyTripController.$inject = ['$state', 'FleetDailyTrip', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'DateUtils'];

    function FleetDailyTripController($state, FleetDailyTrip, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams, DateUtils) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.resetFilters = resetFilters;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = { date: false };

        vm.filterDate = pagingParams.date ? DateUtils.convertLocalDateFromServer(pagingParams.date) : null;
        vm.filterTechnicien = pagingParams.technicien || '';
        vm.WITHOUT_TECHNICIEN = '__WITHOUT__';
        if (pagingParams.withoutTechnicien === 'true') {
            vm.filterTechnicien = vm.WITHOUT_TECHNICIEN;
        }

        vm.techniciens = [];
        Technicien.technicienEnabled({}, function(list) {
            vm.techniciens = list;
        });

        loadAll();

        function loadAll () {
            var params = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            };
            if (vm.filterDate) {
                params.date = DateUtils.convertLocalDateToServer(vm.filterDate);
            }
            if (vm.filterTechnicien === vm.WITHOUT_TECHNICIEN) {
                params.withoutTechnicien = true;
            } else if (vm.filterTechnicien) {
                params.technicien = vm.filterTechnicien;
            }

            FleetDailyTrip.query(params, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fleetDailyTrips = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data ? error.data.message : 'Error');
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function search() {
            vm.page = 1;
            vm.transition();
        }

        function resetFilters() {
            vm.filterDate = null;
            vm.filterTechnicien = '';
            vm.page = 1;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                date: vm.filterDate ? DateUtils.convertLocalDateToServer(vm.filterDate) : null,
                technicien: vm.filterTechnicien && vm.filterTechnicien !== vm.WITHOUT_TECHNICIEN ? vm.filterTechnicien : null,
                withoutTechnicien: vm.filterTechnicien === vm.WITHOUT_TECHNICIEN ? 'true' : null
            }, { reload: true });
        }

        function openCalendar(name) {
            vm.datePickerOpenStatus[name] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ExportPraxedoNewDialogController', ExportPraxedoNewDialogController);

    ExportPraxedoNewDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExportPraxedo','$http', 'DataUtils'];

    function ExportPraxedoNewDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExportPraxedo,$http, DataUtils) {
        var vm = this;

        vm.exportPraxedo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.exportPraxedo.files.forEach(function(file){
                file.typeImport = vm.exportPraxedo.typeImport;
            })
            ExportPraxedo.saveNewFile(vm.exportPraxedo.files, onSaveSuccess, onSaveError);
        }

        vm.setFiles = function ($files, exportFiles) {
            if ($files && $files.length) {
                $files.forEach(function(file) {
                    DataUtils.toBase64(file, function(base64Data) {
                        $scope.$apply(function() {
                            var exportFile = {
                                fileName: file.name,
                                file: base64Data,
                                fileContentType: file.type
                            };
                            exportFiles.files.push(exportFile);
                        });
                    });
                });
            }
        };

        vm.removeFile = function (file) {
            var index = vm.exportPraxedo.files.indexOf(file);
            if (index !== -1) {
                vm.exportPraxedo.files.splice(index, 1);
            }
        };

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:exportPraxedoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ExportPraxedoDialogController', ExportPraxedoDialogController);

    ExportPraxedoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExportPraxedo'];

    function ExportPraxedoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExportPraxedo) {
        var vm = this;

        vm.exportPraxedo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.exportPraxedo.id !== null) {
                ExportPraxedo.update(vm.exportPraxedo, onSaveSuccess, onSaveError);
            } else {
                ExportPraxedo.save(vm.exportPraxedo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:exportPraxedoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ExportPraxedoDetailController', ExportPraxedoDetailController);

    ExportPraxedoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils','entity', 'ExportPraxedo'];

    function ExportPraxedoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, ExportPraxedo) {
        var vm = this;

        vm.exportPraxedo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:exportPraxedoUpdate', function(event, result) {
            vm.exportPraxedo = result;
        });
        $scope.$on('$destroy', unsubscribe);

		vm.download = function(){
			 ExportPraxedo.downloadURL({
				id: vm.exportPraxedo.id
            }, function(body){
				DataUtils.openURL(body.downloadURL);
			});
		};
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ExportPraxedoDeleteController',ExportPraxedoDeleteController);

    ExportPraxedoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExportPraxedo'];

    function ExportPraxedoDeleteController($uibModalInstance, entity, ExportPraxedo) {
        var vm = this;

        vm.exportPraxedo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ExportPraxedo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('export-praxedo', {
            parent: 'import',
            url: '/export-praxedo?page&sort&search&name',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.exportPraxedo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/export-praxedo/export-praxedos.html',
                    controller: 'ExportPraxedoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null,
                name:null,
                error:null,
                type:null,
                dateFrom:null,
                dateTo:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        name: $stateParams.name,
                        error: $stateParams.error,
                        type: $stateParams.type,
                        dateFrom: $stateParams.dateFrom,
                        dateTo: $stateParams.dateTo
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exportPraxedo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('export-praxedo-detail', {
            parent: 'export-praxedo',
            url: '/export-praxedo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.exportPraxedo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-detail.html',
                    controller: 'ExportPraxedoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exportPraxedo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExportPraxedo', function($stateParams, ExportPraxedo) {
                    return ExportPraxedo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'export-praxedo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('export-praxedo-detail.edit', {
            parent: 'export-praxedo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-dialog.html',
                    controller: 'ExportPraxedoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExportPraxedo', function(ExportPraxedo) {
                            return ExportPraxedo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('export-praxedo.new', {
            parent: 'export-praxedo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-dialog.html',
                    controller: 'ExportPraxedoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                date: null,
                                csv: null,
                                creationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('export-praxedo');
                });
            }]
        })
        .state('export-praxedo.edit', {
            parent: 'export-praxedo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-dialog.html',
                    controller: 'ExportPraxedoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExportPraxedo', function(ExportPraxedo) {
                            return ExportPraxedo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('export-praxedo.delete', {
            parent: 'export-praxedo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-delete-dialog.html',
                    controller: 'ExportPraxedoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExportPraxedo', function(ExportPraxedo) {
                            return ExportPraxedo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('export-praxedo.newPraxedo', {
            parent: 'export-praxedo',
            url: '/newPraxedo',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/export-praxedo/export-praxedo-newFile-dialog.html',
                    controller: 'ExportPraxedoNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                files: [],
                                typeImport: null,
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('export-praxedo', null, { reload: 'export-praxedo' });
                }, function() {
                    $state.go('export-praxedo');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('ExportPraxedo', ExportPraxedo);

    ExportPraxedo.$inject = ['$resource', 'DateUtils'];

    function ExportPraxedo ($resource, DateUtils) {
        var resourceUrl =  'api/export-praxedos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
            ,'processMails': {
            	url:'api/export-praxedos/processMails',
            	method: 'PUT'
            }
            ,'resetProcess': {
            	url:'api/export-praxedos/resetProcess',
            	method: 'PUT'
            }
            ,'resetProcessPraxedo': {
                url:'api/export-praxedos/resetProcessPraxedo',
                method: 'PUT'
            }
            ,'resetProcessById':{
            	url:'api/export-praxedos/:id/resetProcess',
            	method: 'PUT',
            	hasBody:false,
                params: {id: "@id"}
            }
            ,'downloadURL':{
            	url:'api/export-praxedos/:id/file',
            	method: 'GET',
            	hasBody:false
            },
            'saveNewFile': {
                url:'api/export-praxedos/newFile',
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getLastImports': {
                url:'api/export-praxedos/lastImports',
                method: 'GET',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ExportPraxedoController', ExportPraxedoController);

    ExportPraxedoController.$inject = ['$state', 'ExportPraxedo', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ExportPraxedoController($state, ExportPraxedo, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.processMails = processMails;
        vm.resetProcess = resetProcess;
        vm.resetProcessPraxedo = resetProcessPraxedo;
        vm.resetProcessById = resetProcessById;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;

        vm.filterName = pagingParams.name;
        vm.filterSearch = pagingParams.search;
        vm.filterError = pagingParams.error;
        vm.filterType = pagingParams.type;
        vm.filterDateFrom = pagingParams.dateFrom;
        vm.filterDateTo = pagingParams.dateTo;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dateFrom = false;
        vm.datePickerOpenStatus.dateTo = false;

        loadAll();

        function loadAll () {
            ExportPraxedo.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                name: vm.filterName,
                search: vm.filterSearch,
                type: vm.filterType,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
                error: vm.filterError,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.exportPraxedos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.filterSearch,
                name: vm.filterName,
                error: vm.filterError,
                type: vm.filterType,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
            }, {
                reload: true
            });
        }

        function processMails(){
        	ExportPraxedo.processMails(function(s){
        		transition();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function resetProcess(){
        	ExportPraxedo.resetProcess({ name: vm.filterName}, function(s){
        		transition();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function resetProcessPraxedo(){
            ExportPraxedo.resetProcessPraxedo({ name: vm.filterName}, function(s){
                transition();
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }
        resetProcessPraxedo

        function resetProcessById(id){
        	ExportPraxedo.resetProcessById({ id: id}, function(s){
        		transition();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }


        function search(){
        	vm.transition();
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('EquipeDialogController', EquipeDialogController);

    EquipeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'Equipe', 'Technicien','AlertService', 'GroupePlanning', 'Outil', '$q'];

    function EquipeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, Equipe, Technicien, AlertService, GroupePlanning, Outil, $q) {

        var vm = this;
        vm.date = $stateParams.date;
        vm.newEquipes = {};
        vm.clear = clear;
        vm.loadEquipes = loadEquipes;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.techniciens = [];
        vm.availableTechniciens = [];
        vm.colors = null;
        vm.addEquipe = addEquipe;
        vm.deleteEquipe = deleteEquipe;
        vm.updateEquipe = updateEquipe;
        vm.getTechnicienForTeam = getTechnicienForTeam;
        vm.copyActualEquipe = copyActualEquipe;
        vm.initNewEquipes = initNewEquipes;
        vm.adaptOutilForChef = adaptOutilForChef;
        vm.inEditingState = false;

        vm.dropdownSettings = {
            buttonClasses: 'form-control',
            displayProp: 'dropdownDisplay',
            idProperty: 'code',
            checkBoxes: true,
            showUncheckAll: false,
            showCheckAll: false,
            scrollableHeight: '200px',
            scrollable: true,
        };

        vm.dropdownTranslation = {
            buttonDefaultText: '-- outil --',
            selectionCount: ' outils sélectionnés'
        }

        loadAllData();
        defineColors();

        function loadAllData() {
            $q.all([
                loadTechniciens(vm.date),
                loadGroupesPlanning(),
                loadOutil(),
            ])
                .then(function() {
                    return loadEquipes();
                })
                .then(function() {
                    adaptAvailableTechniciens();
                })
        }

        function addEquipe(groupePlanningId) {
            var equipe = vm.newEquipes[groupePlanningId];

            equipe.binome = equipe.binome === ""? null : equipe.binome;

            //on va set les codes à la place des ids renvoyés par le dropdown
            if (equipe.outilIds && equipe.outilIds.length){
                var outilCodes = [];
                equipe.outilIds.forEach(function(outilObj) {
                    var outilCode;
                    for (var i = 0; i < vm.outils.length; i++) {
                        if (vm.outils[i].id == outilObj.id) {
                            outilCode = vm.outils[i].code;
                            break;
                        }
                    }
                    if (outilCode) {
                        outilCodes.push(outilCode);
                    }
                });

                equipe.outilCodes = outilCodes;
            }else {
                equipe.outilCodes = null;
            }

            equipe.outilIds = null;
            equipe.groupePlanningId = groupePlanningId;
            equipe.date = vm.date;

            updateNotWorkingTechniciens(equipe);
            vm.isSaving = true;
            Equipe.save(equipe, onSaveSuccess, onSaveError);
            vm.newEquipes[groupePlanningId] = { outilIds: [] };
        }

        function updateEquipe(equipe) {
            equipe.binome = equipe.binome === ""? null : equipe.binome;

            if (equipe.outils && equipe.outils.length) {
                var outilCodes = [];
                equipe.outils.forEach(function (outilObj) {
                    var outilCode;
                    for (var i = 0; i < vm.outils.length; i++) {
                        if (vm.outils[i].id == outilObj.id) {
                            outilCode = vm.outils[i].code;
                            break;
                        }
                    }
                    if (outilCode) {
                        outilCodes.push(outilCode);
                    }
                });

                equipe.outilCodes = outilCodes;
            }else {
                equipe.outilCodes = null;
            }

            equipe.outilIds = null;
            equipe.outils = null;

            Equipe.update(equipe).$promise.then(function() {
                deleteEquipeFromWorkingTechnicien(vm.oldEquipeBeforeEdit);
                updateNotWorkingTechniciens(equipe);
                loadEquipes();
            });
        }

        function deleteEquipe(equipe) {
            Equipe.delete({id: equipe.id}).$promise.then(function() {
                loadEquipes();
                deleteEquipeFromWorkingTechnicien(equipe);
                adaptAvailableTechniciens();
            });
        }

        function deleteEquipeFromWorkingTechnicien(equipe) {
            if (equipe.chef && vm.alreadyWorkingTechniciens.indexOf(equipe.chef) !== -1) {
                var index = vm.alreadyWorkingTechniciens.indexOf(equipe.chef);
                if (index !== -1) {
                    vm.alreadyWorkingTechniciens.splice(index, 1);
                }
            }
            if (equipe.binome && vm.alreadyWorkingTechniciens.indexOf(equipe.binome) !== -1) {
                var index = vm.alreadyWorkingTechniciens.indexOf(equipe.binome);
                if (index !== -1) {
                    vm.alreadyWorkingTechniciens.splice(index, 1);
                }
            }
        }

        function loadOutil() {
            return Outil.getEnabled({ }, function onSuccess(data, headers) {
                data.forEach(function(outil){
                    outil.dropdownDisplay = outil.code + ': ' + outil.name;
                });
                vm.outils = data;

            }, function onError(error) {
                AlertService.error(error.data.message);
            }).$promise;
        }

        function loadGroupesPlanning() {
            return GroupePlanning.getEnabled({ }, function onSuccess(data, headers) {
                vm.groupesPlanning = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            }).$promise;
        }

        function loadEquipes(){
            return Equipe.getByDate({
                    date: vm.date,
                },
                function onSuccess(data, headers) {
                    vm.equipes = {};
                    vm.alreadyWorkingTechniciens = [];

                    data.forEach(function(equipe) {
                        equipe.editing = false;

                        equipe.outilIds = [];
                        equipe.outils = [];
                        if (equipe.outilCodes && equipe.outilCodes.length) {
                            equipe.outilCodes.forEach(function(code) {
                                var outil = null;
                                for (var i = 0; i < vm.outils.length; i++) {
                                    if (vm.outils[i].code === code) {
                                        outil = vm.outils[i];
                                        break;
                                    }
                                }
                                if (outil) {
                                    equipe.outils.push(outil);
                                }
                            });
                        }

                        if (vm.alreadyWorkingTechniciens.indexOf(equipe.chef) === -1) {
                            vm.alreadyWorkingTechniciens.push(equipe.chef);
                        }
                        if (equipe.binome && vm.alreadyWorkingTechniciens.indexOf(equipe.binome) === -1) {
                            vm.alreadyWorkingTechniciens.push(equipe.binome);
                        }

                        var groupePlanningId = equipe.groupePlanningId;
                        if (groupePlanningId !== null) {
                            if (vm.equipes[groupePlanningId] === undefined) {
                                vm.equipes[groupePlanningId] = [];
                            }
                            vm.equipes[groupePlanningId].push(equipe);
                        }else {
                            if (vm.equipes['withoutGroupePlanning'] === undefined) {
                                vm.equipes['withoutGroupePlanning'] = [];
                            }
                            vm.equipes['withoutGroupePlanning'].push(equipe);
                        }
                    });
                },
                function onError(error) {
                    AlertService.error(error.data.message);
                }).$promise;
        }

        function updateNotWorkingTechniciens(newEquipe){
            if (newEquipe.chef && vm.alreadyWorkingTechniciens.indexOf(newEquipe.chef) === -1) {
                vm.alreadyWorkingTechniciens.push(newEquipe.chef);
            }
            if (newEquipe.binome && vm.alreadyWorkingTechniciens.indexOf(newEquipe.binome) === -1) {
                vm.alreadyWorkingTechniciens.push(newEquipe.binome);
            }

            adaptAvailableTechniciens();
        }

        function adaptAvailableTechniciens() {
            vm.availableTechniciens = vm.techniciens.filter(function(technicien) {
                return vm.alreadyWorkingTechniciens.indexOf(technicien.displayname) === -1;
            });
        }

        function getTechnicienForTeam(selectedTech) {
            if(selectedTech){
                return vm.availableTechniciens.filter(function(technicien) { return technicien.displayname !== selectedTech; });
            }else{
                return vm.availableTechniciens;
            }
        }

        function adaptOutilForChef(equipe) {
            equipe.outilIds = vm.outils
                .filter(function(outil) {
                    return outil.technicien === equipe.chef;
                })
                .map(function(outil) {
                    return { id: outil.id };
                });
            console.log(equipe);
        }

        function copyActualEquipe(equipe) {
            vm.oldEquipeBeforeEdit = angular.copy(equipe);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.equipe.id !== null) {
                Equipe.update(vm.equipe, onSaveSuccess, onSaveError);
            } else {
                Equipe.save(vm.equipe, onSaveSuccess, onSaveError);
            }
        }

        function loadTechniciens(date) {
            return Technicien.getAvailableForPlanning({ date: date }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }).$promise;
        }

        function initNewEquipes(groupePlanningId) {
            //pour le dropdown des outils
            if (!vm.newEquipes[groupePlanningId]) {
                vm.newEquipes[groupePlanningId] = { outilIds: [] };
            }
        };

        function defineColors(){
            vm.colors = {
                Gris: {
                    title: "#8C8C8B",
                    base: "#BDBDBD",
                },
                Bleu: {
                    title: "#6590EB",
                    base: "#A5C0FA"
                },
                Vert: {
                    title: "#58BF64",
                    base: "#9BE8A5"
                },
                Rouge: {
                    title: "#F56464",
                    base: "#FCB1B1"
                },
                Jaune: {
                    title: "#FAE950",
                    base: "#FAEE87"
                },
                Violet: {
                    title: "#D159DE",
                    base: "#E797F0"
                },
                Orange: {
                    title: "#FFB061",
                    base: "#FFCA96"
                }
            };
        }

        function onSaveSuccess (result) {
            loadEquipes();
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('EquipeCopyModalController', EquipeCopyModalController);

    EquipeCopyModalController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'Equipe','AlertService'];

    function EquipeCopyModalController ($timeout, $scope, $stateParams, $uibModalInstance, Equipe, AlertService) {

        var vm = this;

        vm.date = $stateParams.date;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.date = false;
        vm.selectedDate = null;
        vm.copyToDate = copyToDate;
        vm.copyErrorMsg = "";

        function copyToDate(){
            var formattedDate = moment(new Date(vm.date)).format('YYYY-MM-DD');
            var formattedDateTarget = moment(new Date(vm.selectedDate)).format('YYYY-MM-DD');
            Equipe.copyToDate({
                    date: formattedDate,
                    dateTarget: formattedDateTarget,
                },
                function onSuccess(data) {
                    if (data.length > 0) {
                        showCopyErrorMsg(data);
                    } else {
                        clear();
                    }
                },
                function onError(error) {
                    AlertService.error(error.data.message)
                });
        }

        function showCopyErrorMsg(data) {
            if(data.length > 1) {
                vm.copyErrorMsg = "Echec de la copie car " + data.join(", ") + " ne sont pas disponibles pour le jour selectionné.";
            } else if(data.length === 1){
                vm.copyErrorMsg = "Echec de la copie car " + data.join(", ") + " n'est pas disponible pour le jour selectionné.";
            }

            setTimeout(function() {
                vm.copyErrorMsg = "";
                $scope.$apply();
            }, 10000);
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('equipe', {
                parent: 'gestion',
                url: '/equipes?dateCalendar&page&sort&year&month&week&chef',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'tmgApp.equipe.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/equipe/equipe.html',
                        controller: 'EquipeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    dateCalendar:null,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    year:null,
                    month:null,
                    chef: null,
                    week: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            dateCalendar: $stateParams.dateCalendar,
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            year: $stateParams.year,
                            month: $stateParams.month,
                            chef: $stateParams.chef,
                            week: $stateParams.week,
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('equipe');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('equipe.copy', {
                parent: 'equipe',
                url: '/copy/{date}',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams','$state', '$uibModal', function($stateParams, $state, $uibModal)  {
                    $uibModal.open({
                        templateUrl: 'app/entities/equipe/equipe-copy-modal.html',
                        controller: 'EquipeCopyModalController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {}
                    }).result.then(function() {
                        $state.go('equipe', null, { reload: 'equipe' });
                    }, function() {
                        $state.go('equipe', null, { reload: true });
                    });
                }]
            })
            .state('equipe.edit', {
                parent: 'equipe',
                url: '/{date}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/equipe/equipe-dialog.html',
                        controller: 'EquipeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'l',
                        windowClass: 'modal-l',
                    }).result.then(function() {
                        $state.go('equipe', null, { reload: 'equipe' });
                    }, function() {
                        $state.go('equipe', null, { reload: true });
                    });
                }]
            })
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Equipe', Equipe);

    Equipe.$inject = ['$resource', 'DateUtils'];

    function Equipe ($resource, DateUtils) {
        var resourceUrl =  'api/equipes/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                url:'api/equipes',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'importEquipeMultiple' : {
                method: 'POST',
                url: 'api/equipes/importMultiple',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'processByFilter': {
                method: 'POST',
                url: 'api/equipes/processByFilter',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'getByDate': {
                method: 'GET',
                url: 'api/equipes/get-by-date',
                params: {
                    date: '@date',
                },
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].date = DateUtils.convertLocalDateFromServer(data[i].date);
                        }
                    }
                    return data;
                }
            },
            'copyToNextDay': {
                method: 'POST',
                url: 'api/equipes/copy-to-next-day',
                params: {
                    date: '@date',
                },
                isArray: true,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'copyToDate': {
                method: 'POST',
                url: 'api/equipes/copy-to-date',
                params: {
                    date: '@date',
                    dateTarget: '@dateTarget'
                },
                isArray: true,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'copyToAllWeek': {
                method: 'POST',
                url: 'api/equipes/copy-to-all-week',
                params: {
                    date: '@date',
                },
                isArray: true,
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCurrentWeek': {
                method: 'GET',
                url: 'api/equipes/get-by-week',
                params: {
                    start: '@start',
                    end: '@end'
                },
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].date = DateUtils.convertLocalDateFromServer(data[i].date);
                        }
                    }
                    return data;
                }
            },
            'getByDatesAndTech': {
                method: 'GET',
                url: 'api/equipes/get-by-dates-and-technicien',
                params: {
                    start: '@start',
                    end: '@end',
                    technicien: '@technicien'
                },
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].dateStart = DateUtils.convertLocalDateFromServer(data[i].dateStart);
                            data[i].dateEnd = DateUtils.convertLocalDateFromServer(data[i].dateEnd);
                        }
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('EquipeController', EquipeController);

    EquipeController.$inject = ['$state', '$scope', 'Equipe', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Technicien', 'GroupePlanning', 'Outil'];

    function EquipeController($state, $scope, Equipe, ParseLinks, AlertService, paginationConstants, pagingParams, Technicien, GroupePlanning, Outil) {
        var vm = this;

        vm.equipes = {};
        vm.outils = [];
        vm.filterYear = null;
        vm.filterWeek = null;
        vm.filterDate = null;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.yearDispo = [];
        vm.parseNumberToMonth = parseNumberToMonth;
        vm.copyToNextDay = copyToNextDay;
        vm.copyToAllWeek = copyToAllWeek;
        vm.copyErrorMsg = "";
        vm.colors = null;
        vm.openModal = openModal;
        vm.filterByWeekNumber = filterByWeekNumber;
        vm.filterByDate = filterByDate;
        vm.isGroupeEmpty = isGroupeEmpty;
        vm.isShowOutilTrue = isShowOutilTrue;

        vm.getTechNumberForDay = getTechNumberForDay;

        vm.currentWeek = pagingParams.dateCalendar ? getWeekFromDate(getStartOfWeek(new Date(pagingParams.dateCalendar))) : getWeekFromDate(getStartOfWeek(new Date()));
        vm.weekNumber = getWeekNumber(new Date(vm.currentWeek[0]));

        loadAll();
        loadOutil();
        loadTechniciens();
        loadAvailableTechniciensByDate();
        loadGroupesPlanning();
        createArrayOfYear();
        defineColors();
        function isGroupeEmpty(id, date) {
            var formatDate = date.toDateString();
            if (vm.equipes[formatDate] !== undefined){
                if (vm.equipes[formatDate][id] !== undefined){
                    return false;
                }
            }
            return true;
            // //si on ne doit pas afficher le groupe uniquement lorsqu'il n'est pas present durant toute la semaine:
            // for (var date in vm.equipes) {
            //     if (vm.equipes[date][id]) {
            //         return false;
            //     }
            // }
            // return true;
        }

        function openModal(id){
            var modalInstance = $uibModal.open({
                template: '<div class="modal-header"><h3>Titre de ma modal</h3></div><div class="modal-body">Contenu de ma modal...</div><div class="modal-footer"><button class="btn btn-primary" ng-click="vm.closeModal()">OK</button></div>',
                controller: 'EquipeController as vm'
            });

            modalInstance.result.then(function() {}, function() {});
        }

        function closeModal(id) {
            $uibModalInstance.close();
        }

        function copyToAllWeek(date) {
            var formattedDate = moment(new Date(date)).format('YYYY-MM-DD');
            Equipe.copyToAllWeek({
                    date: formattedDate,
                },
                function onSuccess(data) {
                    if (data.length > 0) {
                        showCopyErrorMsg(data);
                    }
                    loadAll();
                },
                function onError(error) {
                    AlertService.error(error.data.message);
                }
            );
        }

        function copyToNextDay(date) {
            var formattedDate = moment(new Date(date)).format('YYYY-MM-DD');
            Equipe.copyToNextDay({
                    date: formattedDate,
                },
                function onSuccess(data) {
                    if (data.length > 0) {
                        showCopyErrorMsg(data);
                    }
                    loadAll();
                },
                function onError(error) {
                    AlertService.error(error.data.message);
                });
        }

        function showCopyErrorMsg(data) {
            if(data.length > 1) {
                vm.copyErrorMsg = "Les techniciens " + data.join(", ") + " ne sont pas disponibles pour la journée selectionnée.";
            } else if(data.length === 1){
                vm.copyErrorMsg = "Le technicien " + data.join(", ") + " n'est pas disponible pour la journée selectionnée.";
            }

            setTimeout(function() {
                vm.copyErrorMsg = "";
                $scope.$apply();
            }, 30000);
        }

        function getWeekNumber(date){
            date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

            date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));

            var yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));

            return Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
        }

        function filterByWeekNumber() {
            var yearStart;
            if(vm.filterYear != null){
                yearStart = new Date(vm.filterYear, 0, 1);
            }else{
                var now = new Date();
                yearStart = new Date(now.getFullYear(), 0, 1);
            }
            var msPerDay = 24 * 60 * 60 * 1000;

            // Trouver le premier jeudi de l'année
            var thursdayOfYear = yearStart;
            while (thursdayOfYear.getDay() !== 4) {  // 4 est pour jeudi
                thursdayOfYear = new Date(thursdayOfYear.getTime() + msPerDay);
            }

            // Calculer le premier lundi avant ou le jour de ce jeudi
            var mondayOfYear = new Date(thursdayOfYear.getTime() - (thursdayOfYear.getDay() - 1) * msPerDay);

            // Calculer le nombre de jours depuis ce lundi
            var daysFromFirstMonday = (vm.filterWeek - 1) * 7;
            var newDate = new Date(mondayOfYear.getTime() + daysFromFirstMonday * msPerDay);

            pagingParams.dateCalendar = moment(newDate).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                dateCalendar: pagingParams.dateCalendar
            });
        }

        function filterByDate() {
            pagingParams.dateCalendar = moment(vm.filterDate).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                dateCalendar: pagingParams.dateCalendar
            });
        }

        function getStartOfWeek(date) {
            var day = date.getDay();
            var difference = date.getDate() - day + (day === 0 ? -6 : 1);
            return new Date(date.setDate(difference));
        }

        function getWeekFromDate(startDate) {
            var week = [];
            for (var i = 0; i < 6; i++) {
                var newDate = new Date(startDate);
                newDate.setDate(newDate.getDate() + i);
                week.push(newDate);
            }
            return week;
        }

        vm.nextWeek = function () {
            var newDate = new Date(vm.currentWeek[0]);
            newDate.setDate(newDate.getDate() + 7);
            pagingParams.dateCalendar = moment(newDate).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                dateCalendar: pagingParams.dateCalendar
            });
        };

        vm.previousWeek = function () {
            var newDate = new Date(vm.currentWeek[0]);
            newDate.setDate(newDate.getDate() - 7);
            pagingParams.dateCalendar = moment(newDate).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                dateCalendar: pagingParams.dateCalendar
            });
        };

        vm.actualWeek = function () {
            var newDate = new Date();
            pagingParams.dateCalendar = moment(newDate).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                dateCalendar: pagingParams.dateCalendar
            });
        };

        vm.getTeamForDate = function(date) {
            for (var i = 0; i < vm.equipes.length; i++) {
                if (vm.equipes[i].date.toDateString() === date.toDateString()) {
                    return vm.equipes[i];
                }
            }
            return null;
        };

        function loadAll() {
            Equipe.getCurrentWeek({
                start: vm.currentWeek[0].toISOString().split('T')[0],
                end: vm.currentWeek[vm.currentWeek.length - 1].toISOString().split('T')[0]
            },
            function onSuccess(data, headers) {
                vm.equipes = {};
                data.forEach(function(equipe) {
                    var date = new Date(equipe.date).toDateString();
                    var groupePlanningId = equipe.groupePlanningId;
                    if (vm.equipes[date] === undefined) {
                        vm.equipes[date] = {};
                    }
                    if (groupePlanningId !== null){
                        if (vm.equipes[date][groupePlanningId] === undefined) {
                            vm.equipes[date][groupePlanningId] = [];
                        }
                        vm.equipes[date][groupePlanningId].push(equipe);
                    }else {
                        if (vm.equipes[date]['withoutGroupePlanning'] === undefined) {
                            vm.equipes[date]['withoutGroupePlanning'] = [];
                        }
                        vm.equipes[date]['withoutGroupePlanning'].push(equipe);
                    }
                });
            },
            function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadOutil() {
            return Outil.getEnabled({ }, function onSuccess(data, headers) {
                data.forEach(function(outil){
                    outil.dropdownDisplay = outil.code + ': ' + outil.name;
                });
                vm.outils = data;

            }, function onError(error) {
                AlertService.error(error.data.message);
            }).$promise;
        }

        vm.getTeamsForDate = function(date) {
            var teams = [];
            for (var i = 0; i < vm.equipes.length; i++) {
                if (new Date(vm.equipes[i].date).toDateString() === date.toDateString()) {
                    teams.push(vm.equipes[i]);
                }
            }
            return teams;
        };

        function getTechNumberForDay(day) {
            var equipesOfTheDay = vm.equipes[day.toDateString()];
            var techNumber = 0;
            if (equipesOfTheDay) {
                for (var groupe in equipesOfTheDay) {
                    var equipes = equipesOfTheDay[groupe];

                    for (var i = 0; i < equipes.length; i++) {
                        techNumber++;

                        if (equipes[i].binome) {
                            techNumber++;
                        }
                    }
                }
            }
            return techNumber;
        }

        function isShowOutilTrue(code) {
            for (var i = 0; i < vm.outils.length; i++) {
                var outil = vm.outils[i];
                if (outil.code === code) {
                    return outil.showPlanning === true;
                }
            }

            return false;
        }

        vm.formatDate = function(date){
            return new Date(date).toISOString().split('T')[0];
        };

        vm.formatTechName = function(technicien) {
            var parts = technicien.split(" ");
            var prenom = parts[0];
            var nom = parts[1];
            return prenom + " " + nom.charAt(0);
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadAvailableTechniciensByDate() {
            Technicien.getAvailableTechByDatesForPlanning({
                dateStart: vm.currentWeek[0].toISOString().split('T')[0],
                dateEnd: vm.currentWeek[vm.currentWeek.length - 1].toISOString().split('T')[0]
            }, function onSuccess(data, headers) {
                vm.availableTechniciensDates = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadTechniciens(){
            Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadGroupesPlanning() {
            GroupePlanning.getEnabled({ }, function onSuccess(data, headers) {
                vm.groupesPlanning = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function defineColors(){
            vm.colors = {
                Gris: {
                    title: "#8C8C8B",
                    base: "#BDBDBD",
                },
                Bleu: {
                    title: "#6590EB",
                    base: "#A5C0FA"
                },
                Vert: {
                    title: "#58BF64",
                    base: "#9BE8A5"
                },
                Rouge: {
                    title: "#F56464",
                    base: "#FCB1B1"
                },
                Jaune: {
                    title: "#FAE950",
                    base: "#FAEE87"
                },
                Violet: {
                    title: "#D159DE",
                    base: "#E797F0"
                },
                Orange: {
                    title: "#FFB061",
                    base: "#FFCA96"
                }
            };
        }

        function parseNumberToMonth(month) {
            var today = Date.now();
            var date = moment(today);
            date.set('Month',month);
            return date.format("MMMM");
        }

        function createArrayOfYear() {
            var currentDate = new Date();
            for (var i = 2020; i <= currentDate.getFullYear()+1 ; i++) {
                vm.yearDispo.push(i);
            }
        }

        vm.getTooltipContent = function(outils) {
            return outils.join('\n');
        };

        setTimeout(function () {
            var tooltipTriggerList = Array.prototype.slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.forEach(function (tooltipTriggerEl) {
                new bootstrap.Tooltip(tooltipTriggerEl);
            });
        }, 0);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('CongesDialogController', CongesDialogController);

    CongesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$uibModal' , 'entity', 'Conges', 'Technicien', 'Principal', '$state', 'Equipe', 'DateUtils'];

    function CongesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $uibModal,entity, Conges, Technicien, Principal, $state, Equipe, DateUtils) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.conges.technicien = $('#field_technicien :selected').val();
            });
        });
        var vm = this;

        vm.conges = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.deleteConge = deleteConge;
        vm.equipes = [];
        vm.isAdmin = false;
        vm.loadEquipes = loadEquipes;

        Principal.identity().then(function(account) {
            if (account.technicien) {
                vm.techFullDisplayname = account.technicien.displayname;
            }
            vm.isAdmin = account.authorities.indexOf("ROLE_ADMIN") === 1
        });

        loadTechniciens();
        firstLoadEquipes()

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.conges.id !== null) {
                Conges.update(vm.conges, onSaveSuccess, onSaveError);
            } else {
                Conges.save(vm.conges, onSaveSuccess, onSaveError);
            }
        }

        function firstLoadEquipes() {
            if (vm.conges.id) {
                loadEquipes();
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:congesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.dateEnd = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadTechniciens(){
        	Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadEquipes(){
            if(!vm.conges.date || !vm.conges.dateEnd || !vm.conges.technicien) return;

            var start = DateUtils.convertLocalDateToServer(vm.conges.date);
            var end = DateUtils.convertLocalDateToServer(vm.conges.dateEnd);

            Equipe.getByDatesAndTech({
                start: start,
                end: end,
                technicien: vm.conges.technicien
            },
            function onSuccess(data, headers) {
                vm.equipes = data;
            },
            function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function deleteConge(id) {
            $uibModal.open({
                templateUrl: 'app/entities/conges/conges-delete-dialog.html',
                controller: 'CongesDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Conges', function(Conges) {
                        return Conges.get({id : id}).$promise;
                    }]
                }
            }).result.then(function() {
                $uibModalInstance.close(true);
                $state.reload();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('CongesDetailController', CongesDetailController);

    CongesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Conges'];

    function CongesDetailController($scope, $rootScope, $stateParams, previousState, entity, Conges) {
        var vm = this;

        vm.conges = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:congesUpdate', function(event, result) {
            vm.conges = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('CongesDeleteController',CongesDeleteController);

    CongesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Conges'];

    function CongesDeleteController($uibModalInstance, entity, Conges) {
        var vm = this;

        vm.conges = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Conges.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('conges', {
            parent: 'technicienMenu',
            url: '/conges?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.conges.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conges/conges.html',
                    controller: 'CongesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conges');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('conges-detail', {
            parent: 'conges',
            url: '/conges/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.conges.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/conges/conges-detail.html',
                    controller: 'CongesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('conges');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Conges', function($stateParams, Conges) {
                    return Conges.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'conges',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('conges-detail.edit', {
            parent: 'conges-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-dialog.html',
                    controller: 'CongesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conges', function(Conges) {
                            return Conges.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conges.new', {
            parent: 'conges',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-dialog.html',
                    controller: 'CongesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                dateEnd: null,
                                paid: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('conges', null, { reload: 'conges' });
                }, function() {
                    $state.go('conges');
                });
            }]
        })
        .state('conges.edit', {
            parent: 'conges',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-dialog.html',
                    controller: 'CongesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conges', function(Conges) {
                            return Conges.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conges', null, { reload: 'conges' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('conges.delete', {
            parent: 'conges',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-delete-dialog.html',
                    controller: 'CongesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Conges', function(Conges) {
                            return Conges.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('conges', null, { reload: 'conges' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Conges', Conges);

    Conges.$inject = ['$resource', 'DateUtils'];

    function Conges ($resource, DateUtils) {
        var resourceUrl =  'api/conges/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.dateEnd = DateUtils.convertLocalDateFromServer(data.dateEnd);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.dateEnd = DateUtils.convertLocalDateToServer(copy.dateEnd);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.dateEnd = DateUtils.convertLocalDateToServer(copy.dateEnd);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('CongesController', CongesController);

    CongesController.$inject = ['$state', 'Conges', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CongesController($state, Conges, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.filterTechnicien = pagingParams.technicien;

        loadAll();
        loadTechniciens();

        function loadAll () {
            Conges.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.conges = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function loadTechniciens(){
        	Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ConfigDialogController', ConfigDialogController);

    ConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Config', 'DateUtils'];

    function ConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Config, DateUtils) {
        var vm = this;

        vm.config = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.config.id !== null) {
                Config.update(vm.config, onSaveSuccess, onSaveError);
            } else {
                Config.save(vm.config, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            // Si on a modifié la période de paie, on invalide le cache du DateUtils
            // pour que la nouvelle valeur soit relue au prochain calcul de période.
            if (result && result.name === 'payroll_cutoff_day') {
                DateUtils.invalidateCutoffDay();
            }
            $scope.$emit('tmgApp:configUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ConfigDetailController', ConfigDetailController);

    ConfigDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Config'];

    function ConfigDetailController($scope, $rootScope, $stateParams, previousState, entity, Config) {
        var vm = this;

        vm.config = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:configUpdate', function(event, result) {
            vm.config = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ConfigDeleteController',ConfigDeleteController);

    ConfigDeleteController.$inject = ['$uibModalInstance', 'entity', 'Config'];

    function ConfigDeleteController($uibModalInstance, entity, Config) {
        var vm = this;

        vm.config = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Config.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('config', {
            parent: 'gestion',
            url: '/config?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.config.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/config/configs.html',
                    controller: 'ConfigController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('config');
                    $translatePartialLoader.addPart('configType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('config-detail', {
            parent: 'config',
            url: '/config/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.config.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/config/config-detail.html',
                    controller: 'ConfigDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('config');
                    $translatePartialLoader.addPart('configType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Config', function($stateParams, Config) {
                    return Config.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'config',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('config-detail.edit', {
            parent: 'config-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/config/config-dialog.html',
                    controller: 'ConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Config', function(Config) {
                            return Config.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('config.new', {
            parent: 'config',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/config/config-dialog.html',
                    controller: 'ConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                type: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('config', null, { reload: 'config' });
                }, function() {
                    $state.go('config');
                });
            }]
        })
        .state('config.edit', {
            parent: 'config',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/config/config-dialog.html',
                    controller: 'ConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Config', function(Config) {
                            return Config.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('config', null, { reload: 'config' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('config.delete', {
            parent: 'config',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/config/config-delete-dialog.html',
                    controller: 'ConfigDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Config', function(Config) {
                            return Config.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('config', null, { reload: 'config' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Config', Config);

    Config.$inject = ['$resource'];

    function Config ($resource) {
        var resourceUrl =  'api/configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByName': {
                url: 'api/configs/name/:name',
                method: 'GET',
                hasBody: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ConfigController', ConfigController);

    ConfigController.$inject = ['$state', 'Config', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ConfigController($state, Config, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Config.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.configs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ChargeTechnicienDialogController', ChargeTechnicienDialogController);

    ChargeTechnicienDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChargeTechnicien', 'Technicien'];

    function ChargeTechnicienDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChargeTechnicien, Technicien) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.newTech = $('#field_technicien :selected').val();
            });
            adaptCustomFormError();
        });
        var vm = this;

        vm.chargeTechnicien = entity;
        vm.clear = clear;
        vm.addTech = addTech;
        vm.removeTech = removeTech;
        vm.save = save;
        vm.isSaving = false;

        vm.customFormError = true
        vm.newTech = null;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.date = false;

        loadTechniciens();

        function save() {
            var date = new Date(vm.chargeTechnicien.date);
            date.setHours(date.getHours() + 2);
            vm.chargeTechnicien.date = date.toISOString();
            vm.isSaving = true;
            if (vm.chargeTechnicien.id !== null){
                ChargeTechnicien.update(vm.chargeTechnicien, onSaveSuccess, onSaveError);
            } else {
                ChargeTechnicien.save(vm.chargeTechnicien, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
                vm.newTech = vm.techniciens[0];
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function addTech() {
            if(vm.chargeTechnicien.techniciens == null){
                vm.chargeTechnicien.techniciens = [];
            }

            //verifie si le technicien a déjà été ajouté
            if (vm.newTech){
                if (vm.chargeTechnicien.techniciens.indexOf(vm.newTech) === -1) {
                    vm.chargeTechnicien.techniciens.push(vm.newTech);
                    adaptCustomFormError();
                }
            }
        }

        function removeTech(technicien) {
            var index = vm.chargeTechnicien.techniciens.indexOf(technicien);
            if (index !== -1) {
                vm.chargeTechnicien.techniciens.splice(index, 1);
                adaptCustomFormError();
            }
        }

        function adaptCustomFormError() {
            if (vm.chargeTechnicien.techniciens){
                vm.customFormError = !(vm.chargeTechnicien.techniciens.length > 0);
            }else {
                vm.customFormError = true;
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ChargeTechnicienDetailController', ChargeTechnicienDetailController);

    ChargeTechnicienDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ChargeTechnicien'];

    function ChargeTechnicienDetailController($scope, $rootScope, $stateParams, previousState, entity, ChargeTechnicien) {
        var vm = this;

        vm.chargeTechnicien = entity;
        vm.previousState = previousState.name;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ChargeTechnicienDeleteController',ChargeTechnicienDeleteController);

    ChargeTechnicienDeleteController.$inject = ['$uibModalInstance', 'entity', 'ChargeTechnicien'];

    function ChargeTechnicienDeleteController($uibModalInstance, entity, ChargeTechnicien) {
        var vm = this;

        vm.chargeTechnicien = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ChargeTechnicien.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('charge-technicien', {
                url: '/charge-technicien?technicien&date&year&month&page&sort',
                parent: 'gestion',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Charge technicien'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/charge-technicien/charge-technicien.html',
                        controller: 'ChargeTechnicienController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'date,desc',
                        squash: true
                    },
                    technicien: null,
                    date: null,
                    dateFrom: null,
                    dateTo: null,
                    month: null,
                    year: null,

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            technicien: $stateParams.technicien,
                            date: $stateParams.date,
                            year: $stateParams.year,
                            month: $stateParams.month,
                            dateFrom: $stateParams.dateFrom,
                            dateTo: $stateParams.dateTo,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('charge-technicien.new', {
                parent: 'charge-technicien',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/charge-technicien/charge-technicien-dialog.html',
                        controller: 'ChargeTechnicienDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    techniciens: null,
                                    intervention: null,
                                    date: null,
                                    description: null,
                                    type: null,
                                    charge: null,
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('charge-technicien', null, { reload: 'charge-technicien' });
                    }, function() {
                        $state.go('charge-technicien');
                    });
                }]
            })
            .state('charge-technicien.edit', {
                parent: 'charge-technicien',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/charge-technicien/charge-technicien-dialog.html',
                        controller: 'ChargeTechnicienDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ChargeTechnicien', function(ChargeTechnicien) {
                                return ChargeTechnicien.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('charge-technicien', null, { reload: 'charge-technicien' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('charge-technicien-detail', {
                parent: 'charge-technicien',
                url: '/charge-technicien/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    // pageTitle: 'tmgApp.groupePlanning.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/charge-technicien/charge-technicien-detail.html',
                        controller: 'ChargeTechnicienDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ChargeTechnicien', function($stateParams, ChargeTechnicien) {
                        return ChargeTechnicien.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'charge-technicien',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('charge-technicien.delete', {
                parent: 'charge-technicien',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/charge-technicien/charge-technicien-delete-dialog.html',
                        controller: 'ChargeTechnicienDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ChargeTechnicien', function(ChargeTechnicien) {
                                return ChargeTechnicien.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('charge-technicien', null, { reload: 'charge-technicien' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('ChargeTechnicien', ChargeTechnicien);

    ChargeTechnicien.$inject = ['$resource', 'DateUtils'];

    function ChargeTechnicien ($resource, DateUtils) {
        var resourceUrl =  'api/charge-technicien/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByIntervention': {
                method: 'GET',
                url: 'api/charge-technicien/intervention',
                params: {
                    interventionId: '@interventionId'
                },
                isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'regulChargeForActivity' : {
                method:'POST',
                url: 'api/charge-technicien/regulForActivity',
                hasBody:true,
                isArray: false,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'addChargePreviousMonth': {
                method: 'POST',
                url: 'api/charge-technicien/addChargePreviousMonth',
                isArray: true
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ChargeTechnicienController', ChargeTechnicienController);

    ChargeTechnicienController.$inject = ['$state', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ChargeTechnicien', 'Technicien'];

    function ChargeTechnicienController($state, ParseLinks, AlertService, pagingParams, paginationConstants, ChargeTechnicien, Technicien) {
        var vm = this;

        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.filterTechnicien = pagingParams.technicien;
        vm.filterDate = pagingParams.date;
        vm.filterDateFrom = pagingParams.dateFrom;
        vm.filterDateTo = pagingParams.dateTo;

        vm.selectedYear = pagingParams.year;
        vm.selectedMonth = pagingParams.month;

        vm.search = search;
        vm.transition = transition;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.filterDate = false;
        vm.datePickerOpenStatus.filterMonth = false
        vm.yearDispo = [];
        vm.months = [
            { value: 1, name: 'Janvier' },
            { value: 2, name: 'Février' },
            { value: 3, name: 'Mars' },
            { value: 4, name: 'Avril' },
            { value: 5, name: 'Mai' },
            { value: 6, name: 'Juin' },
            { value: 7, name: 'Juillet' },
            { value: 8, name: 'Août' },
            { value: 9, name: 'Septembre' },
            { value: 10, name: 'Octobre' },
            { value: 11, name: 'Novembre' },
            { value: 12, name: 'Décembre' }
        ];
        vm.filterByPeriod = filterByPeriod;

        loadAll();
        loadTechniciens();
        createArrayOfYear();

        function loadAll () {
            ChargeTechnicien.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                date: vm.filterDate,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),];
                result.push('id');
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.chargeTechnicien = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function filterByPeriod() {
            if (vm.selectedMonth) {
                //filtrer par mois
                var selectedMonth = parseInt(vm.selectedMonth);
                var year = vm.selectedYear ? vm.selectedYear : new Date().getFullYear();

                var startDate = new Date(year, selectedMonth - 1, 1);
                var endDate = new Date(year, selectedMonth, 0);

                vm.filterDateFrom = formatDate(startDate);
                vm.filterDateTo = formatDate(endDate);
            } else {
                if (vm.selectedYear){
                    //filtrer par année
                    vm.filterDateFrom = formatDate(new Date(vm.selectedYear, 0, 1));
                    vm.filterDateTo = formatDate(new Date(vm.selectedYear, 11, 31));
                }
                else {
                    vm.filterDateFrom = null;
                    vm.filterDateTo = null;
                }
            }
        }

        function formatDate(date) {
            return new Date(date).toISOString().split('T')[0];
        }

        function createArrayOfYear() {
            var currentDate = new Date();
            for (var i = 2020; i <= currentDate.getFullYear()+1 ; i++) {
                vm.yearDispo.push(i);
            }
        }

        function search(){
            vm.transition();
        }

        function transition() {
            var params = createChargeTechnicienFilter();
            params.page = vm.page;
            params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            $state.transitionTo($state.$current, params);
        }
        function createChargeTechnicienFilter(){
            return {
                technicien: vm.filterTechnicien,
                date: vm.filterDate,
                month: vm.selectedMonth,
                year: vm.selectedYear,
                dateFrom: vm.filterDateFrom,
                dateTo: vm.filterDateTo,
            }
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreintePlanifieNotWorkController', AstreintePlanifieNotWorkController);

    AstreintePlanifieNotWorkController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'AstreintePlanifie', 'Technicien', '$state'];

    function AstreintePlanifieNotWorkController ($timeout, $scope, $stateParams, $uibModalInstance, $uibModal,entity, AstreintePlanifie, Technicien, $state) {
        var vm = this;

        vm.astreintePlanifie = entity;
        vm.clear = clear;
        vm.save = save;

        loadTechniciens();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.astreintePlanifie.id !== null) {
                AstreintePlanifie.asknotwork(vm.astreintePlanifie, onSaveSuccess, onSaveError);
            } else {
                AstreintePlanifie.save(vm.astreintePlanifie, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:astreintePlanifieUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function loadTechniciens(){
            Technicien.query({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreintePlanifieDialogController', AstreintePlanifieDialogController);

    AstreintePlanifieDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'AstreintePlanifie', 'Technicien', '$state', 'Astreinte', 'AlertService'];

    function AstreintePlanifieDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $uibModal,entity, AstreintePlanifie, Technicien, $state, Astreinte, AlertService) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.astreintePlanifie.technicien = $('#field_technicien :selected').val();
            });
        });
        var vm = this;

        vm.astreintePlanifie = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.deleteAstreintePlanified = deleteAstreintePlanified;
        vm.frequenceActive = false;
        vm.isDatePast = isDatePast;
        vm.astreinteHours = 7;
        vm.createAstreinteRealise = createAstreinteRealise;

        loadTechniciens();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.astreintePlanifie.id !== null) {
                AstreintePlanifie.update(vm.astreintePlanifie, onSaveSuccess, onSaveError);
            } else {
                AstreintePlanifie.save(vm.astreintePlanifie, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:astreintePlanifieUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function createAstreinteRealise(){
            Astreinte.createFromAstreintePlanifie({astreintePlanifie: vm.astreintePlanifie, hours: vm.astreinteHours}, function onSuccess(data, headers) {
                $uibModalInstance.close(true);
                $state.reload();
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function isDatePast(){
            var date = new Date();
            var dateAstreinte = new Date(vm.astreintePlanifie.date);
            return dateAstreinte < date;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadTechniciens(){
            Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function deleteAstreintePlanified(id) {
            $uibModal.open({
                templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-delete-dialog.html',
                controller: 'AstreintePlanifieDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                        return AstreintePlanifie.get({id : id}).$promise;
                    }]
                }
            }).result.then(function () {
                $uibModalInstance.close(true);
                $state.reload();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreintePlanifieDetailController', AstreintePlanifieDetailController);

    AstreintePlanifieDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AstreintePlanifie', 'Principal'];

    function AstreintePlanifieDetailController($scope, $rootScope, $stateParams, previousState, entity, AstreintePlanifie, Principal) {
        var vm = this;

        vm.astreintePlanifie = entity;
        vm.previousState = previousState.name;
        vm.isAccountProperty = false;

        Principal.identity().then(function(account) {
            if (account.technicien) {
                vm.isAccountProperty = account.technicien.displayname === vm.astreintePlanifie.technicien
            }else if(account.authorities.indexOf("ROLE_ADMIN") !== -1) {
                vm.isAccountProperty = true;
            }
        });

        var unsubscribe = $rootScope.$on('tmgApp:astreintePlanifieUpdate', function(event, result) {
            vm.astreintePlanifie = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreintePlanifieDeleteController',AstreintePlanifieDeleteController);

    AstreintePlanifieDeleteController.$inject = ['$uibModalInstance', 'entity', 'AstreintePlanifie'];

    function AstreintePlanifieDeleteController($uibModalInstance, entity, AstreintePlanifie) {
        var vm = this;

        vm.astreintePlanifie = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id,includeRepeat) {
            AstreintePlanifie.delete({id: id,includeRepeat: includeRepeat},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('astreinte-planifie', {
            parent: 'technicienMenu',
            url: '/astreinte-planifie?page&sort&search&technicien&year&month',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreintePlanifie.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifies.html',
                    controller: 'AstreintePlanifieController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                technicien: null,
                year:null,
                month:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        technicien: $stateParams.technicien,
                        year: $stateParams.year,
                        month: $stateParams.month,
                        search: $stateParams.search,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreintePlanifie');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('astreinte-planifie-detail', {
            parent: 'astreinte-planifie',
            url: '/astreinte-planifie/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreintePlanifie.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-detail.html',
                    controller: 'AstreintePlanifieDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreintePlanifie');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AstreintePlanifie', function($stateParams, AstreintePlanifie) {
                    return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'astreinte-planifie',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('astreinte-planifie-detail.edit', {
            parent: 'astreinte-planifie-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                    controller: 'AstreintePlanifieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte-planifie-detail.asknotwork', {
            parent: 'astreinte-planifie-detail',
            url: '/asknotwork',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-notWork.html',
                    controller: 'AstreintePlanifieNotWorkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte-planifie.new', {
            parent: 'astreinte-planifie',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                    controller: 'AstreintePlanifieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('astreinte-planifie');
                });
            }]
        })
        .state('astreinte-planifie.newMultiple', {
            parent: 'astreinte-planifie',
            url: '/newMultiple',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialogue-multiple.html',
                    controller: 'AstreintePlanifieDialogMultipleController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('astreinte-planifie');
                });
            }]
        })
        .state('astreinte-planifie.edit', {
            parent: 'astreinte-planifie',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                    controller: 'AstreintePlanifieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte-planifie.delete', {
            parent: 'astreinte-planifie',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-delete-dialog.html',
                    controller: 'AstreintePlanifieDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('AstreintePlanifie', AstreintePlanifie);

    AstreintePlanifie.$inject = ['$resource', 'DateUtils'];

    function AstreintePlanifie ($resource, DateUtils) {
        var resourceUrl =  'api/astreinte-planifies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'asknotwork': {
                url: 'api/astreinte-planifies/asknotwork',
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreintePlanifieController', AstreintePlanifieController);

    AstreintePlanifieController.$inject = ['$state', 'AstreintePlanifie', 'Technicien' ,'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AstreintePlanifieController($state, AstreintePlanifie, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicien').on('select2:select', function (e) {
                vm.filterTechnicien = $('#filterTechnicien').val();
                vm.search();
            });
        });

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.filterTechnicien = pagingParams.technicien;
        vm.filterYear = pagingParams.year;
        vm.filterMonth = pagingParams.month;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search=search;
        vm.yearDispo = [];
        vm.parseNumberToMonth = parseNumberToMonth;

        loadAll();
        loadTechniciens();
        createArrayOfYear();

        function parseNumberToMonth(month) {
            var today = Date.now();
            var date = moment(today);
            date.set('Month',month);
            return date.format("MMMM");
        }

        function loadAll () {
            AstreintePlanifie.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                year: vm.filterYear,
                month: vm.filterMonth
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.astreintePlanifies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                technicien: vm.filterTechnicien,
                year: vm.filterYear,
                month: vm.filterMonth
            });
        }

        function search(){
            transition();
        }

        function createArrayOfYear() {
            var currentDate = new Date();
            for (var i = 2020; i <= currentDate.getFullYear()+1 ; i++) {
                vm.yearDispo.push(i);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreinteDialogController', AstreinteDialogController);

    AstreinteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$uibModal', 'entity', 'Astreinte', 'Technicien'];

    function AstreinteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $uibModal, entity, Astreinte, Technicien) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.astreinte.technicien = $(this).val();
            });
        });
        var vm = this;
        vm.astreinte = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.deleteAstreinte = deleteAstreinte;

        loadTechniciens();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.astreinte.id !== null) {
                Astreinte.update(vm.astreinte, onSaveSuccess, onSaveError);
            } else {
                Astreinte.save(vm.astreinte, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:astreinteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadTechniciens(){
        	Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function deleteAstreinte(id) {
            $uibModal.open({
                templateUrl: 'app/entities/astreinte/astreinte-delete-dialog.html',
                controller: 'AstreinteDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Astreinte', function(Astreinte) {
                        return Astreinte.get({id : id}).$promise;
                    }]
                }
            }).result.then(function () {
                $uibModalInstance.close(true);
                $scope.go($state.current, {}, {reload: true});
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreinteDetailController', AstreinteDetailController);

    AstreinteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Astreinte'];

    function AstreinteDetailController($scope, $rootScope, $stateParams, previousState, entity, Astreinte) {
        var vm = this;

        vm.astreinte = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:astreinteUpdate', function(event, result) {
            vm.astreinte = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreinteDeleteController',AstreinteDeleteController);

    AstreinteDeleteController.$inject = ['$uibModalInstance', 'entity', 'Astreinte'];

    function AstreinteDeleteController($uibModalInstance, entity, Astreinte) {
        var vm = this;

        vm.astreinte = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Astreinte.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('astreinte', {
            parent: 'technicienMenu',
            url: '/astreinte?page&sort&search&technicien&year&month',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreinte.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte/astreintes.html',
                    controller: 'AstreinteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                technicien: null,
                year:null,
                month:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        technicien: $stateParams.technicien,
                        year: $stateParams.year,
                        month: $stateParams.month,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreinte');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('astreinte-detail', {
            parent: 'astreinte',
            url: '/astreinte/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreinte.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte/astreinte-detail.html',
                    controller: 'AstreinteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreinte');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Astreinte', function($stateParams, Astreinte) {
                    return Astreinte.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'astreinte',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('astreinte-detail.edit', {
            parent: 'astreinte-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                    controller: 'AstreinteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Astreinte', function(Astreinte) {
                            return Astreinte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte.new', {
            parent: 'astreinte',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                    controller: 'AstreinteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                hours: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astreinte', null, { reload: 'astreinte' });
                }, function() {
                    $state.go('astreinte');
                });
            }]
        })
        .state('astreinte.edit', {
            parent: 'astreinte',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                    controller: 'AstreinteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Astreinte', function(Astreinte) {
                            return Astreinte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte', null, { reload: 'astreinte' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte.delete', {
            parent: 'astreinte',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-delete-dialog.html',
                    controller: 'AstreinteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Astreinte', function(Astreinte) {
                            return Astreinte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte', null, { reload: 'astreinte' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Astreinte', Astreinte);

    Astreinte.$inject = ['$resource', 'DateUtils'];

    function Astreinte ($resource, DateUtils) {
        var resourceUrl =  'api/astreintes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'autoDetect': {
            	url:'api/astreintes/autoDetect',
            	method: 'PUT',
            	hasBody:false
            },
            'createFromAstreintePlanifie': {
                url:'api/astreintes/createFromAstreintePlanifie',
                method: 'POST',
                hasBody: true,
                isArray: false,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.astreintePlanifie.date = DateUtils.convertLocalDateToServer(copy.astreintePlanifie.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreinteController', AstreinteController);

    AstreinteController.$inject = ['$state', 'Astreinte', 'Technicien', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AstreinteController($state, Astreinte, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.yearDispo = [];
        vm.filterTechnicien = pagingParams.technicien;
        vm.filterYear = pagingParams.year;
        vm.filterMonth = pagingParams.month;


        vm.autoDetect = autoDetect;
        vm.parseNumberToMonth = parseNumberToMonth;
        vm.search=search;

        loadAll();
        loadTechniciens();
        createArrayOfYear();

        function loadAll () {
            Astreinte.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                year: vm.filterYear,
                month: vm.filterMonth
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.astreintes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                technicien: vm.filterTechnicien,
                year: vm.filterYear,
                month: vm.filterMonth
            });
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function search(){
            transition();
        }

        function autoDetect(){
        	Astreinte.autoDetect({},function(s){
        		loadAll();
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function createArrayOfYear() {
            var currentDate = new Date();
            for (var i = 2020; i <= currentDate.getFullYear()+1 ; i++) {
                vm.yearDispo.push(i);
            }
        }

        function parseNumberToMonth(month) {
            var today = Date.now();
            var date = moment(today);
            date.set('Month',month);
            return date.format("MMMM");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('tmgApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('ngEnter', ngEnter);

    function ngEnter() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if (event.which === 13) {
                    scope.$apply(function() {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('tmgApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter', '$http', '$q'];

    function DateUtils($filter, $http, $q) {

        // Jour de coupure de la période de paie, lu une fois via /api/configs.
        // Valeur par défaut tant que la requête n'a pas répondu : 26.
        var DEFAULT_CUTOFF_DAY = 26;
        var cutoffDay = DEFAULT_CUTOFF_DAY;
        var cutoffPromise = null;

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat,
            getFirstDayOfMonth: getFirstDayOfMonth,
            getFirstDayOfPeriod: getFirstDayOfPeriod,
            getLastDayOfPeriod: getLastDayOfPeriod,
            getFirstDayOfCivilMonth: getFirstDayOfCivilMonth,
            getLastDayOfCivilMonth: getLastDayOfCivilMonth,
            loadCutoffDay: loadCutoffDay,
            invalidateCutoffDay: invalidateCutoffDay,
            getCutoffDay: getCutoffDay,
            getFirstDayOfPayrollPeriod: getFirstDayOfPayrollPeriod,
            getLastDayOfPayrollPeriod: getLastDayOfPayrollPeriod
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }

        function getFirstDayOfMonth(date) {
            var currentMonth = date.getMonth();
            var currentYear = date.getFullYear();

            var firstDayOfCurrentMonth = new Date(currentYear, currentMonth, 1);

            var lastDayOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0);

            var lastSaturdayOfCurrentMonth = new Date(lastDayOfCurrentMonth);
            var dayOfWeek = lastDayOfCurrentMonth.getDay();

            lastSaturdayOfCurrentMonth.setDate(lastDayOfCurrentMonth.getDate() - ((dayOfWeek + 1) % 7));

            // Vérifier si aujourd'hui est après le dernier samedi du mois en cours
            if (date > lastSaturdayOfCurrentMonth) {
                currentMonth += 1;
                if (currentMonth > 11) {
                    currentMonth = 0;
                    currentYear += 1;
                }
            }

            return new Date(currentYear, currentMonth, 1);
        }

        function getFirstDayOfPeriod(firstDayOfMonth) {
            // dimanche précédent la 1ere semaine du mois

            var daysToSubtract = firstDayOfMonth.getDay();
            var firstSundayBeforeMonth = new Date(firstDayOfMonth);
            firstSundayBeforeMonth.setDate(firstDayOfMonth.getDate() - daysToSubtract);
            firstSundayBeforeMonth.setHours(firstSundayBeforeMonth.getHours() + 3);
            return firstSundayBeforeMonth;
        }

        function getLastDayOfPeriod(firstDayOfMonth) {
            //dernier samedi du mois
            var year = firstDayOfMonth.getFullYear();
            var month = firstDayOfMonth.getMonth();
            var lastDayOfMonth = new Date(year, month + 1, 0);

            var dayOfWeek = lastDayOfMonth.getDay();
            var daysToSubtract = dayOfWeek < 6 ? dayOfWeek + 1 : 0;

            var lastSaturdayOfMonth = new Date(lastDayOfMonth);
            lastSaturdayOfMonth.setDate(lastDayOfMonth.getDate() - daysToSubtract);

            lastSaturdayOfMonth.setHours(lastSaturdayOfMonth.getHours() + 3);
            return lastSaturdayOfMonth;
        }

        function getFirstDayOfCivilMonth(date) {
            return new Date(date.getFullYear(), date.getMonth(), 1);
        }

        function getLastDayOfCivilMonth(date) {
            return new Date(date.getFullYear(), date.getMonth() + 1, 0);
        }

        // Charge le jour de coupure depuis le back. Renvoie une promise qui
        // se résout avec la valeur. Mise en cache : appels suivants instantanés.
        function loadCutoffDay() {
            if (cutoffPromise) {
                return cutoffPromise;
            }
            cutoffPromise = $http.get('api/configs/name/payroll_cutoff_day').then(function (response) {
                if (response && response.data && response.data.value) {
                    var parsed = parseInt(response.data.value, 10);
                    if (!isNaN(parsed) && parsed >= 1 && parsed <= 28) {
                        cutoffDay = parsed;
                    }
                }
                return cutoffDay;
            }, function () {
                return cutoffDay;
            });
            return cutoffPromise;
        }

        function invalidateCutoffDay() {
            cutoffPromise = null;
        }

        function getCutoffDay() {
            return cutoffDay;
        }

        // Premier jour de la période de paie contenant `date`.
        // Ex : cutoff=26, date=10 juin -> 26 mai. date=28 juin -> 26 juin.
        function getFirstDayOfPayrollPeriod(date) {
            var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            if (d.getDate() >= cutoffDay) {
                return new Date(d.getFullYear(), d.getMonth(), cutoffDay);
            }
            return new Date(d.getFullYear(), d.getMonth() - 1, cutoffDay);
        }

        // Dernier jour de la période de paie contenant `date`.
        // = premier jour + 1 mois - 1 jour.
        function getLastDayOfPayrollPeriod(date) {
            var start = getFirstDayOfPayrollPeriod(date);
            var end = new Date(start.getFullYear(), start.getMonth() + 1, start.getDate());
            end.setDate(end.getDate() - 1);
            return end;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            openURL: openURL,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function openURL (url) {
            $window.open(url, '_blank');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('tmgApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();

                if ($state.current.name === 'home') {
                    $state.reload();
                }

                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'fr',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('twoMonthsAdvance', twoMonthsAdvance);

    function twoMonthsAdvance () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc,
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {

            if (!ngModel) {
                return;
            }

            ngModel.$validators.twoMonthsAdvance = function (modelValue) {
                if (ngModel.$isEmpty(modelValue)){
                    return true;
                } else {
                    var MINIMUM_NOTICE_PERIOD_IN_MONTHS = 2;
                    var today = new Date();
                    var earliestAllowedLeaveDate = new Date(today.getFullYear(), today.getMonth() + MINIMUM_NOTICE_PERIOD_IN_MONTHS, today.getDate());
                    var inputDate = new Date(modelValue);

                    return inputDate >= earliestAllowedLeaveDate;
                }
            };
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('tmgApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('tmgApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('tmgApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('tmgApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('calendar', {
            parent: 'app',
            url: '/calendar?dateCalendar',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/calendar/calendar.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                dateCalendar: moment().format("YYYY-MM-DD")
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('astreinte');
                    $translatePartialLoader.addPart('astreintePlanifie');
                    $translatePartialLoader.addPart('conges');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        dateCalendar: $stateParams.dateCalendar
                    }
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Calendar', Calendar);

    Calendar.$inject = ['$resource'];

    function Calendar ($resource) {
        var resourceUrl =  'api/calendar';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                params: {
                    calendarFilter: '@calendarFilter',
                    start: '@start'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .controller('CalendarController', CalendarController);

    CalendarController.$inject = ['$state','$uibModal','AlertService','Conges', 'Calendar', 'Principal', 'pagingParams', 'Config', 'GroupePlanning', 'Equipe', '$q', 'DateUtils'];

    function CalendarController ($state,$uibModal,AlertService, Conges, Calendar, Principal, pagingParams, Config, GroupePlanning, Equipe, $q, DateUtils) {
        //Properties
        var vm = this;
        var isAdmin = false;
        vm.listTechniciens = [];
        vm.existingMonth = moment.months();
        vm.ApiResponseTab = [];
        vm.userEditing = {
            name : "",
        };
        vm.tabCalendar = [];
        vm.configTabLine = [];
        vm.selectedMonth = new Date(pagingParams.dateCalendar);
        vm.currentDate = new Date();
        vm.groupesPlanning = [];
        vm.equipes = [];
        // Bornes de la période de paie courante (ex : 26 mai -> 25 juin).
        // Calculées via DateUtils dès que le jour de coupure est connu.
        vm.periodStart = null;
        vm.periodEnd = null;
        vm.currentPeriodMonth = "";

        //Functions
        // On attend le jour de coupure de paie avant de calculer les bornes et de charger.
        DateUtils.loadCutoffDay().then(function () {
            recomputePeriod();
            Principal.hasAuthority("ROLE_ADMIN").then(function (result) {
                isAdmin = result;
                loadAllData();
            });
        });

        // Recalcule periodStart/periodEnd à partir de vm.selectedMonth.
        function recomputePeriod() {
            vm.periodStart = DateUtils.getFirstDayOfPayrollPeriod(vm.selectedMonth);
            vm.periodEnd = DateUtils.getLastDayOfPayrollPeriod(vm.selectedMonth);
            vm.currentPeriodMonth = formatPeriodMonth();
        }

        // Renvoie la date correspondant à la colonne dayIndex (1-based) du tableau.
        function getDateForDayIndex(dayIndex) {
            var d = new Date(vm.periodStart);
            d.setDate(d.getDate() + (dayIndex - 1));
            return d;
        }
        vm.getDateForDayIndex = getDateForDayIndex;

        vm.updateMonth = updateMonth;
        vm.openModalNewAstreinte = openModalNewAstreinte;
        vm.openModalNewAstreintePlanifie = openModalNewAstreintePlanifie;
        vm.openModalNewConge = openModalNewConge;
        vm.editAstreinte = editAstreinte;
        vm.editAstreintePlanified = editAstreintePlanified;
        vm.editConges = editConges;
        vm.numberOfDaysForMonth = numberOfDaysForMonth;
        vm.defineTdColor = defineTdColor;
        vm.getStrDateForNumDay = getStrDateForNumDay;
        vm.hightlightDayAndBorderWeek = hightlightDayAndBorderWeek;
        vm.numberOfWeek = numberOfWeek;
        vm.colspanCalcul = colspanCalcul;
		vm.rowClass = rowClass;
        vm.hexToRgba = hexToRgba;
        vm.titleCaseWord = titleCaseWord;

        function loadAllData() {
            $q.all([
                loadEquipes(),
                loadAllEventCalendar(),
                loadGroupePlanning()
            ]).then(function() {
                defineColors();
            });
        }
        getConfig();

        function loadGroupePlanning(){
            if(isAdmin){
                return GroupePlanning.query({ }, function onSuccess(data, headers) {
                    vm.groupesPlanning = data;
                }, function onError(error) {
                    AlertService.error(error.data.message);
                }).$promise;
            }
        }

        function loadEquipes() {
            if(isAdmin){
                // Bornes de la période de paie configurable.
                var firstDay = new Date(vm.periodStart);
                firstDay.setHours(firstDay.getHours() + 2);
                var lastDay = new Date(vm.periodEnd);
                lastDay.setHours(lastDay.getHours() + 2);
                return Equipe.getCurrentWeek({
                    start: firstDay.toISOString().split('T')[0],
                    end: lastDay.toISOString().split('T')[0]
                },onSuccess,onError).$promise;

                function onSuccess(data, headers) {
                    vm.equipes = data;
                };
                function onError(error) {
                    AlertService.error(error.data.message);
                };
            }
        }

        function defineColors(){
            vm.colors = {
                Gris: {
                    title: "#8C8C8B",
                    base: "#BDBDBD",
                },
                Bleu: {
                    title: "#6590EB",
                    base: "#A5C0FA"
                },
                Vert: {
                    title: "#58BF64",
                    base: "#9BE8A5"
                },
                Rouge: {
                    title: "#F56464",
                    base: "#FCB1B1"
                },
                Jaune: {
                    title: "#FAE950",
                    base: "#FAEE87"
                },
                Violet: {
                    title: "#D159DE",
                    base: "#E797F0"
                },
                Orange: {
                    title: "#FFB061",
                    base: "#FFCA96"
                }
            };

            //ajouter les couleurs dans vm.tabCalendar
            var groupesMapping = {};
            vm.groupesPlanning.forEach(function(oneGroupe) {
                groupesMapping[oneGroupe.id] = oneGroupe;
            });

            //mapper les equipes par technicien et date pour ameliorer les perfs
            var techDateMapping = {};
            vm.equipes.forEach(function(equipe) {
                var technicienKey1 = equipe.chef + "_" + equipe.date.toDateString();
                techDateMapping[technicienKey1] = groupesMapping[equipe.groupePlanningId].color;

                if (equipe.binome) {
                    var technicienKey2 = equipe.binome + "_" + equipe.date.toDateString();
                    techDateMapping[technicienKey2] = groupesMapping[equipe.groupePlanningId].color;
                }
            });

            vm.tabCalendar.forEach(function(oneTech) {
                //le technicien peut etre null

                if (oneTech[0].technicienName !== null) {
                    var technicienName = oneTech[0].technicienName;
                    oneTech.forEach(function(oneDay) {
                        var key = technicienName + "_" + new Date(oneDay.date).toDateString();
                        if (techDateMapping[key]) {
                            //= le technicien appartient à une equipe pour ce jour
                            oneDay.color = techDateMapping[key];
                        }
                    });
                }
            });

        }

        function hexToRgba(hex, opacity) {
            var bigint = parseInt(hex.slice(1), 16);
            var r = (bigint >> 16) & 255;
            var g = (bigint >> 8) & 255;
            var b = bigint & 255;
            return "rgba(" + r + ", " + g + ", " + b + ", " + opacity + ")";
        }

        function createTabCalendar() {
            for (var user=0; user < vm.listTechniciens.length; user++ ) {
                vm.tabCalendar[user] = [];
                for (var day = 0; day < numberOfDaysForMonth(vm.selectedMonth); day++) {
                    var date = getDateForDayIndex(day + 1);
                    vm.tabCalendar[user][day] = {
                        astreinteId: null,
                        astreintePlanifie: null,
                        conges : [],
                        date: moment(date).format('YYYY-MM-DD'),
                        technicienName: null
                    };
                }
            }
            fillTabCalendar();
        }

        function fillTabCalendar() {
            for (var user = 0; user < vm.listTechniciens.length; user++) {
                for (var day = 0; day < vm.tabCalendar[user].length; day++) {
                    //ajouter le nom de tous les techniciens pour pouvoir afficher les couleurs des equipes
                    vm.tabCalendar[user][day].technicienName = vm.listTechniciens[user];
                    for (var responseAPI = 0; responseAPI < vm.ApiResponseTab[user].length; responseAPI++) {
                        if (vm.ApiResponseTab[user][responseAPI].date === vm.tabCalendar[user][day].date) {
                            vm.tabCalendar[user][day] = vm.ApiResponseTab[user][responseAPI];
                        }else {
                            vm.tabCalendar[user][day].technicienName = vm.listTechniciens[user];
                        }
                    }
                }
            }
        }

        function updateMonth(arg) {
            if (arg === "prev")
                vm.selectedMonth = previousMonth(vm.selectedMonth);
            if (arg === "next")
                vm.selectedMonth = nextMonth(vm.selectedMonth);
            if (arg === "actual")
                vm.selectedMonth = goToCurrent(vm.selectedMonth);
            recomputePeriod();
            pagingParams.dateCalendar = moment(vm.selectedMonth).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                dateCalendar: pagingParams.dateCalendar
            });
        }

        function nextMonth(date) {
            return new Date(date.setMonth(date.getMonth()+1));
        }

        function previousMonth(date) {
            return new Date(date.setMonth(date.getMonth()-1));
        }

        function numberOfDaysForMonth(date) {
            if (!vm.periodStart || !vm.periodEnd) {
                return 0;
            }
            var ms = vm.periodEnd.getTime() - vm.periodStart.getTime();
            return Math.round(ms / (1000 * 60 * 60 * 24)) + 1;
        }

        function goToCurrent() {
            vm.selectedMonth = new Date();
            return vm.selectedMonth;
        }

        function openModalNewAstreintePlanifie() {
            $uibModal.open({
                templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                controller: 'AstreintePlanifieDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            technicien: null,
                            date: null,
                            id: null
                        };
                    }
                }
            }).result.then(function() {
                $state.go('calendar', null, { reload: 'calendar' });
            }, function() {
                $state.go('calendar');
            });
        }

        function editAstreintePlanified(id) {
            if(isAdmin) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                    controller: 'AstreintePlanifieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AstreintePlanifie', function (AstreintePlanifie) {
                            return AstreintePlanifie.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('calendar', null, {reload: 'calendar'});
                }, function () {
                    $state.go('calendar');
                });
            }
        }

        function openModalNewAstreinte() {
            $uibModal.open({
                templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                controller: 'AstreinteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            technicien: null,
                            date: null,
                            hours: null,
                            id: null
                        };
                    }
                }
            }).result.then(function() {
                $state.go('calendar', null, { reload: 'calendar' });
            }, function() {
                $state.go('calendar');
            });
        }

        function editAstreinte(id) {
            if(isAdmin) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte/astreinte-dialog.html',
                    controller: 'AstreinteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Astreinte', function (Astreinte) {
                            return Astreinte.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('calendar', null, {reload: 'calendar'});
                }, function () {
                    $state.go('calendar');
                });
            }
        }

        function editConges(id) {
            if(isAdmin) {
                $uibModal.open({
                    templateUrl: 'app/entities/conges/conges-dialog.html',
                    controller: 'CongesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Conges', function(Conges) {
                            return Conges.get({id : id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('calendar', null, { reload: 'calendar' });
                }, function() {
                    $state.go('calendar');
                });
            }
        }

        function openModalNewConge() {
            $uibModal.open({
                templateUrl: 'app/entities/conges/conges-dialog.html',
                controller: 'CongesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            technicien: null,
                            date: null,
                            dateEnd: null,
                            paid: false,
                            id: null
                        };
                    }
                }
            }).result.then(function() {
                $state.go('calendar', null, { reload: 'calendar' });
            }, function() {
                $state.go('calendar');
            });
        }

        function getConfig() {
            Config.getByName({name: "calendarRowSeparator"}, onSuccess, onError);

            function onSuccess(data) {
                vm.configTabLine = data.value.split(',');
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAllEventCalendar() {
            var dateFrom = new Date(vm.periodStart);
            dateFrom.setHours(dateFrom.getHours() + 2);
            var dateTo = new Date(vm.periodEnd);
            dateTo.setHours(dateTo.getHours() + 2);
            var calendarFilter = {
                dateFrom: dateFrom.toISOString().split('T')[0],
                dateTo: dateTo.toISOString().split('T')[0]
            };

            return Calendar.query(calendarFilter, onSuccess,onError).$promise;

            function onSuccess(data) {
                delete data.$promise;
                delete data.$resolved;
                vm.listTechniciens = Object.keys(data);
                vm.ApiResponseTab = Object.values(data);
                createTabCalendar();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function defineTdColor(event, jour) {
            var classTd = "";
             if (event.astreinteId != null) {
                 classTd+= " tdYellow";
             } else if (event.conges[0] != null) {
				if(!event.conges[0].validate){
					classTd+= " tdRed";
				}else{
                 switch (event.conges[0].status) {
                     case "AT" : classTd+= " tdPink"; break;
                     case "CHP" : classTd+= " tdGrey"; break;
                     case "CP" : classTd+= " tdBlue"; break;
                     case "JR": classTd += " tdGreen"; break;
                     case "JD": classTd += " tdOrange"; break;
                     case "GD": classTd += " tdPurple"; break;
                 }
				}
             } else if (event.astreintePlanifie !== null ) {
                 if (event.astreintePlanifie[0] !== undefined ) {
                     switch (event.astreintePlanifie[0].type) {
                         case "CUIVRE": return "tdGreen";
                         case "FIBRE_CHEF_EQUIPE_BINOME": return "tdYellowChef";
                         case "FIBRE_BINOME": return "tdBeigeBinome";
                         case "FIBRE_CHEF_MONOME": return "tdLightBrown";
                     }
                 }
             }
            var date = getDateForDayIndex(jour);
            if(moment(date).isFerie()){
                classTd+= " tdGreySunday";
            }
            if (moment(date).isoWeekday() === 1 ) {
                classTd+= " borderLeft";
            }else if (moment(date).isoWeekday() === 7 ){
                classTd+= " borderRight tdGreySunday";
            }
             return classTd;
        }

        function numberOfWeek(jour) {
            var date = getDateForDayIndex(jour);
            if (moment(date).isoWeekday() === 4 ) {
                return moment(date).weeks();
            }
        }

        function colspanCalcul(day) {
            var date = getDateForDayIndex(day);
        }

        function getStrDateForNumDay(nbDay) {
            var date = getDateForDayIndex(nbDay);
            return moment(date).format('dd');
        }

        function hightlightDayAndBorderWeek($index) {
            var classTd = null;
            var date = getDateForDayIndex($index + 1);
            if (vm.currentDate.getFullYear() === date.getFullYear()
                && vm.currentDate.getMonth() === date.getMonth()
                && vm.currentDate.getDate() === date.getDate()) {
                classTd = "hightlightDayCalendar";
            }
            if (moment(date).isoWeekday() === 1 ) {
                classTd+= " borderLeft";
            }else if (moment(date).isoWeekday() === 7 ){
                classTd+= " borderRight";
            }
            return classTd;
        }

        function formatPeriodMonth() {
            if (!vm.periodEnd) {
                return "";
            }
            return vm.existingMonth[vm.periodEnd.getMonth()];
        }

        function titleCaseWord(word) {
            if (!word) {
                return word;
            }
            return word[0].toUpperCase() + word.substr(1).toLowerCase();
        }

        function rowClass(key) {
            var classTr = null;
            if (vm.configTabLine.indexOf((key+1).toString()) !== -1) {
                classTr= "bottomBorderBolder";
            }
            return classTr;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('bonusObjWeek', {
            parent: 'app',
            url: '/bonusObjWeek?searchDate',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/bonusObjWeek/bonusObjWeek.html',
                    controller: 'BonusObjWeekController',
                    controllerAs: 'vm'
                }
            },
            params: {
                searchDate: moment().format("YYYY-MM-DD")
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        searchDate: $stateParams.searchDate
                    }
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .controller('BonusObjWeekController', BonusObjWeekController);

    BonusObjWeekController.$inject = ['$state','$uibModal','AlertService','Principal', 'pagingParams','BonusObjWeek','BonusObjWeek'];

    function BonusObjWeekController ($state,$uibModal,AlertService, Principal, pagingParams, BonusObjWeek) {
        //Properties
        var vm = this;
        vm.updateWeek = updateWeek;
        vm.dayOfWeek = ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'];
        vm.selectedWeek = new Date(pagingParams.searchDate);
        vm.existingMonth = moment.months();
        vm.listTechniciens = [];

        //Methods
        vm.updateWeek = updateWeek;
        vm.numberOfWeek = numberOfWeek;
        vm.titleCaseWord = titleCaseWord;
        vm.getDayFromDate = getDayFromDate;
        vm.calculatePoints = calculatePoints;
        vm.calculatePalier= calculatePalier;
        vm.defineTdColor = defineTdColor;
        loadAllEventCalendar();

        function updateWeek(arg) {
            if (arg === "prev")
                vm.selectedWeek = previousWeek(vm.selectedWeek);
            if (arg === "next")
                vm.selectedWeek = nextWeek(vm.selectedWeek);
            if (arg === "actual")
                vm.selectedWeek = goToCurrent(vm.selectedWeek);
            pagingParams.searchDate = moment(vm.selectedWeek).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                searchDate: pagingParams.searchDate
            });
        }

        function loadAllEventCalendar() {
            BonusObjWeek.query({
                searchDate: pagingParams.searchDate
            },onSuccess, onError);
        }

        function onSuccess(data) {
            vm.listTechniciens = Object.keys(data);
            vm.listTechniciens.splice(vm.listTechniciens.length - 2,2);
            vm.ApiResponseTab = Object.values(data);
            vm.ApiResponseTab.splice(vm.ApiResponseTab.length - 2,2);
            console.log(vm.ApiResponseTab)
        }

        function defineTdColor(congeType){
            var classTd = "";
            if(congeType != null ) {
                switch (congeType) {
                    case "AT" : classTd+= " tdPink"; break;
                    case "CHP" : classTd+= " tdGrey"; break;
                    case "CP" : classTd+= " tdBlue"; break;
                    case "JR": classTd += " tdGreen"; break;
                    case "JD": classTd += " tdOrange"; break;
                    case "GD": classTd += " tdPurple"; break;
                }
            }
            return classTd;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function numberOfWeek() {
            return moment(new Date(vm.selectedWeek)).weeks();
        }

        function nextWeek(date) {
            return new Date(date.setDate(date.getDate()+7));
        }

        function previousWeek(date) {
            return new Date(date.setDate(date.getDate()-7));
        }

        function goToCurrent() {
            vm.selectedWeek = new Date();
            return vm.selectedWeek;
        }

        function titleCaseWord(word) {
            if (!word) return word;
            return word[0].toUpperCase() + word.substr(1).toLowerCase();
        }

        function getDayFromDate(day) {
            //find the monday of the week
            return moment(new Date(vm.selectedWeek)).isoWeekday(day).format('DD');
        }

        function calculatePoints(technicienInfo) {
            var points = 0;
            for (var i = 0; i < technicienInfo.days; i++) {
                points += technicienInfo.days[i].pointObj;
            }
            points+= technicienInfo.pointValorisation;
            return points;
        }

        function calculatePalier(number) {
            if (number >= 5 && number < 15) {
                return 1;
            } else if (number >= 15 && number < 25) {
                return 2;
            } else if (number >= 25 && number < 35) {
                return 3;
            }else if (number >= 35 && number < 45) {
                return 4;
            }
        }
    }

})();

(function (){
    'use strict';
    angular
        .module('tmgApp')
        .factory('BonusObjWeek', BonusObjWeek);

    BonusObjWeek.$inject = ['$resource'];

    function BonusObjWeek ($resource) {
        var resourceUrl =  'api/bonusObjWeek';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('bonusObjMonth', {
            parent: 'app',
            url: '/bonusObjMonth?searchDate',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/bonusObjMonth/bonusObjMonth.html',
                    controller: 'BonusObjMonthController',
                    controllerAs: 'vm'
                }
            },
            params: {
                searchDate: moment().format("YYYY-MM-DD")
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        searchDate: $stateParams.searchDate
                    }
                }]
            }
        });
    }
})();



(function (){
    'use strict';
    angular
        .module('tmgApp')
        .factory('BonusObjMonth', BonusObjMonth);

    BonusObjMonth.$inject = ['$resource'];

    function BonusObjMonth ($resource) {
        var resourceUrl =  'api/bonusObjMonth';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('tmgApp')
        .controller('BonusObjMonthController', BonusObjMonthController);

    BonusObjMonthController.$inject = ['$state', '$uibModal', 'AlertService', 'Principal', 'pagingParams', 'BonusObjMonth', 'DateUtils'];

    function BonusObjMonthController($state, $uibModal, AlertService, Principal, pagingParams, BonusObjMonth, DateUtils) {
        var vm = this;

        vm.updateMonth = updateMonth;
        vm.titleCaseWord = titleCaseWord;
        vm.defineTdColor = defineTdColor;
        vm.defineSundayClass = defineSundayClass;
        vm.formatHours = formatHours;
        vm.defineValueClass = defineValueClass;
        vm.showDayPoints = showDayPoints;
        vm.formatHoursRatio = formatHoursRatio;
        vm.formatHoursDelta = formatHoursDelta;
        vm.defineHoursDeltaClass = defineHoursDeltaClass;
        vm.getValorisationTooltip = getValorisationTooltip;
        vm.selectedMonth = new Date(pagingParams.searchDate);
        vm.currentMonthLabel = formatPeriodLabel(vm.selectedMonth);
        vm.existingMonth = moment.months();
        vm.currentPeriodMonth = formatPeriodMonth(vm.selectedMonth);
        vm.dayOfWeekShort = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
        vm.listTechniciens = [];
        vm.daysOfMonth = [];
        vm.showInterventions = false;
        vm.showVehicleHours = true;
        vm.isTechnicien = false;
        vm.selectedFilterTech = null;

        Principal.hasAuthority('ROLE_TECHNICIEN').then(function(result) {
            vm.isTechnicien = result;
            if (result) {
                vm.showVehicleHours = false;
            }
        });

        // Attend le jour de coupure de paie avant de construire les jours et lancer la requête.
        DateUtils.loadCutoffDay().then(function () {
            loadAllEventCalendar();
        });

        function updateMonth(arg) {
            if (arg === "prev") {
                vm.selectedMonth = previousMonth(vm.selectedMonth);
            }
            if (arg === "next") {
                vm.selectedMonth = nextMonth(vm.selectedMonth);
            }
            if (arg === "actual") {
                vm.selectedMonth = goToCurrent();
            }
            vm.currentMonthLabel = formatPeriodLabel(vm.selectedMonth);
            vm.currentPeriodMonth = formatPeriodMonth(vm.selectedMonth);
            pagingParams.searchDate = moment(vm.selectedMonth).format("YYYY-MM-DD");
            $state.transitionTo($state.$current, {
                searchDate: pagingParams.searchDate
            });
        }

        function loadAllEventCalendar() {
            buildDaysOfMonth();
            vm.currentMonthLabel = formatPeriodLabel(vm.selectedMonth);
            vm.currentPeriodMonth = formatPeriodMonth(vm.selectedMonth);

            BonusObjMonth.query({
                searchDate: pagingParams.searchDate
            }, onSuccess, onError);
        }

        function buildDaysOfMonth() {
            // Période de paie configurable (ex : 26 -> 25 du mois suivant).
            var startDate = DateUtils.getFirstDayOfPayrollPeriod(vm.selectedMonth);
            var endDate = DateUtils.getLastDayOfPayrollPeriod(vm.selectedMonth);
            var nbDays = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;

            vm.daysOfMonth = [];
            for (var i = 0; i < nbDays; i++) {
                vm.daysOfMonth.push(moment(startDate).add(i, 'days'));
            }
        }

        function getValorisationTooltip(day) {
            if (!day || !day.valorisations || day.valorisations.length === 0) {
                return '';
            }
            return day.valorisations.map(function(valorisation) {
                var point = valorisation.point > 0 ? '+' + valorisation.point : valorisation.point;
                var commentary = valorisation.commentary ? valorisation.commentary : 'Aucun commentaire';

                return point + ' : ' + commentary;
            }).join(' | ');
        }

        function onSuccess(data) {
            vm.listTechniciens = Object.keys(data);
            vm.listTechniciens.splice(vm.listTechniciens.length - 2,2);
            vm.ApiResponseTab = Object.values(data);
            vm.ApiResponseTab.splice(vm.ApiResponseTab.length - 2,2);
            console.log(vm.ApiResponseTab)
        }

        function defineTdColor(day) {
            if (!day) {
                return "";
            }
            if (day.congeType != null) {
                switch (day.congeType) {
                    case "AT": return " tdPink";
                    case "CHP": return " tdGrey";
                    case "CP": return " tdBlue";
                    case "JR": return " tdGreen";
                    case "JD": return " tdOrange";
                    case "GD": return " tdPurple";
                    default: return "";
                }
            }
            var realisee = parseFloat(day.pointRealisee) || 0;
            var valorisation = parseFloat(day.pointObjectif) || 0;
            var objectif = parseFloat(day.objectif) || 0;
            if (realisee === 0 && valorisation === 0 && objectif === 0) {
                return "";
            }
            return (realisee + valorisation) >= objectif ? " day-objectif-ok" : " day-objectif-ko";
        }

        function defineValueClass(value) {
            if (value > 0) {
                return 'positive-value';
            }
            if (value < 0) {
                return 'negative-value';
            }
            return '';
        }

        function showDayPoints(day) {
            if (!day) {
                return false;
            }
            var realisee = parseFloat(day.pointRealisee) || 0;
            var objectif = parseFloat(day.objectif) || 0;
            var valorisation = parseFloat(day.pointObjectif) || 0;
            return realisee !== 0 || objectif !== 0 || valorisation !== 0;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function previousMonth(date) {
            return moment(date).subtract(1, 'month').toDate();
        }

        function nextMonth(date) {
            return moment(date).add(1, 'month').toDate();
        }

        function goToCurrent() {
            return new Date();
        }

        // Libellé de la période de paie courante (ex : "26/05/2026 - 25/06/2026").
        function formatPeriodLabel(date) {
            if (!date) {
                return '';
            }
            var start = DateUtils.getFirstDayOfPayrollPeriod(date);
            var end = DateUtils.getLastDayOfPayrollPeriod(date);
            return moment(start).format('DD/MM/YYYY') + ' - ' + moment(end).format('DD/MM/YYYY');
        }

        function formatPeriodMonth(date) {
            if (!date) {
                return '';
            }
            var end = DateUtils.getLastDayOfPayrollPeriod(date);
            return vm.existingMonth[end.getMonth()];
        }

        function titleCaseWord(word) {
            if (!word) return word;
            return word[0].toUpperCase() + word.substr(1).toLowerCase();
        }

        function defineSundayClass(date) {
            if (!date) {
                return "";
            }
            return moment(date).isoWeekday() === 7 ? " sunday-cell" : "";
        }

        function formatHours(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            var num = parseFloat(value);
            if (isNaN(num) || num <= 0) {
                return '';
            }
            var totalMinutes = Math.round(num * 60);
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            return hours + 'h' + (minutes < 10 ? '0' : '') + minutes;
        }

        function formatHoursValue(value) {
            var totalMinutes = Math.round((parseFloat(value) || 0) * 60);
            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;
            return hours + 'h' + (minutes < 10 ? '0' : '') + minutes;
        }

        function formatHoursRatio(total, due) {
            var t = parseFloat(total) || 0;
            var d = parseFloat(due) || 0;
            if (t === 0 && d === 0) {
                return '';
            }
            return formatHoursValue(t) + ' / ' + formatHoursValue(d);
        }

        function formatHoursDelta(total, due) {
            var t = parseFloat(total) || 0;
            var d = parseFloat(due) || 0;
            if (t === 0 && d === 0) {
                return '';
            }
            var diff = t - d;
            var sign = diff > 0 ? '+' : (diff < 0 ? '-' : '');
            return sign + formatHoursValue(Math.abs(diff));
        }

        function defineHoursDeltaClass(total, due) {
            var t = parseFloat(total) || 0;
            var d = parseFloat(due) || 0;
            if (t === 0 && d === 0) {
                return '';
            }
            var diff = t - d;
            if (diff > 0) {
                return 'positive-value';
            }
            if (diff < 0) {
                return 'negative-value';
            }
            return '';
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('tmgApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "fr"');
                $cookies.putObject(name, 'fr');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('fr');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('tmgApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'Technicien', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, Technicien, JhiLanguageService) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicien').on('select2:select', function (e) {
                vm.user.technicien={};
				vm.user.technicien.id = $('#filterTechnicien :selected').val();
                vm.user.technicien.displayname = $('#filterTechnicien :selected').text();
            });
        });
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_TECHNICIEN', 'ROLE_AFFICHAGE'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.techniciens = [];
        vm.user = entity;

        loadTechniciens();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function loadTechniciens(){
            Technicien.technicienEnabled({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('tmgApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;
        vm.getCssClass = getCssClass;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
        
        function getCssClass(audit){
        	if(audit.type.includes("SUCCESS")){
        		return "success";
        	}else if(audit.type.includes("ERROR")){
        		return "error";
        	}
      	}
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SocialRegisterController', SocialRegisterController);

    SocialRegisterController.$inject = ['$filter', '$stateParams'];

    function SocialRegisterController ($filter, $stateParams) {
        var vm = this;

        vm.success = $stateParams.success;
        vm.error = !vm.success;
        vm.provider = $stateParams.provider;
        vm.providerLabel = $filter('capitalize')(vm.provider);
        vm.success = $stateParams.success;
    }
})();

(function () {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SocialAuthController', SocialAuthController);

    SocialAuthController.$inject = ['$state', '$cookies', 'Auth'];

    function SocialAuthController($state, $cookies, Auth) {
        var token = $cookies.get('social-authentication');

        Auth.loginWithToken(token, false).then(function () {
            $cookies.remove('social-authentication');
            Auth.authorize(true);
        }, function () {
            $state.go('social-register', {'success': 'false'});
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('social-register', {
            parent: 'account',
            url: '/social-register/:provider?{success:boolean}',
            data: {
                authorities: [],
                pageTitle: 'social.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/social/social-register.html',
                    controller: 'SocialRegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('social');
                    return $translate.refresh();
                }]
            }
        })
        .state('social-auth', {
            parent: 'account',
            url: '/social-auth',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    controller: 'SocialAuthController'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .factory('SocialService', SocialService);

    SocialService.$inject = ['$http', '$cookies'];

    function SocialService ($http, $cookies) {
        var socialService = {
            getProviderSetting: getProviderSetting,
            getProviderURL: getProviderURL,
            getCSRF: getCSRF
        };

        return socialService;

        function getProviderSetting (provider) {
            switch(provider) {
            case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
            case 'facebook': return 'public_profile,email';
            case 'twitter': return '';
                // jhipster-needle-add-social-button
            default: return 'Provider setting not defined';
            }
        }

        function getProviderURL (provider) {
            return 'signin/' + provider;
        }

        function getCSRF () {
            return $cookies.get($http.defaults.xsrfCookieName);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('jhSocial', jhSocial);

    jhSocial.$inject = ['$translatePartialLoader', '$translate', '$filter', 'SocialService'];

    function jhSocial($translatePartialLoader, $translate, $filter, SocialService) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider'
            },
            templateUrl: 'app/account/social/directive/social.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {
            
            $translatePartialLoader.addPart('social');
            $translate.refresh();
            
            scope.label = $filter('capitalize')(scope.provider);
            scope.providerSetting = SocialService.getProviderSetting(scope.provider);
            scope.providerURL = SocialService.getProviderURL(scope.provider);
            scope.csrf = SocialService.getCSRF();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

// (function() {
//     'use strict';
//
//     angular
//         .module('tmgApp')
//         .config(stateConfig);
//
//     stateConfig.$inject = ['$stateProvider'];
//
//     function stateConfig($stateProvider) {
//         $stateProvider.state('register', {
//             parent: 'account',
//             url: '/register',
//             data: {
//                 authorities: [],
//                 pageTitle: 'register.title'
//             },
//             views: {
//                 'content@': {
//                     templateUrl: 'app/account/register/register.html',
//                     controller: 'RegisterController',
//                     controllerAs: 'vm'
//                 }
//             },
//             resolve: {
//                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                     $translatePartialLoader.addPart('register');
//                     return $translate.refresh();
//                 }]
//             }
//         });
//     }
// })();

// (function() {
//     'use strict';
//
//     angular
//         .module('tmgApp')
//         .controller('RegisterController', RegisterController);
//
//
//     RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];
//
//     function RegisterController ($translate, $timeout, Auth, LoginService) {
//         var vm = this;
//
//         vm.doNotMatch = null;
//         vm.error = null;
//         vm.errorUserExists = null;
//         vm.login = LoginService.open;
//         vm.register = register;
//         vm.registerAccount = {};
//         vm.success = null;
//
//         $timeout(function (){angular.element('#login').focus();});
//
//         function register () {
//             if (vm.registerAccount.password !== vm.confirmPassword) {
//                 vm.doNotMatch = 'ERROR';
//             } else {
//                 vm.registerAccount.langKey = $translate.use();
//                 vm.doNotMatch = null;
//                 vm.error = null;
//                 vm.errorUserExists = null;
//                 vm.errorEmailExists = null;
//
//                 Auth.createAccount(vm.registerAccount).then(function () {
//                     vm.success = 'OK';
//                 }).catch(function (response) {
//                     vm.success = null;
//                     if (response.status === 400 && response.data === 'login already in use') {
//                         vm.errorUserExists = 'ERROR';
//                     } else if (response.status === 400 && response.data === 'email address already in use') {
//                         vm.errorEmailExists = 'ERROR';
//                     } else {
//                         vm.error = 'ERROR';
//                     }
//                 });
//             }
//         }
//     }
// })();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('tmgApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('tmgApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/calendar/calendar.html','<div><div class="container"><div class="row"><div class="col-md-12"><button class="btn btn-primary" ng-click="vm.openModalNewAstreinte()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.astreinte.home.createLabel">Cr\xE9er une nouvelle astreinte r\xE9alis\xE9e</span></button> <button class="btn btn-primary" ng-click="vm.openModalNewConge()"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.conges.home.createLabel">Create new Conges</span></button> <button class="btn btn-primary" ng-click="vm.openModalNewAstreintePlanifie()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.astreintePlanifie.home.createLabel">Create new Astreinte Planifie</span></button></div></div><div class="row"><div class="col-md-7"><h2 class="text-capitalize">{{vm.periodStart | date:\'dd/MM/yyyy\'}} - {{vm.periodEnd | date:\'dd/MM/yyyy\'}}</h2></div><div class="col-md-5 text-right"><nav aria-label="..."><ul class="pagination"><li class="page-item" ng-click="vm.updateMonth(\'prev\')"><span class="page-link">Mois pr\xE9c\xE9dent</span></li><li ng-click="vm.updateMonth(\'actual\')"><span class="page-link">Date actuel</span></li><li ng-click="vm.updateMonth(\'next\')"><span class="page-link">Prochain mois</span></li></ul></nav></div></div></div><table class="table table-striped table-bordered"><thead><tr><th scope="col" class="calendar-month-header"><span class="breakline calendar-month-name">{{vm.titleCaseWord(vm.currentPeriodMonth)}}</span> <span class="breakline">N\xB0 semaine</span></th><th scope="col" class="tdAlignCenter" ng-repeat="i in [].constructor(vm.numberOfDaysForMonth(vm.selectedMonth )) track by $index" colspan="{{vm.colspanCalcul($index+1)}}">{{vm.numberOfWeek($index+1)}}</th></tr><tr><th scope="col"><span class="breakline">Nom</span> <span class="breakline">Jour</span></th><th scope="col" ng-class="vm.hightlightDayAndBorderWeek($index)" ng-repeat="i in [].constructor(vm.numberOfDaysForMonth(vm.selectedMonth )) track by $index" class="tdAlignCenter borderTopAndBottom"><span class="breakline">{{vm.getDateForDayIndex($index+1).getDate()}}</span> <span class="breakline">{{vm.getStrDateForNumDay($index+1)}}</span></th></tr></thead><tbody class="hightlightRow"><tr ng-repeat="(key, user) in vm.tabCalendar" ng-if="vm.tabCalendar.length !== 0" ng-class="vm.rowClass(key)"><th scope="row">{{vm.listTechniciens[key]}}</th><td ng-repeat="eventCreated in user" ng-style="!eventCreated.astreintePlanifie ? {\'background-color\': vm.colors[eventCreated.color] ? vm.hexToRgba(vm.colors[eventCreated.color].base, 0.3) : \'\'} : {}" ng-class="[\r\n                        vm.defineTdColor(eventCreated, $index+1),\r\n                        eventCreated.conges == 0 ? \'non-clickable\' : \'clickable\'\r\n                    ]" class="tdAlignCenter" ng-click="eventCreated.conges == 0 ? null : vm.editConges(eventCreated.conges[0].congeId)"><i ng-click="vm.editAstreintePlanified(eventCreated.astreintePlanifie[0].astreintePlanifieId)" ng-if="eventCreated.astreintePlanifie.length" class="fa fa-square-o" aria-hidden="true"></i> <span ng-if="eventCreated.conges != 0"><span ng-if=\'eventCreated.conges[0].status == "none"\'><i class="fa fa-plane" aria-hidden="true"></i> </span><span ng-if=\'eventCreated.conges[0].status != "none"\'><i ng-if="eventCreated.conges[0].status == \'AT\'" class="fa fa-ambulance" aria-hidden="true"></i> <i ng-if="eventCreated.conges[0].status != \'AT\' && eventCreated.conges[0].status != \'GD\'" class="fa fa-plane" aria-hidden="true"></i> </span></span><i ng-click="vm.editAstreinte(eventCreated.astreinteId)" ng-if="eventCreated.astreinteId !== null" class="fa fa-check-square-o" aria-hidden="true"></i></td></tr><tr ng-if="vm.tabCalendar.length == 0"><th scope="row">Pas d\'\xE9venement</th><th scope="col" ng-repeat="i in [].constructor(vm.numberOfDaysForMonth(vm.selectedMonth )) track by $index"></th></tr></tbody></table><br><div class="container"><div class="row align-items-start"><div class="col col-md-6"><div class=""><i class="fa fa-check-square-o tdYellow"></i>&nbsp;Astreinte R\xE9alis\xE9e</div><div class=""><i class="fa fa-square-o tdGreen"></i>&nbsp;Astreinte Planifi\xE9 - Cuivre</div><div class=""><i class="fa fa-square-o tdYellowChef"></i>&nbsp;Astreinte Planifi\xE9 - Fibre Chef Equipe Binome</div><div class=""><i class="fa fa-square-o tdBeigeBinome"></i>&nbsp;Astreinte Planifi\xE9 - Fibre Bin\xF4me</div><div class=""><i class="fa fa-square-o tdLightBrown"></i>&nbsp;Astreinte Planifi\xE9 - Fibre Chef Mon\xF4me</div></div><div class="col col-md-6"><div class=""><i class="fa fa-plane tdRed"></i>&nbsp;Cong\xE9 non valid\xE9</div><div class=""><i class="fa fa-plane tdBlue"></i>&nbsp;Cong\xE9 Pay\xE9</div><div class=""><i class="fa fa-plane tdGrey"></i>&nbsp;Ch\xF4mage partiel</div><div class=""><span style="display: inline-block; width: 9.44px; height: 12px; background-color: #A23CD5"></span>&nbsp;Grand d\xE9placement</div><div class=""><i class="fa fa-plane tdOrange"></i>&nbsp;Journ\xE9e d\xE9plac\xE9</div><div class=""><i class="fa fa-plane tdGreen"></i>&nbsp;Journ\xE9e r\xE9cup\xE9r\xE9e</div><div class=""><i class="fa fa-ambulance tdPink"></i>&nbsp;Arr\xEAt maladie</div></div></div></div></div>');
$templateCache.put('app/bonusObjWeek/bonusObjWeek.html','<div><div class="container-fluid"><div class="row"><div class="col-md-7"></div><div class="col-md-5 text-right"><nav aria-label="..."><ul class="pagination"><li class="page-item" ng-click="vm.updateWeek(\'prev\')"><span class="page-link">Semaine pr\xE9c\xE9dente</span></li><li ng-click="vm.updateWeek(\'actual\')"><span class="page-link">Date actuel</span></li><li ng-click="vm.updateWeek(\'next\')"><span class="page-link">Prochain semaine</span></li></ul></nav></div></div><table class="table table-striped table-bordered"><thead><tr><th scope="col" class="tdAlignCenter" rowspan="2">{{ vm.titleCaseWord(vm.existingMonth[vm.selectedWeek.getMonth()]) }}</th><th scope="col" class="tdAlignCenter" rowspan="2">Semaine {{ vm.numberOfWeek() }}</th><th scope="col" colspan="3" ng-repeat="x in [].constructor(6) track by $index">{{ vm.dayOfWeek[$index]}}</th><th rowspan="2" scope="col" class="tdAlignCenter">Valorisation</th><th rowspan="2" scope="col" class="tdAlignCenter">Total</th><th rowspan="2" scope="col" class="tdAlignCenter">Objectif</th><th rowspan="2" scope="col" class="tdAlignCenter">Palier</th><th rowspan="2" scope="col" class="tdAlignCenter">Point d\xE9finitif</th></tr><tr><th scope="col" colspan="3" ng-repeat="x in [].constructor(6) track by $index">{{ vm.getDayFromDate($index+1) }}</th></tr></thead><tbody><tr ng-repeat="(index, technicien) in vm.listTechniciens" ng-if="vm.listTechniciens.length !== 0"><td>{{technicien}}</td><td>{{vm.ApiResponseTab[index].role}}</td><td ng-repeat-start="i in [0,1,2,3,4,5]" ng-class="vm.defineTdColor(vm.ApiResponseTab[index].days[i].congeType)">{{vm.ApiResponseTab[index].days[i].congeType}}</td><td ng-class="vm.defineTdColor(vm.ApiResponseTab[index].days[i].congeType)"><a ui-sref="intervention({technicienEquipe:technicien,dateFrom:vm.ApiResponseTab[index].days[i].date,dateTo:vm.ApiResponseTab[index].days[i].date})">{{vm.ApiResponseTab[index].days[i].nbInterventions}} inters</a></td><td ng-class="vm.defineTdColor(vm.ApiResponseTab[index].days[i].congeType)" ng-repeat-end>{{vm.ApiResponseTab[index].days[i].pointRealisee}} <span class="astreinteAlert" ng-if="vm.ApiResponseTab[index].days[i].pointObjectif">+{{vm.ApiResponseTab[index].days[i].pointObjectif}}</span> / {{vm.ApiResponseTab[index].days[i].objectif}}</td><th scope="col" class="astreinteAlert">{{vm.ApiResponseTab[index].pointValorisation}}</th><th scope="col">{{vm.ApiResponseTab[index].pointSemaine}}</th><th scope="col">{{vm.ApiResponseTab[index].objectif}}</th><th scope="col">{{vm.ApiResponseTab[index].palier}}</th><th scope="col">{{vm.ApiResponseTab[index].pointDefinitif}}</th></tr><tr ng-if="vm.listTechniciens.length == 0"><td colspan="19">Aucun \xE9venement</td></tr></tbody></table></div><br><div class="container"><div class="row align-items-start"><div class="col col-md-12"><div class=""><i class="fa fa-plane tdBlue"></i>&nbsp;Cong\xE9 Pay\xE9</div><div class=""><i class="fa fa-plane tdGrey"></i>&nbsp;Ch\xF4mage partiel</div><div class=""><i class="fa fa-plane tdPurple"></i>&nbsp;Grand d\xE9placement</div><div class=""><i class="fa fa-plane tdOrange"></i>&nbsp;Journ\xE9e d\xE9plac\xE9</div><div class=""><i class="fa fa-plane tdGreen"></i>&nbsp;Journ\xE9e r\xE9cup\xE9r\xE9e</div><div class=""><i class="fa fa-ambulance tdPink"></i>&nbsp;Arr\xEAt maladie</div></div></div></div></div>');
$templateCache.put('app/bonusObjMonth/bonusObjMonth.html','<div><div class="container-fluid"><div class="bonus-month-header"><div class="bonus-month-header-spacer"><h4 class="bonus-obj-month-title">{{ vm.titleCaseWord(vm.currentMonthLabel) }}</h4></div><div class="bonus-month-header-checkbox"><label class="bonus-month-checkbox-label" ng-if="!vm.isTechnicien"><input type="checkbox" ng-model="vm.showVehicleHours"> Afficher le nombre d\'heure des v\xE9hicules</label><label class="bonus-month-checkbox-label"><input type="checkbox" ng-model="vm.showInterventions"> Afficher le nombre d\'interventions</label></div><div class="bonus-month-header-nav"><nav aria-label="..."><ul class="pagination"><li class="page-item" ng-click="vm.updateMonth(\'prev\')"><span class="page-link">Mois pr\xE9c\xE9dent</span></li><li ng-click="vm.updateMonth(\'actual\')"><span class="page-link">Date actuelle</span></li><li ng-click="vm.updateMonth(\'next\')"><span class="page-link">Mois suivant</span></li></ul></nav></div></div><table class="table table-striped table-bordered bonus-month-table"><thead><tr><th scope="col" class="tdAlignCenter tech-col bonus-month-name" rowspan="2">{{ vm.titleCaseWord(vm.currentPeriodMonth) }}</th><th scope="col" class="tdAlignCenter day-header {{ vm.defineSundayClass(day) }}" ng-repeat="day in vm.daysOfMonth track by $index">{{ vm.dayOfWeekShort[day.isoWeekday() - 1] }}</th><th rowspan="2" scope="col" class="tdAlignCenter summary-col">Valo</th><th rowspan="2" scope="col" class="tdAlignCenter summary-col">Total</th><th rowspan="2" scope="col" class="tdAlignCenter summary-col">Obj.</th><th rowspan="2" scope="col" class="tdAlignCenter summary-col">\xC9cart h.</th></tr><tr><th scope="col" class="tdAlignCenter day-header {{ vm.defineSundayClass(day) }}" ng-repeat="day in vm.daysOfMonth track by $index">{{ day.format(\'DD\') }}</th></tr></thead><tbody><tr ng-repeat-start="(index, technicien) in vm.listTechniciens" ng-if="vm.listTechniciens.length !== 0 && (!vm.selectedFilterTech || technicien === vm.selectedFilterTech)"><td class="tech-col">{{ technicien }} <i class="fa fa-filter" ng-class="{\'text-primary\': vm.selectedFilterTech === technicien}" ng-click="vm.selectedFilterTech = (vm.selectedFilterTech === technicien ? null : technicien)" style="cursor: pointer; margin-left: 5px" title="{{ vm.selectedFilterTech === technicien ? \'Afficher tous les techniciens\' : \'Filtrer sur \' + technicien }}"></i></td><td ng-repeat="day in vm.ApiResponseTab[index].days track by $index" class="day-compact-cell {{ vm.defineSundayClass(day.date) }}" ng-class="vm.defineTdColor(day)"><a class="day-link" ng-if="vm.showInterventions" ui-sref="intervention({technicienEquipe: technicien, dateFrom: day.date, dateTo: day.date})">{{ day.nbInterventions }}i</a><div class="day-points" ng-if="vm.showDayPoints(day)"><a ui-sref="intervention({technicienEquipe: technicien, dateFrom: day.date, dateTo: day.date})">{{ day.pointRealisee }} </a><a ng-if="day.pointObjectif != null && day.pointObjectif != 0" ng-class="vm.defineValueClass(day.pointObjectif)" ui-sref="valorisation({technicien: technicien, date: day.date})" data-toggle="tooltip" title="{{ vm.getValorisationTooltip(day) }}">{{ day.pointObjectif > 0 ? \'+\' : \'\' }}{{ day.pointObjectif }} </a>/ <a ui-sref="intervention({technicienEquipe: technicien, dateFrom: day.date, dateTo: day.date})">{{ day.objectif }}</a></div><div class="day-conge" ng-if="day.congeType">{{ day.congeType }}</div></td><th scope="col" class="summary-col" ng-class="vm.defineValueClass(vm.ApiResponseTab[index].pointValorisation)">{{ vm.ApiResponseTab[index].pointValorisation }}</th><th scope="col" class="summary-col">{{ vm.ApiResponseTab[index].pointSemaine }}</th><th scope="col" class="summary-col objectif-summary-col"><table class="objectif-palier-table"><tbody><tr ng-repeat="palier in vm.ApiResponseTab[index].paliers track by $index " ng-class="{\'palier-alt-row\': $index % 2 === 1}"><td class="objectif-palier-label">{{ palier.label }}</td><td class="objectif-palier-point">{{ palier.point }}</td></tr></tbody></table></th><th scope="col" class="summary-col"></th></tr><tr ng-repeat-end ng-if="vm.showVehicleHours && !vm.isTechnicien && (!vm.selectedFilterTech || technicien === vm.selectedFilterTech)" class="vehicle-hours-row"><td class="tech-col text-muted">Heures v\xE9hicule</td><td ng-repeat="day in vm.ApiResponseTab[index].days track by $index" class="day-compact-cell {{ vm.defineSundayClass(day.date) }}"><a class="day-points" ng-if="day.estimatedTimeHours" ui-sref="fleet-daily-trip({date: day.date, technicien: technicien})">{{ vm.formatHours(day.estimatedTimeHours) }}</a></td><th scope="col" class="summary-col"></th><th scope="col" class="summary-col">{{ vm.formatHoursRatio(vm.ApiResponseTab[index].totalEstimatedTimeHours, vm.ApiResponseTab[index].dueTimeHours) }}</th><th scope="col" class="summary-col"></th><th scope="col" class="summary-col" ng-class="vm.defineHoursDeltaClass(vm.ApiResponseTab[index].totalEstimatedTimeHours, vm.ApiResponseTab[index].dueTimeHours)">{{ vm.formatHoursDelta(vm.ApiResponseTab[index].totalEstimatedTimeHours, vm.ApiResponseTab[index].dueTimeHours) }}</th></tr><tr ng-if="vm.listTechniciens.length == 0"><td colspan="{{ 1 + vm.daysOfMonth.length + 4 }}">Aucun \xE9v\xE9nement</td></tr></tbody></table></div><br><div class="container"><div class="row align-items-start"><div class="col col-md-12"><div><i class="fa fa-plane tdBlue"></i>&nbsp;Cong\xE9 pay\xE9</div><div><i class="fa fa-plane tdGrey"></i>&nbsp;Ch\xF4mage partiel</div><div><i class="fa fa-plane tdPurple"></i>&nbsp;Grand d\xE9placement</div><div><i class="fa fa-plane tdOrange"></i>&nbsp;Journ\xE9e d\xE9plac\xE9e</div><div><i class="fa fa-plane tdGreen"></i>&nbsp;Journ\xE9e r\xE9cup\xE9r\xE9e</div><div><i class="fa fa-ambulance tdPink"></i>&nbsp;Arr\xEAt maladie</div></div></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"></div><div style="padding-bottom: 2rem; text-align: center"><h1>Bienvenue sur TMG!</h1></div><div class="row" ng-if="vm.isAuthenticated" has-authority="ROLE_ADMIN"><div class="col-md-7"><h2 class="text-capitalize">{{vm.formatMonthFr(vm.month)}} {{vm.month.getFullYear()}}</h2></div><div class="col-md-5 text-right"><nav aria-label="..."><ul class="pagination"><li class="page-item" ng-click="vm.previousMonth()"><span class="page-link">Mois pr\xE9c\xE9dent</span></li><li ng-click="vm.actualMonth()"><span class="page-link">Date actuel</span></li><li ng-click="vm.nextMonth()"><span class="page-link">Prochain mois</span></li></ul></nav></div></div><div ng-if="vm.isAuthenticated"><div class="dates" style="margin-bottom: 2rem"><span>Du {{vm.dateStart | date:\'dd/MM/yyyy\'}} au {{vm.dateEnd | date:\'dd/MM/yyyy\'}}</span></div><div style="margin-top: 3rem"><div class="one-stat-container" ng-repeat="stat in vm.technicienHomeStats"><div class="progress-bar-container"><div class="technicien-name"><span has-authority="ROLE_ADMIN" class="view-calendar-btn" ng-click="vm.viewCalendar(stat)"><span ng-if="!stat.display"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><style>svg{fill:#000000}</style><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg> </span><span ng-if="stat.display"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><style>svg{fill:#000000}</style><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg> </span></span><span class="tech-name">{{stat.technicienName}}</span></div><div class="progress-bar-column" ng-if="stat.displayProgressBar || vm.isAdmin"><span>{{stat.percentage}}%</span><uib-progressbar type="success" value="stat.percentage / vm.progressBarMax * 100"></uib-progressbar><div ng-if="stat.percentage > 0" class="theoricalPercentage" ng-style="{\'left\': (stat.theoricalPercentage / vm.progressBarMax * 100) + \'%\'}">{{stat.theoricalPercentage}}</div></div></div><div has-authority="ROLE_ADMIN" ng-if="stat.display"><div class="home-calendar"><div class="one-week" ng-repeat="week in vm.weeks"><div class="calendar-week"><div class="one-day" ng-repeat="day in week" ng-init="dayInfo = vm.findCalendarDayInfo(day, stat.calendarInfos)"><div><div class="date"><span>{{day | date:\'dd/MM\'}}</span> <span>{{vm.formatDayFr(day)}}</span></div><div class="content" ng-class="[vm.getBackgroundColor(day, stat.calendarInfos)]"><i ng-if="dayInfo && dayInfo.astreintePlanifie && dayInfo.astreintePlanifie.length > 0" class="fa fa-square-o" aria-hidden="true"></i> <span ng-if="dayInfo && dayInfo.conges && dayInfo.conges.length > 0"><i ng-if="dayInfo.conges[0].status == \'none\'" class="fa fa-plane" aria-hidden="true"></i> <i ng-if="dayInfo.conges[0].status == \'AT\'" class="fa fa-ambulance" aria-hidden="true"></i> <i ng-if="dayInfo.conges[0].status != \'AT\' && dayInfo.conges[0].status != \'GD\'" class="fa fa-plane" aria-hidden="true"></i> </span><i ng-if="dayInfo && dayInfo.astreinteId !== null" class="fa fa-check-square-o" aria-hidden="true"></i></div></div></div></div><div class="home-equipes"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Chef</span></th><th><span>Binome</span></th><th><span>Dates</span></th></tr></thead><tbody><tr ng-repeat="equipe in stat.equipes" ng-if="vm.isEquipeInWeekRange(equipe, week)"><td>{{equipe.chef}}</td><td>{{equipe.binome}}</td><td><span ng-if="equipe.dateStart == equipe.dateEnd">{{equipe.dateStart | date:\'dd/MM\'}} </span><span ng-if="equipe.dateStart != equipe.dateEnd">{{equipe.dateStart | date:\'dd/MM\'}} - {{equipe.dateEnd | date:\'dd/MM\'}}</span></td></tr></tbody></table></div></div></div></div><div class="home-activities" ng-if="stat.resultatTechniciens && stat.resultatTechniciens.length > 0"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Activit\xE9</span></th><th><span>Quantit\xE9</span></th><th><span>Pourcentage</span></th></tr></thead><tbody><tr ng-repeat="resultat in stat.resultatTechniciens"><td>{{resultat.description}}</td><td>{{resultat.qty}}</td><td>{{resultat.homeStatPercentage}}%</td></tr></tbody></table></div></div></div><div has-authority="ROLE_TECHNICIEN" ng-if="userRole !== \'ROLE_ADMIN\'"><div class="home-calendar"><div class="one-week" ng-repeat="week in vm.weeks"><div class="calendar-week"><div class="one-day" ng-repeat="day in week" ng-init="dayInfo = vm.findCalendarDayInfo(day, stat.calendarInfos)"><div><div class="date"><span>{{day | date:\'dd/MM\'}}</span> <span>{{vm.formatDayFr(day)}}</span></div><div class="content" ng-class="[vm.getBackgroundColor(day, stat.calendarInfos)]"><i ng-if="dayInfo && dayInfo.astreintePlanifie && dayInfo.astreintePlanifie.length > 0" class="fa fa-square-o" aria-hidden="true"></i> <span ng-if="dayInfo && dayInfo.conges && dayInfo.conges.length > 0"><i ng-if="dayInfo.conges[0].status == \'none\'" class="fa fa-plane" aria-hidden="true"></i> <i ng-if="dayInfo.conges[0].status == \'AT\'" class="fa fa-ambulance" aria-hidden="true"></i> <i ng-if="dayInfo.conges[0].status != \'AT\' && dayInfo.conges[0].status != \'GD\'" class="fa fa-plane" aria-hidden="true"></i> </span><i ng-if="dayInfo && dayInfo.astreinteId !== null" class="fa fa-check-square-o" aria-hidden="true"></i></div></div></div></div><div class="home-equipes"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Chef</span></th><th><span>Binome</span></th><th><span>Dates</span></th></tr></thead><tbody><tr ng-repeat="equipe in stat.equipes" ng-if="vm.isEquipeInWeekRange(equipe, week)"><td>{{equipe.chef}}</td><td>{{equipe.binome}}</td><td><span ng-if="equipe.dateStart == equipe.dateEnd">{{equipe.dateStart | date:\'dd/MM\'}} </span><span ng-if="equipe.dateStart != equipe.dateEnd">{{equipe.dateStart | date:\'dd/MM\'}} - {{equipe.dateEnd | date:\'dd/MM\'}}</span></td></tr></tbody></table></div></div></div></div><div class="home-activities" ng-if="stat.resultatTechniciens && stat.resultatTechniciens.length > 0"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Activit\xE9</span></th><th><span>Quantit\xE9</span></th><th><span>Pourcentage</span></th></tr></thead><tbody><tr ng-repeat="resultat in stat.resultatTechniciens"><td>{{resultat.description}}</td><td>{{resultat.qty}}</td><td>{{resultat.homeStatPercentage}}%</td></tr></tbody></table></div></div></div><hr></div><div class="infos"><div class="last-imports"><div><span>Dernier import praxedo: {{vm.lastImportFiles.praxedo}}</span></div><div><span>Dernier import sogetrel: {{vm.lastImportFiles.sogetrel}}</span></div></div><div class="legende"><div class="theoricalPercentage"></div><div><span>Progression th\xE9orique: {{vm.formatDate(vm.theoricalPercentageDay)}}</span></div></div></div></div><div class="alert alert-warning" ng-if="!vm.isAuthenticated">Veuillez vous <a class="alert-link" href="" ng-click="vm.login()">connecter</a> pour continuer</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<!--<div>--><!--    <div class="row">--><!--        <div class="col-md-8 col-md-offset-2">--><!--            <h1 data-translate="register.title">Registration</h1>--><!--            <div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success">--><!--                <strong>Registration saved!</strong> Please check your email for confirmation.--><!--            </div>--><!--            <div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail">--><!--                <strong>Registration failed!</strong> Please try again later.--><!--            </div>--><!--            <div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists">--><!--                <strong>Login name already registered!</strong> Please choose another one.--><!--            </div>--><!--            <div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists">--><!--                <strong>Email is already in use!</strong> Please choose another one.--><!--            </div>--><!--            <div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">--><!--                The password and its confirmation do not match!--><!--            </div>--><!--        </div>--><!--        <div class="col-md-4 col-md-offset-2">--><!--            <form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation>--><!--                <div class="form-group">--><!--                    <label class="control-label" for="login" data-translate="global.form.username">Username</label>--><!--                    <input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}"--><!--                           ng-model="vm.registerAccount.login" ng-minlength=1 ng-maxlength=50 ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required>--><!--                    <div ng-show="form.login.$dirty && form.login.$invalid">--><!--                        <p class="help-block"--><!--                               ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">--><!--                            Your username is required.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">--><!--                            Your username is required to be at least 1 character.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">--><!--                            Your username cannot be longer than 50 characters.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">--><!--                            Your username can only contain lower-case letters and digits.--><!--                    </p>--><!--                    </div>--><!--                </div>--><!--                <div class="form-group">--><!--                    <label class="control-label" for="email" data-translate="global.form.email">Email</label>--><!--                    <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}"--><!--                           ng-model="vm.registerAccount.email" ng-minlength=5 ng-maxlength=100 required>--><!--                    <div ng-show="form.email.$dirty && form.email.$invalid">--><!--                        <p class="help-block"--><!--                               ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">--><!--                            Your email is required.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">--><!--                            Your email is invalid.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">--><!--                            Your email is required to be at least 5 characters.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">--><!--                            Your email cannot be longer than 100 characters.--><!--                        </p>--><!--                    </div>--><!--                </div>--><!--                <div class="form-group">--><!--                    <label class="control-label" for="password" data-translate="global.form.newpassword">New password</label>--><!--                    <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}"--><!--                           ng-model="vm.registerAccount.password" ng-minlength=4 ng-maxlength=50 required>--><!--                    <div ng-show="form.password.$dirty && form.password.$invalid">--><!--                        <p class="help-block"--><!--                               ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">--><!--                            Your password is required.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">--><!--                            Your password is required to be at least 4 characters.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">--><!--                            Your password cannot be longer than 50 characters.--><!--                        </p>--><!--                    </div>--><!--                    <password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar>--><!--                </div>--><!--                <div class="form-group">--><!--                    <label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label>--><!--                    <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}"--><!--                           ng-model="vm.confirmPassword" ng-minlength=4 ng-maxlength=50 required>--><!--                    <div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid">--><!--                        <p class="help-block"--><!--                               ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">--><!--                            Your confirmation password is required.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">--><!--                            Your confirmation password is required to be at least 4 characters.--><!--                        </p>--><!--                        <p class="help-block"--><!--                               ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">--><!--                            Your confirmation password cannot be longer than 50 characters.--><!--                        </p>--><!--                    </div>--><!--                </div>--><!--                <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button>--><!--            </form>--><!--            <p></p>--><!--            <div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>--><!--                If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").--><!--            </div>--><!--        </div>--><!--        <div class="col-md-4">--><!--            <br/>--><!--            <jh-social ng-provider="google"></jh-social>--><!--            <jh-social ng-provider="facebook"></jh-social>--><!--            <jh-social ng-provider="twitter"></jh-social>--><!--            &lt;!&ndash; jhipster-needle-add-social-button &ndash;&gt;--><!--        </div>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/social/social-register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 ng-show="success" data-translate="social.register.title" translate-values="{ label: vm.providerLabel }">Registration with</h1><h1 ng-show="error" data-translate="social.register.errorTitle">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="social.register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="social.register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><jh-social ng-if="vm.success" ng-provider="{{ vm.provider }}"></jh-social><br><div class="alert alert-warning" data-translate="global.messages.info.authenticated">If you want to <a class="alert-link" href="#/login">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered" ng-class="vm.getCssClass(audit)"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><div ng-show="audit.data.message">{{audit.data.message}}</div><div ng-repeat="(key, value) in audit.data">{{key}} {{value}}</div></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd><dt>Technicien</dt><dd>{{vm.user.user.technicien.displayname}}</dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="techniciens" ng-model="vm.user.technicien" id="filterTechnicien" ng-options="technicien as technicien.displayname for technicien in vm.techniciens track by technicien.id"><option ng-value="null"></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th>Technicien</th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.technicien.displayname}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-12"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/entities/astreinte/astreinte-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.astreinte.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.astreinte.delete.question" translate-values="{id: \'{{vm.astreinte.id}}\'}">Are you sure you want to delete this Astreinte?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/astreinte/astreinte-detail.html','<div><h2><span data-translate="tmgApp.astreinte.detail.title">Astreinte</span> {{vm.astreinte.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.astreinte.technicien">Technicien</span></dt><dd><span>{{vm.astreinte.technicien}}</span></dd><dt><span data-translate="tmgApp.astreinte.date">Date</span></dt><dd><span>{{vm.astreinte.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="tmgApp.astreinte.hours">Hours</span></dt><dd><span>{{vm.astreinte.hours}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="astreinte-detail.edit({id:vm.astreinte.id})" class="btn btn-primary" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/astreinte/astreinte-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAstreinteLabel" data-translate="tmgApp.astreinte.home.createOrEditLabel">Create or edit a Astreinte</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.astreinte.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.astreinte.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.astreinte.technicien" for="field_technicien">Technicien</label><select class="form-control" name="technicien" ng-model="vm.astreinte.technicien" id="field_technicien" required><option ng-repeat="technicien in vm.techniciens">{{ technicien.displayname }}</option></select><div ng-show="editForm.technicien.$invalid"><p class="help-block" ng-show="editForm.technicien.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.astreinte.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.astreinte.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.astreinte.hours" for="field_hours">Hours</label><input type="number" class="form-control" name="hours" id="field_hours" ng-model="vm.astreinte.hours" required><div ng-show="editForm.hours.$invalid"><p class="help-block" ng-show="editForm.hours.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.hours.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" ng-if="vm.astreinte.id !== null" ng-click="vm.deleteAstreinte(vm.astreinte.id)" class="btn btn-danger pull-left"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/astreinte/astreintes.html','<div><h2 data-translate="tmgApp.astreinte.home.title">Astreintes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 col-md-2" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien" ng-change="vm.search()"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select></div></div><div class="col-xs-4 col-md-2"><div class="form-group"><label for="filterYear">Year</label><select class="form-control" name="filterYear" ng-model="vm.filterYear" id="filterYear" ng-change="vm.search()"><option></option><option ng-repeat="year in vm.yearDispo">{{ year }}</option></select></div></div><div class="col-xs-4 col-md-2"><div class="form-group"><label for="filterMonth">Month</label><select class="form-control" name="filterMonth" ng-model="vm.filterMonth" id="filterMonth" ng-change="vm.search()"><option></option><option value="{{ $index+1 }}" ng-repeat="x in [].constructor(12) track by $index">{{ vm.parseNumberToMonth($index) | capitalize }}</option></select></div></div></div><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="astreinte.new" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.astreinte.home.createLabel">Create new realised astreinte</span></button> <button class="btn btn-primary" ng-click="vm.autoDetect()" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-link"></span> <span>Auto Detect</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span data-translate="tmgApp.astreinte.technicien">Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="tmgApp.astreinte.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="hours"><span data-translate="tmgApp.astreinte.hours">Hours</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="astreinte in vm.astreintes track by astreinte.id"><td><a ui-sref="astreinte-detail({id:astreinte.id})">{{astreinte.id}}</a></td><td>{{astreinte.technicien}}</td><td>{{astreinte.date | date:\'mediumDate\'}}</td><td>{{astreinte.hours}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="astreinte-detail({id:astreinte.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" has-authority="ROLE_ADMIN" ui-sref="astreinte.edit({id:astreinte.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="astreinte.delete({id:astreinte.id})" has-authority="ROLE_ADMIN" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/astreinte-planifie/astreinte-planifie-delete-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.astreintePlanifie.delete.question" translate-values="{technicien: \'{{vm.astreintePlanifie.technicien}}\', date: \'{{vm.astreintePlanifie.date | date: \'dd/MM/yyyy\'}}\'}">Are you sure you want to delete this Astreinte Planifie?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-if="vm.astreintePlanifie.repeatId!=null" ng-click="vm.confirmDelete(vm.astreintePlanifie.id,true)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Supprimer les astreintes futures</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-click="vm.confirmDelete(vm.astreintePlanifie.id,false)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/astreinte-planifie/astreinte-planifie-detail.html','<div><h2><span data-translate="tmgApp.astreintePlanifie.detail.title">Astreinte Planifie</span> {{vm.astreintePlanifie.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.astreintePlanifie.technicien">Technicien</span></dt><dd><span>{{vm.astreintePlanifie.technicien}}</span></dd><dt><span data-translate="tmgApp.astreintePlanifie.date">Date</span></dt><dd><span>{{vm.astreintePlanifie.date | date:\'mediumDate\'}}</span></dd><dt ng-if="vm.astreintePlanifie.comment"><span data-translate="tmgApp.astreintePlanifie.comment">Comment</span></dt><dd ng-if="vm.astreintePlanifie.comment"><span class="astreinteAlert">{{vm.astreintePlanifie.comment}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="astreinte-planifie-detail.edit({id:vm.astreintePlanifie.id})" class="btn btn-primary" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button type="button" ui-sref="astreinte-planifie-detail.asknotwork({id:vm.astreintePlanifie.id})" ng-if="vm.isAccountProperty" class="btn btn-danger" ng-disabled="vm.astreintePlanifie.comment"><span class="glyphicon glyphicon-alert"></span> <span class="hidden-sm-down" data-translate="tmgApp.astreintePlanifie.askNotWork">Ask to not work</span></button></div>');
$templateCache.put('app/entities/astreinte-planifie/astreinte-planifie-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAstreintePlanifieLabel" data-translate="tmgApp.astreintePlanifie.home.createOrEditLabel">Create or edit a Astreinte Planifie</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.astreintePlanifie.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.astreintePlanifie.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.astreintePlanifie.technicien" for="field_technicien">Technicien</label><select class="form-control" name="technicien" ng-model="vm.astreintePlanifie.technicien" id="field_technicien" required><option ng-if="technicien.enabled" ng-repeat="technicien in vm.techniciens">{{ technicien.displayname }}</option></select><div ng-show="editForm.technicien.$invalid"><p class="help-block" ng-show="editForm.technicien.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.astreintePlanifie.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.astreintePlanifie.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.astreintePlanifie.type.name" for="field_type">Type</label><select class="form-control" name="field_type" ng-model="vm.astreintePlanifie.type" id="field_type"><option data-translate="tmgApp.astreintePlanifie.type.copper" value="CUIVRE">Cuivre</option><option data-translate="tmgApp.astreintePlanifie.type.fiber.chef.equipeBinome" value="FIBRE_CHEF_EQUIPE_BINOME">Fibre chef equipe binome</option><option data-translate="tmgApp.astreintePlanifie.type.fiber.binome" value="FIBRE_BINOME">Fibre binome</option><option data-translate="tmgApp.astreintePlanifie.type.fiber.chef.monome" value="FIBRE_CHEF_MONOME">Fibre chef monome</option></select></div><div class="form-group" ng-if="vm.astreintePlanifie.id == null"><label for="frequenceActive"><input type="checkbox" name="frequenceActive" id="frequenceActive" ng-model="vm.repeatFrequenceActive"> <span>Avec une frequence de r\xE9p\xE9titon ?</span></label></div><div class="form-group" ng-if="vm.repeatFrequenceActive == true"><label class="control-label" for="field_frequence">Fr\xE9quence de r\xE9p\xE9tition (en semaine)</label><input type="number" class="form-control" name="field_frequence" id="field_frequence" ng-model="vm.astreintePlanifie.repeatFrequence" min="1"><label class="control-label" for="field_frequence">Nombre de fois</label><input type="number" class="form-control" name="field_frequence" id="field_frequence" ng-model="vm.astreintePlanifie.repeatNumber" min="1"></div><hr ng-if="vm.isDatePast() && vm.astreintePlanifie.id"><div class="form-group createAstreinte" ng-if="vm.isDatePast() && vm.astreintePlanifie.id"><div><label for="astreinteHour">Nombre d\'heures</label><input type="number" class="form-control" id="astreinteHour" name="astreinteHour" ng-model="vm.astreinteHours" required></div><div><button type="button" class="btn btn-primary btn-sm" ng-click="vm.createAstreinteRealise()" ng-disabled="vm.astreinteHours == null || vm.astreinteHours == \'\'"><span class="glyphicon glyphicon-save"></span> <span class="hidden-sm-down">Cr\xE9er l\'astreinte r\xE9alis\xE9e</span></button></div></div></div><div class="modal-footer"><button type="button" ng-if="vm.astreintePlanifie.id !== null" ng-click="vm.deleteAstreintePlanified(vm.astreintePlanifie.id)" class="btn btn-danger pull-left"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/astreinte-planifie/astreinte-planifie-notWork.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAstreintePlanifieLabel" data-translate="tmgApp.astreintePlanifie.askNotWork">Ask to not work</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.astreintePlanifie.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.astreintePlanifie.id" readonly="readonly"></div><div class="form-group"><label for="field_technicien" data-translate="tmgApp.astreintePlanifie.technicien">Technicien</label><input type="text" class="form-control" id="field_technicien" name="technicien" ng-model="vm.astreintePlanifie.technicien" readonly="readonly"></div><div class="form-group"><label for="field_date" data-translate="tmgApp.astreintePlanifie.date">Date</label><input type="text" class="form-control" id="field_date" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.astreintePlanifie.date" readonly="readonly"></div><div class="form-group"><label for="commentary" data-translate="tmgApp.astreintePlanifie.comment">Comment</label><input type="text" class="form-control" id="commentary" name="commentary" ng-model="vm.astreintePlanifie.comment"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-send"></span>&nbsp;<span data-translate="tmgApp.astreintePlanifie.send">Send</span></button></div></form>');
$templateCache.put('app/entities/astreinte-planifie/astreinte-planifies.html','<div><h2 data-translate="tmgApp.astreintePlanifie.home.title">Astreinte Planifies</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 col-md-2" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien" ng-change="vm.search()"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select></div></div><div class="col-xs-4 col-md-2"><div class="form-group"><label for="filterYear">Year</label><select class="form-control" name="filterYear" ng-model="vm.filterYear" id="filterYear" ng-change="vm.search()"><option></option><option ng-repeat="year in vm.yearDispo">{{ year }}</option></select></div></div><div class="col-xs-4 col-md-2"><div class="form-group"><label for="filterMonth">Month</label><select class="form-control" name="filterMonth" ng-model="vm.filterMonth" id="filterMonth" ng-change="vm.search()"><option></option><option value="{{ $index+1 }}" ng-repeat="x in [].constructor(12) track by $index">{{ vm.parseNumberToMonth($index) | capitalize }}</option></select></div></div></div><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="astreinte-planifie.new" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.astreintePlanifie.home.createLabel">Create new Astreinte Planifie</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span data-translate="tmgApp.astreintePlanifie.technicien">Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="tmgApp.astreintePlanifie.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="tmgApp.astreintePlanifie.type.name">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="astreintePlanifie in vm.astreintePlanifies track by astreintePlanifie.id"><td ng-class="astreintePlanifie.comment ? \'astreinteAlert\' : \'\'"><a ui-sref="astreinte-planifie-detail({id:astreintePlanifie.id})">{{astreintePlanifie.id}}</a></td><td ng-class="astreintePlanifie.comment ? \'astreinteAlert\' : \'\'">{{astreintePlanifie.technicien}}</td><td ng-class="astreintePlanifie.comment ? \'astreinteAlert\' : \'\'">{{astreintePlanifie.date | date:\'mediumDate\'}}</td><td ng-class="astreintePlanifie.comment ? \'astreinteAlert\' : \'\'">{{astreintePlanifie.type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="astreinte-planifie-detail({id:astreintePlanifie.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="astreinte-planifie.edit({id:astreintePlanifie.id})" has-authority="ROLE_ADMIN" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="astreinte-planifie.delete({id:astreintePlanifie.id})" has-authority="ROLE_ADMIN" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/config/config-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.config.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.config.delete.question" translate-values="{id: \'{{vm.config.id}}\'}">Are you sure you want to delete this Config?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/config/config-detail.html','<div><h2><span data-translate="tmgApp.config.detail.title">Config</span> {{vm.config.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.config.name">Name</span></dt><dd><span>{{vm.config.name}}</span></dd><dt><span data-translate="tmgApp.config.description">Description</span></dt><dd><span>{{vm.config.description}}</span></dd><dt><span data-translate="tmgApp.config.type">Type</span></dt><dd><span data-translate="{{\'tmgApp.ConfigType.\' + vm.config.type}}">{{vm.config.type}}</span></dd><dt><span data-translate="tmgApp.config.value">Value</span></dt><dd><span>{{vm.config.value}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="config-detail.edit({id:vm.config.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/config/config-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConfigLabel" data-translate="tmgApp.config.home.createOrEditLabel">Create or edit a Config</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.config.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.config.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.config.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.config.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.config.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.config.description" rows="2"></textarea></div><div class="form-group"><label class="control-label" data-translate="tmgApp.config.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.config.type" id="field_type" required><option value="STRING" data-translate="tmgApp.ConfigType.String">String</option><option value="BOOLEAN" data-translate="tmgApp.ConfigType.Boolean">Boolean</option><option value="NUMERIC" data-translate="tmgApp.ConfigType.Numeric">Numeric</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.config.value" for="field_value">Value</label><!-- Cas sp\xE9cial : p\xE9riode de paie (entier entre 1 et 28). --> <input ng-if="vm.config.name === \'payroll_cutoff_day\'" type="number" class="form-control" name="value" id="field_value" ng-model="vm.config.value" min="1" max="28" step="1" required><!-- Cas par d\xE9faut : champ libre. --> <input ng-if="vm.config.name !== \'payroll_cutoff_day\'" type="text" class="form-control" name="value" id="field_value" ng-model="vm.config.value" required><div ng-show="editForm.value.$invalid"><p class="help-block" ng-show="editForm.value.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.value.$error.min || editForm.value.$error.max">La p\xE9riode de paie doit \xEAtre un jour entre 1 et 28.</p><p class="help-block" ng-show="editForm.value.$error.number || editForm.value.$error.step">La p\xE9riode de paie doit \xEAtre un nombre entier.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/config/configs.html','<div><h2 data-translate="tmgApp.config.home.title">Configs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="config.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.config.home.createLabel">Creer Config</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="tmgApp.config.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="tmgApp.config.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="tmgApp.config.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="value"><span data-translate="tmgApp.config.value">Value</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="config in vm.configs track by config.id"><td><a ui-sref="config-detail({id:config.id})">{{config.name}}</a></td><td>{{config.description}}</td><td data-translate="{{\'tmgApp.ConfigType.\' + config.type}}">{{config.type}}</td><td>{{config.value}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="config-detail({id:config.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="config.edit({id:config.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="config.delete({id:config.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/charge-technicien/charge-technicien-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.chargeTechnicien.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Etes-vous s\xFBr de vouloir supprimer cette charge?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/charge-technicien/charge-technicien-detail.html','<div><h2><span>ChargeTechnicien</span> {{vm.chargeTechnicien.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Id</span></dt><dd><span>{{vm.chargeTechnicien.id}}</span></dd><dt><span>Techniciens</span></dt><dd><div ng-repeat="technicien in vm.chargeTechnicien.techniciens">{{technicien}}</div></dd><dt><span>Intervention</span></dt><dd><a ui-sref="intervention-detail({id:vm.chargeTechnicien.intervention})">{{vm.chargeTechnicien.intervention}}</a></dd><dt><span>Date</span></dt><dd><span>{{vm.chargeTechnicien.date | date:\'yyyy-MM-dd\'}}</span></dd><dt><span>Type</span></dt><dd><span>{{vm.chargeTechnicien.type}}</span></dd><dt><span>Charge</span></dt><dd><span>{{vm.chargeTechnicien.charge}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.chargeTechnicien.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Retour</span></button> <button type="button" ui-sref="groupe-planning-detail.edit({id:vm.groupePlanning.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Editer</span></button></div>');
$templateCache.put('app/entities/charge-technicien/charge-technicien-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-show="!vm.chargeTechnicien.id" class="modal-title">Cr\xE9er une charge pour technicien</h4><h4 ng-show="vm.chargeTechnicien.id" class="modal-title">Editer une charge pour technicien</h4></div><div class="modal-body"><div class="form-group" ng-show="vm.chargeTechnicien.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chargeTechnicien.id" readonly="readonly"></div><div class="form-group form-technicien" style="background-color: white; padding: 0; margin-bottom: 1rem"><div class="technicien-label"><label class="control-label" for="field_technicien">Technicien</label></div><div class="techniciens"><div ng-repeat="technicien in vm.chargeTechnicien.techniciens"><span>{{technicien}}</span> <a class="text-danger" ng-click="vm.removeTech(technicien)"><span class="glyphicon glyphicon-trash"></span></a></div><div class="new-technicien"><select class="form-control" name="technicien" ng-model="vm.newTech" id="field_technicien"><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select><div class="form-group"><button type="button" class="btn btn-default btn-sm" ng-click="vm.addTech()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter</span></button></div></div></div><div ng-show="!vm.chargeTechnicien.techniciens.length > 0"><p class="help-block">Veuillez selectionner au moins un technicien</p></div></div><div class="form-group"><label for="field_date" class="control-label">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" datetime-picker="yyyy-MM-dd" enable-time="false" ng-model="vm.chargeTechnicien.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_type">Type</label><div><select id="field_type" class="form-control" name="type" ng-model="vm.chargeTechnicien.type"><option value="SALAIRE">SALAIRE</option><option value="OUTIL">OUTIL</option><option value="ACTIVITE">ACTIVITE</option><option value="CHARGE">CHARGE</option><option value="ASTREINTE">ASTREINTE</option><option value="REGUL">REGUL</option></select></div><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea name="description" id="field_description" class="form-control" ng-model="vm.chargeTechnicien.description"></textarea></div><div class="form-group"><label class="control-label" for="field_charge">Charge</label><input type="number" class="form-control" name="charge" id="field_charge" ng-model="vm.chargeTechnicien.charge" required><div ng-show="editForm.charge.$invalid"><p class="help-block" ng-show="editForm.charge.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.customFormError" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/charge-technicien/charge-technicien.html','<div><h2>Charge technicien</h2><div class="filterGroup"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control filterInput" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien" ng-change="vm.search()"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select></div></div><div class="filterSubGroup"><div class="form-group filterDate"><label for="filterDate">Date</label><div class="input-group"><input type="text" class="form-control filterInput" id="filterDate" ng-model="vm.filterDate" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="selectedMonth">Mois</label><select name="selectedMonth" id="selectedMonth" class="form-control filterInput" ng-model="vm.selectedMonth" ng-change="vm.filterByPeriod()"><option></option><option ng-repeat="month in vm.months" value="{{ month.value }}">{{ month.name }}</option></select></div><div class="form-group"><label for="selectedYear">Ann\xE9e</label><select class="form-control filterInput" name="selectedYear" ng-model="vm.selectedYear" id="selectedYear" ng-change="vm.filterByPeriod()"><option></option><option ng-repeat="year in vm.yearDispo">{{ year }}</option></select></div></div><div class="row"><div class="col-xs-1"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="charge-technicien.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er une nouvelle charge pour un technicien</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="techniciens"><span>Techniciens</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="intervention"><span>Intervention</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span>Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span>Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span>Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="charge"><span>Charge</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="chargeTechnicien in vm.chargeTechnicien track by chargeTechnicien.id"><td><a ui-sref="charge-technicien-detail({id:chargeTechnicien.id})">{{chargeTechnicien.id}}</a></td><td><div ng-repeat="technicien in chargeTechnicien.techniciens">{{technicien}}</div></td><td><a ui-sref="intervention-detail({id:chargeTechnicien.intervention})">{{chargeTechnicien.intervention}}</a></td><td>{{ (chargeTechnicien.description.length > 40) ? (chargeTechnicien.description.substr(0, 40) + \'(...)\') : chargeTechnicien.description }}</td><td>{{chargeTechnicien.type}}</td><td>{{chargeTechnicien.date}}</td><td style="text-align: right" ng-class="{\'text-green\': chargeTechnicien.charge < 0, \'text-red\': chargeTechnicien.charge > 0}">{{ chargeTechnicien.charge | currency:\'\u20AC\':2 }}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="charge-technicien-detail({id:chargeTechnicien.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="charge-technicien.edit({id:chargeTechnicien.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="charge-technicien.delete({id:chargeTechnicien.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/conges/conges-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.conges.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.conges.delete.question" translate-values="{id: \'{{vm.conges.id}}\'}">Are you sure you want to delete this Conges?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/conges/conges-detail.html','<div><h2><span data-translate="tmgApp.conges.detail.title">Conges</span> {{vm.conges.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.conges.technicien">Technicien</span></dt><dd><span>{{vm.conges.technicien}}</span></dd><dt><span data-translate="tmgApp.conges.date">Date</span></dt><dd><span>{{vm.conges.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="tmgApp.conges.dateEnd">Date End</span></dt><dd><span>{{vm.conges.dateEnd | date:\'mediumDate\'}}</span></dd><dt><span data-translate="type">Type</span></dt><dd><span>{{vm.conges.type}}</span></dd><dt><span data-translate="tmgApp.conges.paid">Paid</span></dt><dd><span>{{vm.conges.paid}}</span></dd><dt><span data-translate="tmgApp.conges.logs">Logs</span></dt><dd><table class="table table-striped"><thead><tr><th>Author</th><th>Date</th><th>Comment</th><th>Type</th></tr></thead><tbody><tr ng-repeat="log in vm.conges.congesLogs"><td>{{log.author}}</td><td>{{log.dateLog}}</td><td style="white-space: pre">{{log.comment}}</td><td>{{log.type}}</td></tr></tbody></table></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="conges-detail.edit({id:vm.conges.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/conges/conges-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCongesLabel" data-translate="tmgApp.conges.home.createOrEditLabel">Create or edit a Conges</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.conges.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.conges.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.conges.technicien" for="field_technicien">Technicien</label><select class="form-control" name="technicien" ng-model="vm.conges.technicien" id="field_technicien" ng-change="vm.loadEquipes()" required><option ng-if="vm.isAdmin" ng-repeat="technicien in vm.techniciens">{{ technicien.displayname }}</option><option ng-if="!vm.isAdmin">{{ vm.techFullDisplayname }}</option></select><div ng-show="editForm.technicien.$invalid"><p class="help-block" ng-show="editForm.technicien.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.conges.date" for="field_date">Date</label><div class="input-group"><input id="field_dateAdmin" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.conges.date" is-open="vm.datePickerOpenStatus.date" required ng-if="vm.isAdmin" ng-change="vm.loadEquipes()"> <input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.conges.date" is-open="vm.datePickerOpenStatus.date " required ng-if="!vm.isAdmin" ng-change="vm.loadEquipes()" two-months-advance> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div ng-show="editForm.date.$error.twoMonthsAdvance"><p class="help-block astreinteAlert" data-translate="tmgApp.conges.twoMonthsAdvance">You must anticipate your leave 2 months in advance in order to be able to organize. Please see with your supervisor.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.conges.dateEnd" for="field_dateEnd">Date End</label><div class="input-group"><input id="field_dateEndAdmin" type="text" class="form-control" name="dateEnd" uib-datepicker-popup="{{dateformat}}" ng-model="vm.conges.dateEnd" is-open="vm.datePickerOpenStatus.dateEnd" ng-if="vm.isAdmin" required ng-change="vm.loadEquipes()"> <input id="field_dateEnd" type="text" class="form-control" name="dateEnd" uib-datepicker-popup="{{dateformat}}" ng-model="vm.conges.dateEnd" is-open="vm.datePickerOpenStatus.dateEnd" ng-if="!vm.isAdmin" required two-months-advance ng-change="vm.loadEquipes()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateEnd\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dateEnd.$invalid"><p class="help-block" ng-show="editForm.dateEnd.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div ng-show="editForm.dateEnd.$error.twoMonthsAdvance"><p class="help-block astreinteAlert" data-translate="tmgApp.conges.twoMonthsAdvance">You must anticipate your leave 2 months in advance in order to be able to organize. Please see with your supervisor.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.conges.type" for="field_type">Type</label><div class="input-group"><select id="field_type" class="form-control" name="type" ng-model="vm.conges.type"><option value="CP">Cong\xE9 Pay\xE9</option><option ng-disabled="!vm.isAdmin" value="AT">Arr\xEAt de travail</option><option ng-disabled="!vm.isAdmin" value="CSS">Cong\xE9 sans solde</option><option ng-disabled="!vm.isAdmin" value="CHP">Ch\xF4mage partiel</option><option value="GD">Grand d\xE9placement</option><option ng-disabled="!vm.isAdmin" value="JD">Journ\xE9e d\xE9plac\xE9</option><option ng-disabled="!vm.isAdmin" value="JR">Journ\xE9e r\xE9cup\xE9r\xE9e</option></select></div><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" has-authority="ROLE_ADMIN"><label class="control-label" data-translate="tmgApp.conges.validate" for="field_validate">Validate</label><input type="checkbox" name="validate" id="field_validate" ng-model="vm.conges.validate"><div ng-show="editForm.paid.$invalid"><p class="help-block" ng-show="editForm.paid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><hr><table class="table table-striped"><thead><tr><th>Author</th><th>Date</th><th>Comment</th><th>Type</th></tr></thead><tbody><tr ng-repeat="log in vm.conges.congesLogs"><td>{{log.author}}</td><td>{{log.dateLog | date:\'d MMM yyyy\' }}</td><td style="white-space: pre">{{log.comment}}</td><td>{{log.type}}</td></tr></tbody></table><div class="form-group"><label class="control-label" data-translate="tmgApp.conges.comment" for="field_comment">Comment</label><input type="text" id="field_comment" class="form-control" name="comment" ng-model="vm.conges.comment"></div><hr><span ng-if="vm.equipes.length > 0 && vm.conges.type != \'GD\'" has-authority="ROLE_ADMIN" class="text-red">Ces \xE9quipes seront supprim\xE9es lors de la validation du cong\xE9s</span><table ng-if="vm.equipes.length > 0" has-authority="ROLE_ADMIN" class="table table-striped"><tr><th>Chef</th><th>Binome</th><th>Date</th></tr><tbody><tr ng-repeat="equipe in vm.equipes"><td>{{equipe.chef}}</td><td>{{equipe.binome}}</td><td>{{equipe.date | date:\'d MMM yyyy\'}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" ng-if="vm.conges.id !== null" ng-click="vm.deleteConge(vm.conges.id)" class="btn btn-danger pull-left"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/conges/conges.html','<div><h2 data-translate="tmgApp.conges.home.title">Conges</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="conges.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.conges.home.createLabel">Create new Conges</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span data-translate="tmgApp.conges.technicien">Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateStart"><span data-translate="tmgApp.conges.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateEnd"><span data-translate="tmgApp.conges.dateEnd">Date End</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="tmgApp.conges.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="paid"><span data-translate="tmgApp.conges.paid">Paid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="paid"><span data-translate="tmgApp.conges.validate">Validate</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="conges in vm.conges track by conges.id"><td><a ui-sref="conges-detail({id:conges.id})">{{conges.id}}</a></td><td>{{conges.technicien}}</td><td>{{conges.date | date:\'mediumDate\'}}</td><td>{{conges.dateEnd | date:\'mediumDate\'}}</td><td>{{conges.type}}</td><td>{{conges.paid}}</td><td>{{conges.validate}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="conges-detail({id:conges.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="conges.edit({id:conges.id})" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="conges.delete({id:conges.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/fleet-daily-trip/fleet-daily-trip-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.fleetDailyTrip.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.fleetDailyTrip.delete.question" translate-values="{id: \'{{vm.fleetDailyTrip.id}}\'}">\xCAtes-vous certain de vouloir supprimer ce trajet ?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/fleet-daily-trip/fleet-daily-trip-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="tmgApp.fleetDailyTrip.home.importLabel">Importer un fichier Masternaut</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="text-muted" data-translate="tmgApp.fleetDailyTrip.home.importHelp">S\xE9lectionnez un fichier de suivi d\'amplitude journali\xE8re (Masternaut). Les trajets existants pour les jours pr\xE9sents dans le fichier seront remplac\xE9s.</p><div class="form-group" ngf-drop ngf-change="vm.setFile($file)"><label class="control-label" data-translate="tmgApp.fleetDailyTrip.file" for="field_file">Fichier Excel</label><div><div ng-if="vm.fleetDailyTrip.file" class="help-block clearfix"><span class="pull-left"><strong>{{vm.fleetDailyTrip.fileName}}</strong> <span class="text-muted">&nbsp;({{vm.byteSize(vm.fleetDailyTrip.file)}})</span> </span><button type="button" ng-click="vm.fleetDailyTrip.file=null;vm.fleetDailyTrip.fileContentType=null;vm.fleetDailyTrip.fileName=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file)" ngf-pattern="\'.xlsx,.xls\'" data-translate="entity.action.addblob">Add blob</button></div></div><div class="alert alert-danger" ng-if="vm.errorMessage">{{ vm.errorMessage }}</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="!vm.fleetDailyTrip.file || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span data-translate="tmgApp.fleetDailyTrip.home.importLabel">Importer</span></button></div></form>');
$templateCache.put('app/entities/fleet-daily-trip/fleet-daily-trip-edit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="tmgApp.fleetDailyTrip.edit.title">Modifier le trajet</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="well well-sm" style="margin-bottom: 15px; padding: 14px 30px; text-align: center"><table style="width: 100%; border-collapse: collapse"><colgroup><col style="width: 50%"><col style="width: 50%"></colgroup><tbody><tr><td style="text-align: right; padding: 4px 24px 4px 0; color: #777; font-weight: 600" data-translate="tmgApp.fleetDailyTrip.date">Date</td><td style="text-align: left; padding: 4px 0 4px 24px; font-weight: 700">{{vm.fleetDailyTrip.date | date:\'dd/MM/yyyy\'}}</td></tr><tr><td style="text-align: right; padding: 4px 24px 4px 0; color: #777; font-weight: 600" data-translate="tmgApp.fleetDailyTrip.licencePlate">Plaque d\'immatriculation</td><td style="text-align: left; padding: 4px 0 4px 24px; font-weight: 700">{{vm.fleetDailyTrip.licencePlate}}</td></tr></tbody></table></div><div class="form-group"><label class="control-label" for="field_technicien" data-translate="tmgApp.fleetDailyTrip.technicien">Technicien</label><select id="field_technicien" class="form-control" name="technicien" ng-model="vm.fleetDailyTrip.technicien"><option value="" data-translate="tmgApp.fleetDailyTrip.withoutTechnicien">Sans technicien</option><option ng-repeat="t in vm.techniciens" value="{{t.displayname}}">{{t.displayname}}</option></select></div><div class="form-group"><label class="control-label" for="field_timeStart" data-translate="tmgApp.fleetDailyTrip.timeStart">D\xE9but</label><div class="input-group"><input id="field_timeStart" type="text" class="form-control" name="timeStart" required datetime-picker="yyyy-MM-dd HH:mm" ng-model="vm.fleetDailyTrip.timeStart" is-open="vm.datePickerOpenStatus.timeStart"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'timeStart\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_timeEnd" data-translate="tmgApp.fleetDailyTrip.timeEnd">Fin</label><div class="input-group"><input id="field_timeEnd" type="text" class="form-control" name="timeEnd" required datetime-picker="yyyy-MM-dd HH:mm" ng-model="vm.fleetDailyTrip.timeEnd" is-open="vm.datePickerOpenStatus.timeEnd"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'timeEnd\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="alert alert-danger" ng-if="vm.errorMessage">{{ vm.errorMessage }}</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/fleet-daily-trip/fleet-daily-trips.html','<div><h2 data-translate="tmgApp.fleetDailyTrip.home.title">Trajets Journaliers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row" style="margin-bottom: 10px"><div class="col-xs-3"><button class="btn btn-primary" ui-sref="fleet-daily-trip.new"><span class="glyphicon glyphicon-upload"></span> <span data-translate="tmgApp.fleetDailyTrip.home.importLabel">Importer un fichier Masternaut</span></button></div></div><div class="row" style="margin-bottom: 10px"><div class="col-md-3"><label data-translate="tmgApp.fleetDailyTrip.filterDate">Jour</label><div class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filterDate" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-3"><label data-translate="tmgApp.fleetDailyTrip.filterTechnicien">Technicien</label><select class="form-control" ng-model="vm.filterTechnicien"><option value="">-- Tous --</option><option value="{{vm.WITHOUT_TECHNICIEN}}" data-translate="tmgApp.fleetDailyTrip.withoutTechnicien">Sans technicien</option><option ng-repeat="t in vm.techniciens" value="{{t.displayname}}">{{t.displayname}}</option></select></div><div class="col-md-3" style="margin-top: 25px"><button class="btn btn-default" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="tmgApp.fleetDailyTrip.search">Rechercher</span></button> <button class="btn btn-default" ng-click="vm.resetFilters()"><span class="glyphicon glyphicon-erase"></span> <span data-translate="tmgApp.fleetDailyTrip.reset">R\xE9initialiser</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="date"><span data-translate="tmgApp.fleetDailyTrip.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="licencePlate"><span data-translate="tmgApp.fleetDailyTrip.licencePlate">Plaque</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span data-translate="tmgApp.fleetDailyTrip.technicien">Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timeStart"><span data-translate="tmgApp.fleetDailyTrip.timeStart">D\xE9but</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="timeEnd"><span data-translate="tmgApp.fleetDailyTrip.timeEnd">Fin</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="operationTimeHours"><span data-translate="tmgApp.fleetDailyTrip.operationTimeHours">Heures</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="distance"><span data-translate="tmgApp.fleetDailyTrip.distance">Distance (km)</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="trip in vm.fleetDailyTrips track by trip.id"><td>{{trip.date | date:\'dd/MM/yyyy\'}}</td><td>{{trip.licencePlate}}</td><td><span ng-if="trip.technicien">{{trip.technicien}}</span> <span ng-if="!trip.technicien" class="text-muted" data-translate="tmgApp.fleetDailyTrip.withoutTechnicien">Sans technicien</span></td><td>{{trip.timeStart | date:\'HH:mm\'}}</td><td>{{trip.timeEnd | date:\'HH:mm\'}}</td><td>{{trip.operationTimeHours}}</td><td>{{trip.distance}}</td><td class="text-right"><button type="button" ui-sref="fleet-daily-trip.edit({id:trip.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="fleet-daily-trip.delete({id:trip.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete">Delete</span></button></td></tr><tr ng-if="vm.fleetDailyTrips.length === 0"><td colspan="8" class="text-center text-muted" data-translate="tmgApp.fleetDailyTrip.empty">Aucun trajet</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/equipe/equipe-copy-modal.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Copier la journ\xE9e du {{vm.date}}</h4></div><div class="modal-body"><div ng-if="vm.copyErrorMsg" class="error-msg"><span style="color: red">{{vm.copyErrorMsg}}</span></div><div class="form-group"><label class="control-label" for="field_date">Copier vers le</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="fieldDate" ng-model="vm.selectedDate" uib-datepicker-popup="{{dateformat}}" is-open="vm.datePickerOpenStatus.month" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'month\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><!--        <button class="btn btn-primary" type="button" data-dismiss="modal" aria-hidden="true" ng-click="vm.copyToDate()">OK</button>--> <button class="btn btn-primary" type="button" aria-hidden="true" ng-click="vm.copyToDate()">OK</button></div></div>');
$templateCache.put('app/entities/equipe/equipe-dialog.html','<form name="editForm" role="form" novalidate show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEquipe">{{vm.date | date:\'fullDate\'}}</h4></div><div class="planning-equipe planning-equipe-edit"><div class="equipe-one-day equipe-one-day-edit"><h4>{{ day | date:\'fullDate\' }}</h4><div ng-repeat="groupePlanning in vm.groupesPlanning" ng-style="{\'background-color\': vm.colors[groupePlanning.color] ? vm.colors[groupePlanning.color].base : \'#BDBDBD\'}" class="groupe-planning"><div class="groupe-title" ng-style="{\'background-color\': vm.colors[groupePlanning.color] ? vm.colors[groupePlanning.color].title : \'#8C8C8B\'}" ng-class="{\'first-groupe\': $first}"><span>{{groupePlanning.name}}</span></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Chef</span></th><th><span>Binome</span></th><th><span>Outil</span></th><th></th></tr></thead><tbody><tr ng-style="{\'background-color\': vm.colors[groupePlanning.color] ? vm.colors[groupePlanning.color].base : \'#BDBDBD\'}" ng-repeat="equipe in vm.equipes[groupePlanning.id]"><td><span ng-show="!equipe.editing">{{equipe.chef}}</span><select class="form-control" ng-show="equipe.editing" ng-model="equipe.chef"><option ng-value="equipe.chef">{{equipe.chef}}</option><option ng-repeat="technicien in vm.getTechnicienForTeam(equipe.binome)" value="{{technicien.displayname}}">{{technicien.displayname}}</option></select></td><td><div ng-show="!equipe.editing">{{equipe.binome}}</div><select class="form-control" ng-show="equipe.editing" ng-model="equipe.binome"><option value="">aucun</option><option ng-if="equipe.binome" ng-value="equipe.binome">{{equipe.binome}}</option><option ng-repeat="technicien in vm.getTechnicienForTeam(equipe.chef)" value="{{technicien.displayname}}">{{technicien.displayname}}</option></select></td><td><div ng-show="!equipe.editing" ng-repeat="outil in equipe.outils"><span>{{outil.code}}: {{outil.name}}</span></div><div ng-dropdown-multiselect="" class="outilMultiselect" ng-show="equipe.editing" options="vm.outils" selected-model="equipe.outils" extra-settings="vm.dropdownSettings" translation-texts="vm.dropdownTranslation"></div></td><td><div><button type="submit" ng-show="!equipe.editing" ng-click="equipe.editing = !equipe.editing; vm.inEditingState = !vm.inEditingState; vm.copyActualEquipe(equipe)" class="btn btn-primary" ng-disabled="vm.inEditingState"><span>Editer</span></button> <button type="submit" ng-click="equipe.editing = !equipe.editing; vm.inEditingState = false; vm.updateEquipe(equipe)" ng-show="equipe.editing" class="btn btn-success"><span>Valider</span></button> <button type="submit" ng-show="!equipe.editing" ng-click="vm.deleteEquipe(equipe)" class="btn btn-danger btn-sm" ng-disabled="vm.inEditingState"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="submit" ng-click="equipe.editing = !equipe.editing; vm.inEditingState = false; vm.loadEquipes()" ng-show="equipe.editing" class="btn btn-warning btn-sm"><span>Annuler</span></button></div></td></tr><tr ng-style="{\'background-color\': vm.colors[groupePlanning.color] ? vm.colors[groupePlanning.color].base : \'#BDBDBD\'}"><td style="width: 24.85%"><select class="form-control" ng-model="vm.newEquipes[groupePlanning.id].chef" ng-change="vm.adaptOutilForChef(vm.newEquipes[groupePlanning.id])"><option value="" disabled="disabled">-- chef --</option><option ng-repeat="technicien in vm.getTechnicienForTeam(vm.newEquipes[groupePlanning.id].binome)" value="{{technicien.displayname}}">{{technicien.displayname}}</option></select></td><td style="width: 24.85%"><select class="form-control" ng-model="vm.newEquipes[groupePlanning.id].binome"><option value="" disabled="disabled">-- binome --</option><option value="">aucun</option><option ng-repeat="technicien in vm.getTechnicienForTeam(vm.newEquipes[groupePlanning.id].chef)" value="{{technicien.displayname}}">{{technicien.displayname}}</option></select></td><td style="width: 24.85%"><div ng-dropdown-multiselect="" class="outilMultiselect" ng-init="vm.initNewEquipes(groupePlanning.id)" options="vm.outils" selected-model="vm.newEquipes[groupePlanning.id].outilIds" extra-settings="vm.dropdownSettings" translation-texts="vm.dropdownTranslation"></div></td><td><button ng-click="vm.addEquipe(groupePlanning.id); vm.inEditingState = false" class="btn btn-success" ng-disabled="!vm.newEquipes[groupePlanning.id].chef"><span>Ajouter</span></button></td></tr></tbody></table></div></div></div></div></form>');
$templateCache.put('app/entities/equipe/equipe.html','<div><div class="row filters"><div class="day-filter-group"><div class="form-group"><label class="control-label" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control equipe-filter-input equipe-filter-day" name="fieldDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filterDate" is-open="vm.datePickerOpenStatus.month" ng-change="vm.filterByDate()" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'month\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="weekFilterGroup"><div class="form-group"><label for="filterYear">Ann\xE9e</label><select class="form-control equipe-filter-input" name="filterYear" ng-model="vm.filterYear" id="filterYear"><option></option><option ng-repeat="year in vm.yearDispo">{{ year }}</option></select></div><div class="form-group"><label for="filterWeek">Semaine</label><select name="filterWeek" id="filterWeek" class="form-control equipe-filter-input" ng-model="vm.filterWeek" ng-change="vm.filterByWeekNumber()"><option></option><option value="{{ $index+1 }}" ng-repeat="x in [].constructor(52) track by $index">{{ $index+1 }}</option></select></div></div></div><div ng-if="vm.copyErrorMsg" class="error-msg"><span style="color: red">{{vm.copyErrorMsg}}</span></div><div style="max-width: 1000px; margin: auto"><div class="row"><div class="col-md-7"><h2 class="text-capitalize">Semaine {{vm.weekNumber}}</h2></div><div class="col-md-5 text-right"><nav aria-label="..."><ul class="pagination"><li class="page-item" ng-click="vm.previousWeek()"><span class="page-link">Semaine pr\xE9c\xE9dent</span></li><li ng-click="vm.actualWeek()"><span class="page-link">Semaine actuel</span></li><li ng-click="vm.nextWeek()"><span class="page-link">Semaine suivante</span></li></ul></nav></div></div></div><div class="planning-equipe"><div ng-repeat="day in vm.currentWeek" class="equipe-day-group"><div class="equipe-one-day"><h4>{{ day | date:\'fullDate\' }}</h4><div class="day-topbar"><div class="btn-group" style="margin-top: 1rem; margin-bottom: 1rem"><button class="btn btn-primary" ui-sref="equipe.edit({date: vm.formatDate(day)})"><span>Editer</span></button> <button class="btn btn-primary" ui-sref="equipe.copy({date: vm.formatDate(day)})"><span>Copier</span></button></div><div class="technicien-ratio" ng-class="{\r\n                         \'text-red\': vm.getTechNumberForDay(day) < vm.availableTechniciensDates[$index].availableTechniciens.length,\r\n                         \'text-green\': vm.getTechNumberForDay(day) == vm.availableTechniciensDates[$index].availableTechniciens.length\r\n                         }"><span>{{vm.getTechNumberForDay(day)}}/{{vm.availableTechniciensDates[$index].availableTechniciens.length}}</span></div></div><div ng-repeat="groupePlanning in vm.groupesPlanning" class="groupe-planning" ng-if="$index === 0 || !vm.isGroupeEmpty(groupePlanning.id, day)" ng-style="{\'background-color\': vm.colors[groupePlanning.color] ? vm.colors[groupePlanning.color].base : \'#BDBDBD\'}"><div class="groupe-title" ng-class="{\'first-groupe\': $first}" ng-style="{\'background-color\': vm.colors[groupePlanning.color] ? vm.colors[groupePlanning.color].title : \'#8C8C8B\'}"><span>{{groupePlanning.name}}</span></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Chef</span></th><th><span>Binome</span></th><th><span>Outils</span></th></tr></thead><tbody class="planning-table-body"><tr ng-style="{\'background-color\': vm.colors[groupePlanning.color] ? vm.colors[groupePlanning.color].base : \'#BDBDBD\'}" ng-repeat="equipe in vm.equipes[day.toDateString()][groupePlanning.id]"><td>{{vm.formatTechName(equipe.chef)}}</td><td ng-if="equipe.binome">{{vm.formatTechName(equipe.binome)}}</td><td ng-if="!equipe.binome"></td><td><div ng-repeat="code in equipe.outilCodes" data-bs-toggle="tooltip" data-bs-placement="top" title="{{vm.getTooltipContent(equipe.outilCodes)}}"><span ng-if="vm.isShowOutilTrue(code)">{{code}}</span></div></td></tr></tbody></table></div></div></div><div class="copyBtns copyBtnsBase" ng-if="!$last"><div class="dayCopyBtn" ng-click="vm.copyToNextDay(day)"><span>></span></div><div class="dayCopyBtn" ng-click="vm.copyToAllWeek(day)"><span>>></span></div></div><div class="copyBtns copyBtnsResponsive" ng-if="!$last"><div class="dayCopyBtn" ng-click="vm.copyToNextDay(day)"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><style>svg{fill:#ffffff}</style><path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></div><div class="dayCopyBtn" ng-click="vm.copyToAllWeek(day)"><span><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><style>svg{fill:#ffffff}</style><path d="M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"/></svg></span></div></div></div></div></div>');
$templateCache.put('app/entities/export-praxedo/export-praxedo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.exportPraxedo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.exportPraxedo.delete.question" translate-values="{id: \'{{vm.exportPraxedo.name}}\'}">Are you sure you want to delete this import file intervention?</p><p class="text-danger">Toutes les interventions import\xE9es par ce fichiers seront supprim\xE9es</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/export-praxedo/export-praxedo-detail.html','<div><h2><span data-translate="tmgApp.exportPraxedo.detail.title">Import file intervention</span> {{vm.exportPraxedo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.exportPraxedo.filename">filename</span></dt><dd><span>{{vm.exportPraxedo.filename}}</span></dd><dt><span data-translate="tmgApp.exportPraxedo.date">Date</span></dt><dd><span>{{vm.exportPraxedo.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="tmgApp.exportPraxedo.creationDate">Creation Date</span></dt><dd><span>{{vm.exportPraxedo.creationDate | date:\'medium\'}}</span></dd><dt>CSV</dt><dd><div ng-if="!vm.exportPraxedo.empty"><a ng-click="vm.download()">Ouvrir</a> {{vm.exportPraxedo.filename}}</div></dd><dt><span data-translate="tmgApp.exportPraxedo.type">Type</span></dt><dd><span>{{vm.exportPraxedo.type}}</span></dd><dt><span data-translate="tmgApp.exportPraxedo.errorMessage">Error message</span></dt><dd><span style="word-wrap: break-word">{{vm.exportPraxedo.errorParsing}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="export-praxedo-detail.edit({id:vm.exportPraxedo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/export-praxedo/export-praxedo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myExportPraxedoLabel" data-translate="tmgApp.exportPraxedo.home.createOrEditLabel">Create or edit a import file</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.exportPraxedo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.exportPraxedo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.exportPraxedo.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.exportPraxedo.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.exportPraxedo.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.exportPraxedo.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.exportPraxedo.csv" for="field_csv">Csv</label><input type="text" class="form-control" name="csv" id="field_csv" ng-model="vm.exportPraxedo.csv" required><div ng-show="editForm.csv.$invalid"><p class="help-block" ng-show="editForm.csv.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.exportPraxedo.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" datetime-picker="{{dateformat}}" ng-model="vm.exportPraxedo.creationDate" is-open="vm.datePickerOpenStatus.creationDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.creationDate.$invalid"><p class="help-block" ng-show="editForm.creationDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.creationDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.exportPraxedo.proceed" for="field_proceed">Proceed</label><input type="checkbox" class="form-control" name="proceed" id="field_proceed" ng-model="vm.exportPraxedo.proceed"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.exportPraxedo.nbInterventions" for="field_nbInterventions">nbInterventions</label><input type="text" class="form-control" name="csv" id="field_nbInterventions" ng-model="vm.exportPraxedo.nbInterventions" required></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/export-praxedo/export-praxedo-newFile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myExportPraxedoLabel" data-translate="tmgApp.exportPraxedo.home.createOrEditLabel">Create or edit a import file intervention</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.exportPraxedo)"><label for="field_file" data-translate="tmgApp.exportPraxedo.file"></label><div><div ng-repeat="file in vm.exportPraxedo.files" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(file.fileContentType, file.file)" data-translate="entity.action.open"></a><br><span class="pull-left">{{file.fileName}}, {{vm.byteSize(file.file)}}</span> <button type="button" ng-click="vm.removeFile(file)" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select="vm.setFile($files, vm.exportPraxedo)" ngf-multiple="true" class="btn btn-default btn-block" ngf-change="vm.setFiles($files, vm.exportPraxedo)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="files" id="field_file" ng-model="vm.exportPraxedo.files" required></div><div class="form-group"><select name="typeImport" id="typeImport" ng-model="vm.exportPraxedo.typeImport" class="form-control" required><option value="SOGETREL">SOGETREL</option><option value="PRAXEDO">PRAXEDO</option><option value="KYNTUS">KYNTUS</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.exportPraxedo.files.length === 0" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/export-praxedo/export-praxedos.html','<div><h2 data-translate="tmgApp.exportPraxedo.home.title">Import file</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ng-click="vm.processMails()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="tmgApp.exportPraxedo.home.processMails">Process Mails</span></button> <button class="btn btn-primary" ui-sref="export-praxedo.newPraxedo"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.exportPraxedo.home.newPraxedo">New import file</span></button></div></div></div><br><div class="container-fluid"><!--        <div class="row">--><!--        \t<div class="col-xs-12 col-md-2">--><!--\t\t        <div class="form-group">--><!--\t\t            <label for="filterName">Date Mail Import</label>--><!--\t\t            <input type="text" class="form-control" id="filterName" ng-model="vm.filterName" pattern="[0-9]{4}-.*"/>--><!--\t\t        </div>--><!--        \t</div>--><!--        </div>--><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterSearch">Rechercher</label><input type="text" class="form-control" id="filterSearch" ng-model="vm.filterSearch" ng-enter="vm.search()"></div></div><div class="col-xs-12 col-md-2"><label class="control-label" for="field_type">Type</label><div><select id="field_type" class="form-control" name="type" ng-model="vm.filterType" ng-change="vm.search()"><option value=""></option><option value="PRAXEDO">PRAXEDO</option><option value="SOGETREL">SOGETREL</option><option value="KYNTUS">KYNTUS</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterDateFrom">Du</label><div class="input-group"><input type="text" class="form-control" id="filterDateFrom" ng-model="vm.filterDateFrom" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterDateTo">Au</label><div class="input-group"><input type="text" class="form-control" id="filterDateTo" ng-model="vm.filterDateTo" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateTo\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="form-group"><input type="checkbox" name="filterError" id="filterError" ng-model="vm.filterError"><label for="filterError">Afficher les fichiers en erreur</label></div><div class="row"><div class="col-xs-2"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Rechercher</span></button></div><div class="col-xs-2"><button class="btn btn-primary" ng-click="vm.resetProcess()"><span class="glyphicon glyphicon-refresh"></span> <span>Process again</span></button></div><div class="col-xs-2"><button class="btn btn-primary" ng-click="vm.resetProcessPraxedo()"><span class="glyphicon glyphicon-refresh"></span> <span>Process all import</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="filename">Filename <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type">Type <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="tmgApp.exportPraxedo.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationDate"><span data-translate="tmgApp.exportPraxedo.creationDate">Creation Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="proceed"><span data-translate="tmgApp.exportPraxedo.proceed">proceed</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Error</span></th><th jh-sort-by="nbInterventions"><span data-translate="tmgApp.exportPraxedo.nbInterventions">nbInterventions</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="exportPraxedo in vm.exportPraxedos track by exportPraxedo.id"><td><a ui-sref="export-praxedo-detail({id:exportPraxedo.id})">{{exportPraxedo.id}}</a></td><td>{{exportPraxedo.filename}}</td><td>{{exportPraxedo.type}}</td><td>{{exportPraxedo.date | date:\'mediumDate\'}}</td><td>{{exportPraxedo.creationDate | date:\'medium\'}}</td><td>{{exportPraxedo.proceed}}</td><td>{{exportPraxedo.errorParsing | limitTo: 100}}...</td><td><a ui-sref="intervention({filename:exportPraxedo.filename})">{{exportPraxedo.nbInterventions}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.resetProcessById(exportPraxedo.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-sm-down" data-translate="process"></span></button> <button type="submit" ui-sref="export-praxedo-detail({id:exportPraxedo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="export-praxedo.edit({id:exportPraxedo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="export-praxedo.delete({id:exportPraxedo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/groupe-planning/groupe-planning-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.groupePlanning.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Etes-vous s\xFBr de vouloir supprimer ce groupe pour planning?</p><p style="color: red">Attention! Toutes les \xE9quipes li\xE9es \xE0 ce groupe seront elles aussi supprim\xE9es.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/groupe-planning/groupe-planning-detail.html','<div><h2><span>Groupe planning</span> {{vm.groupePlanning.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.groupePlanning.name}}</span></dd><dt><span>Id</span></dt><dd><span>{{vm.groupePlanning.id}}</span></dd><dt><span>Actif</span></dt><dd ng-show="groupePlanning.enabled"><span>Oui</span></dd><dd ng-show="!groupePlanning.enabled"><span>Non</span></dd><dt><span>Couleur</span></dt><dd><span>{{vm.groupePlanning.color}}</span></dd><dt><span>Ordre</span></dt><dd><span>{{vm.groupePlanning.order}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Retour</span></button> <button type="button" ui-sref="groupe-planning-detail.edit({id:vm.groupePlanning.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Editer</span></button></div>');
$templateCache.put('app/entities/groupe-planning/groupe-planning-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-show="!vm.groupePlanning.id" class="modal-title">Cr\xE9er un groupe pour planning</h4><h4 ng-show="vm.groupePlanning.id" class="modal-title">Editer un groupe pour planning</h4></div><div class="modal-body"><div class="form-group" ng-show="vm.groupePlanning.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.groupePlanning.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.groupePlanning.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_enabled">Actif</label><input type="checkbox" name="enabled" id="field_enabled" ng-model="vm.groupePlanning.enabled"></div><div class="form-group"><label for="field_color" class="control-label">Couleur</label><select class="form-control" name="color" id="field_color" ng-model="vm.groupePlanning.color" required><option ng-repeat="color in vm.colors" value="{{color}}">{{color}}</option></select><div ng-show="editForm.color.$invalid"><p class="help-block" ng-show="editForm.color.$error.required" data-translate="entity.validation.required">Ce champ est obligatoire.</p></div></div><div class="form-group"><label for="field_order" class="control-label">Ordre</label><input type="number" class="form-control" name="order" id="field_order" ng-model="vm.groupePlanning.order" required><div ng-show="editForm.order.$invalid"><p class="help-block" ng-show="editForm.order.$error.required" data-translate="entity.validation.required">Ce champ est obligatoire.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/groupe-planning/groupe-planning.html','<div><h2>Groupe planning</h2><div class="row"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="groupe-planning.new"><span class="glyphicon glyphicon-plus"></span> <span>Cr\xE9er un nouveau groupe pour planning</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="enabled"><span>Actif</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="color"><span>Couleur</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="order"><span>Ordre</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="groupePlanning in vm.groupePlanning track by groupePlanning.id"><td><a ui-sref="groupe-planning-detail({id:groupePlanning.id})">{{groupePlanning.id}}</a></td><td>{{groupePlanning.name}}</td><td ng-show="groupePlanning.enabled">Oui</td><td ng-show="!groupePlanning.enabled">Non</td><td>{{groupePlanning.color}}</td><td>{{groupePlanning.order}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="groupe-planning-detail({id:groupePlanning.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="groupe-planning.edit({id:groupePlanning.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="groupe-planning.delete({id:groupePlanning.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/indicator-file/indicator-file-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.indicatorFile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.indicatorFile.delete.question" translate-values="{id: \'{{vm.indicatorFile.id}}\'}">Are you sure you want to delete this Indicator File?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/indicator-file/indicator-file-detail.html','<div><h2><span data-translate="tmgApp.indicatorFile.detail.title">Indicator File</span> {{vm.indicatorFile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.indicatorFile.filename">Filename</span></dt><dd><span>{{vm.indicatorFile.filename}}</span></dd><dt><span data-translate="tmgApp.indicatorFile.agence">Agence</span></dt><dd><span>{{vm.indicatorFile.agence}}</span></dd><dt><span data-translate="tmgApp.indicatorFile.category">Category</span></dt><dd><span>{{vm.indicatorFile.category}}</span></dd><dt><span data-translate="tmgApp.indicatorFile.typeIndicator">Type Indicator</span></dt><dd><span>{{vm.indicatorFile.typeIndicator}}</span></dd><dt>CSV</dt><dd><a ng-click="vm.download()">Ouvrir</a> {{vm.indicatorFile.filename}}</dd><dt><span data-translate="tmgApp.indicatorFile.imported">Imported</span></dt><dd><span>{{vm.indicatorFile.imported}}</span></dd><dt><span data-translate="tmgApp.indicatorFile.ignored">Ignored</span></dt><dd><span>{{vm.indicatorFile.ignored}}</span></dd><dt><span>Date d\'import</span></dt><dd><span>{{vm.indicatorFile.creationDate | date:\'longDate\'}}</span></dd><dt><span>Erreur</span></dt><dd><span>{{vm.indicatorFile.error}}</span></dd><dt ng-if="vm.indicatorFile.stacktrace"><span>Stacktrace</span></dt><dd><span>{{vm.indicatorFile.stacktrace}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="indicator-file-detail.edit({id:vm.indicatorFile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button ng-click="vm.redownload(vm.indicatorFile.id)" class="btn btn-success btn-sm" ng-disabled="vm.disabled(vm.indicatorFile.error)"><span class="glyphicon glyphicon-download"></span> <span class="hidden-sm-down" data-translate="tmgApp.indicatorFile.redownload"></span></button></div>');
$templateCache.put('app/entities/indicator-file/indicator-file-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIndicatorFileLabel" data-translate="tmgApp.indicatorFile.home.createOrEditLabel">Create or edit a Indicator File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.zipFile)"><label class="control-label" data-translate="tmgApp.zipFile.file" for="field_file">File</label><div><div ng-if="vm.zipFile.file" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.zipFile.fileContentType, vm.zipFile.file)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.zipFile.fileContentType}}, {{vm.byteSize(vm.zipFile.file)}}</span> <button type="button" ng-click="vm.zipFile.file=null;vm.zipFile.fileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, vm.zipFile)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.zipFile.file" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.zipFile.fileContentType"><div ng-show="editForm.file.$invalid"><p class="help-block" ng-show="editForm.file.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.zipFile.filename" for="field_filename">File Name</label><input type="text" class="form-control" name="filename" id="field_filename" ng-model="vm.zipFile.filename" required><div ng-show="editForm.filename.$invalid"><p class="help-block" ng-show="editForm.filename.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/indicator-file/indicator-files.html','<div><h2 data-translate="tmgApp.indicatorFile.home.title">Indicator Files</h2><jhi-alert></jhi-alert><br><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterSearch">Search</label><input type="text" class="form-control" id="filterSearch" ng-model="vm.filterSearch" ng-enter="vm.search()"></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterAgence">Agence</label><select class="form-control" id="filterAgence" ng-model="vm.filterAgence" ng-change="vm.search()"><option></option><option>DONF</option><option>DOCE</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterCategory">Category</label><select class="form-control" id="filterCategory" ng-model="vm.filterCategory" ng-change="vm.search()"><option></option><option>CRIC</option><option>DP15</option><option>GR</option><option>MEO</option><option>RD2</option><option>TAUX DE FACTUE</option><option>TAUX MUTATIONS</option><option>TEP</option><option>TIRE</option><option>TRLC</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterTypeIndicator">Type Indicator</label><select class="form-control" id="filterTypeIndicator" ng-model="vm.filterTypeIndicator" ng-change="vm.search()"><option></option><option>CRIC</option><option>DP15 JOURS</option><option>DP15 JOURS FTTH</option><option>GR ETRM</option><option>GR ETRM E [ENT]</option><option>GR ETRM PE [ENT]</option><option>GR ETRM SU</option><option>MEO TEXCPI</option><option>MEO TEXCPI IE</option><option>RD2</option><option>RD2 WHOLESALE</option><option>TAUX DE FACTURE CIBLE</option><option>TAUX MUTATIONS TIC</option><option>TEP</option><option>TEP FTTH</option><option>NEW TEP</option><option>TIRE [ENT]</option><option>TRLC</option><option>TRLC FTTH</option><option>TRLC FTTH PE [ENT]</option><option>TRLC PE [ENT]</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterImported">Imported</label><select class="form-control" id="filterImported" ng-model="vm.filterImported" ng-change="vm.search()"><option></option><option value="true">OUI</option><option value="false">NON</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterIgnored">Ignored</label><select class="form-control" id="filterIgnored" ng-model="vm.filterIgnored" ng-change="vm.search()"><option></option><option value="true">OUI</option><option value="false">NON</option></select></div></div></div><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterError">Erreur</label><select class="form-control" id="filterError" ng-model="vm.filterError" ng-change="vm.search()"><option></option><option value="true">OUI</option><option value="false">NON</option></select></div></div></div></div><br><div class="container-fluid"><div class="row"><div class="col-xs-1"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div><div class="col-xs-2"><button class="btn btn-primary" ui-sref="indicator-file.new"><span class="glyphicon glyphicon-plus"></span> <span>Importer un fichier ZIP</span></button></div><div class="col-xs-3"><button class="btn btn-primary" ng-click="vm.importIndicators()"><span class="glyphicon glyphicon-refresh"></span> <span>Importer les nouveaux fichiers</span></button></div></div><br><div class="row"><div class="col-xs-4"><button class="btn btn-warning" ng-click="vm.resetByFilter()"><span class="glyphicon glyphicon-refresh"></span> <span>R\xE9-importer les fichiers</span></button></div><div class="col-xs-4"><button class="btn btn-primary" ng-click="vm.importNonImportedIndicators()"><span class="glyphicon glyphicon-refresh"></span> <span>Process non imported</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="filename"><span data-translate="tmgApp.indicatorFile.filename">Filename</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="agence"><span data-translate="tmgApp.indicatorFile.agence">Agence</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span data-translate="tmgApp.indicatorFile.category">Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="typeIndicator"><span data-translate="tmgApp.indicatorFile.typeIndicator">Type Indicator</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nbIndicators"><span data-translate="tmgApp.indicatorFile.nbIndicators">Nb Indicators</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ignore"><span data-translate="tmgApp.indicatorFile.ignored">Ignored</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imported"><span data-translate="tmgApp.indicatorFile.imported">Imported</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="error"><span>Erreur</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="creationDate"><span>Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="indicatorFile in vm.indicatorFiles track by indicatorFile.id"><td><a ui-sref="indicator-file-detail({id:indicatorFile.id})">{{indicatorFile.id}}</a></td><td>{{indicatorFile.filename}}</td><td>{{indicatorFile.agence}}</td><td>{{indicatorFile.category}}</td><td>{{indicatorFile.typeIndicator}}</td><td>{{indicatorFile.nbIndicators}}</td><td>{{indicatorFile.ignored}}</td><td>{{indicatorFile.imported}}</td><td>{{indicatorFile.error}}</td><td>{{indicatorFile.creationDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.reimportFile(indicatorFile.id)" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-repeat"></span> <span class="hidden-sm-down" data-translate="tmgApp.indicatorFile.reimport"></span></button> <button ng-click="vm.redownload(indicatorFile.id)" class="btn btn-success btn-sm" ng-disabled="vm.disabled(indicatorFile.error)"><span class="glyphicon glyphicon-download"></span> <span class="hidden-sm-down" data-translate="tmgApp.indicatorFile.redownload"></span></button> <button type="submit" ui-sref="indicator-file-detail({id:indicatorFile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="indicator-file.edit({id:indicatorFile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="indicator-file.delete({id:indicatorFile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/point/point-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.point.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.point.delete.question" translate-values="{id: \'{{vm.point.id}}\'}">Are you sure you want to delete this Point?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/point/point-detail.html','<div><h2><span data-translate="tmgApp.point.detail.title">Point</span> {{vm.point.id}}</h2><hr><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.point.article">Activity</span></dt><dd><span>{{vm.point.activity}}</span></dd><dt><span data-translate="tmgApp.point.category">Category</span></dt><dd><span>{{vm.point.category}}</span></dd><dt><span data-translate="tmgApp.point.pointChefMonome">Point Chef Monome</span></dt><dd><span>{{vm.point.pointChefMonome}}</span></dd><dt><span data-translate="tmgApp.point.pointChefBinome">Point Chef Binome</span></dt><dd><span>{{vm.point.pointChefBinome}}</span></dd><dt><span data-translate="tmgApp.point.pointSupportBinome">Point Technicien</span></dt><dd><span>{{vm.point.pointSupportBinome}}</span></dd><dt><span data-translate="tmgApp.point.pointObjectif">Point Objectif</span></dt><dd><span>{{vm.point.pointObjectif}}</span></dd><dt><span>Prix moyen</span></dt><dd><span>{{vm.point.averagePrice | currency:\'\u20AC\':2 }}</span></dd><dt><span>Regex</span></dt><dd><span>{{vm.point.regex}}</span> <button ng-if="vm.point.regex" type="button" ng-click="vm.adaptInterventions()" class="btn btn-warning" style="margin-left: 8rem"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-sm-down">Adapter les interventions existantes avec la regex</span></button></dd><dt><span>Liste de points compatibles</span></dt><dd><span>{{vm.point.compatiblePoints}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="point-detail.edit({id:vm.point.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/point/point-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPointLabel" data-translate="tmgApp.point.home.createOrEditLabel">Create or edit a Point</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.point.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.point.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.point.article" for="field_activity">Activity</label><input type="text" class="form-control" name="activity" id="field_activity" ng-model="vm.point.activity" required><div ng-show="editForm.activity.$invalid"><p class="help-block" ng-show="editForm.activity.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.point.category" for="field_category">Category</label><input type="text" class="form-control" name="category" id="field_category" ng-model="vm.point.category" required><div ng-show="editForm.category.$invalid"><p class="help-block" ng-show="editForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.point.pointChefMonome" for="field_pointChefMonome">Point Chef Monome</label><input type="number" class="form-control" name="pointChefMonome" id="field_pointChefMonome" ng-model="vm.point.pointChefMonome" required><div ng-show="editForm.pointChefMonome.$invalid"><p class="help-block" ng-show="editForm.pointChefMonome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pointChefMonome.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.point.pointChefBinome" for="field_pointChefBinome">Point Chef Binome</label><input type="number" class="form-control" name="pointChefBinome" id="field_pointChefBinome" ng-model="vm.point.pointChefBinome" required><div ng-show="editForm.pointChefBinome.$invalid"><p class="help-block" ng-show="editForm.pointChefBinome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pointChefBinome.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.point.pointSupportBinome" for="field_pointSupportBinome">Point Technicien</label><input type="number" class="form-control" name="pointSupportBinome" id="field_pointSupportBinome" ng-model="vm.point.pointSupportBinome" required><div ng-show="editForm.pointSupportBinome.$invalid"><p class="help-block" ng-show="editForm.pointSupportBinome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pointSupportBinome.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.point.pointObjectif" for="field_pointObjectif">Point Objectif</label><input type="number" class="form-control" name="pointObjectif" id="field_pointObjectif" ng-model="vm.point.pointObjectif"></div><div class="form-group"><label class="control-label" for="field_averagePrice">Prix moyen</label><input type="number" class="form-control" name="pointObjectif" id="field_averagePrice" ng-model="vm.point.averagePrice"></div><div class="form-group"><label class="control-label" for="field_regex">Regex</label><input type="text" class="form-control" name="pointObjectif" id="field_regex" ng-model="vm.point.regex"></div><div class="form-group"><label class="control-label" for="field_compatiblePoints">Liste de points compatibles</label><input type="text" class="form-control" name="compatiblePoints" id="field_compatiblePoints" ng-model="vm.point.compatiblePoints" placeholder="Regex s\xE9par\xE9es par des virgules"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/point/points.html','<div><h2 data-translate="tmgApp.point.home.title">Points</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2"><label for="filterActivity">Activit\xE9</label><input type="text" class="form-control" id="filterActivity" ng-model="vm.filterActivity" ng-enter="vm.search()"></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterCategories">Categories</label><select class="form-control" name="filterCategories" ng-model="vm.filterCategory" ng-change="vm.search()"><option value=""></option><option ng-repeat="categorie in vm.categories">{{categorie}}</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label><input type="checkbox" ng-model="vm.showDerivedPoints">Voir les Point d\xE9riv\xE9s</label></div></div></div><div class="row"><div class="col-xs-1"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div></div><br><div class="row"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="point.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.point.home.createLabel">Create new Point</span></button> <button class="btn btn-primary" ng-click="vm.importMultiple()"><span class="glyphicon glyphicon-plus"></span> <span>Import Multiple</span></button> <button class="btn btn-primary" ng-click="vm.export()"><span class="glyphicon glyphicon-plus"></span> <span>Export</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="activity"><span data-translate="tmgApp.point.article">Activity</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span data-translate="tmgApp.point.category">Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pointChefMonome"><span data-translate="tmgApp.point.pointChefMonome">Point Chef Monome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pointChefBinome"><span data-translate="tmgApp.point.pointChefBinome">Point Chef Binome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pointSupportBinome"><span data-translate="tmgApp.point.pointSupportBinome">Point Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pointObjectif"><span data-translate="tmgApp.point.pointObjectif">Point Objectif</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="averagePrice"><span>Prix moyen</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat-start="point in vm.points track by point.id"><td><a ui-sref="point-detail({id:point.id})">{{point.activity}}</a></td><td>{{point.category}}</td><td>{{point.pointChefMonome}}</td><td>{{point.pointChefBinome}}</td><td>{{point.pointSupportBinome}}</td><td>{{point.pointObjectif}}</td><td style="text-align: right">{{point.averagePrice | currency:\'\u20AC\':2 }}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="point-detail({id:point.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="point.edit({id:point.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="point.delete({id:point.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr><tr ng-repeat="derivedPoint in point.derivedPoints" class="derivedPoint" ng-if="vm.showDerivedPoints"><td>{{derivedPoint.activity}}</td><td></td><td>{{derivedPoint.pointChefMonome}}</td><td>{{derivedPoint.pointChefBinome}}</td><td>{{derivedPoint.pointSupportBinome}}</td><td></td></tr><tr ng-repeat-end></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/intervention/intervention-commentary-dialog.html','<form name="commentaryForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInterventionLabel">Ajout d\'un commentaire</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group hidden" ng-show="vm.intervention.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.intervention.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.commentary" for="field_commentary">Commentary</label><input type="text" class="form-control" name="commentary" id="field_commentary" ng-model="vm.listCommentary" required><div ng-show="editForm.commentary.$invalid"><p class="help-block" ng-show="editForm.commentary.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/intervention/intervention-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.intervention.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xCAtes vous s\xFBr de vouloir supprimer cette intervention?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/intervention/intervention-detail.html','<div><h2>Praxedo {{vm.intervention.praxedoId}}</h2><hr><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-sd-12 col-md-6"><div class="jumbotron"><dl class="dl-horizontal jh-entity-details"><dt><span>Agence</span></dt><dd><span>{{vm.intervention.agenceNom}}</span></dd><dt><span data-translate="tmgApp.intervention.status">Status</span></dt><dd><span>{{vm.intervention.status}}</span></dd><dt><span data-translate="tmgApp.intervention.creationDate">Creation Date</span></dt><dd><span>{{vm.intervention.creationDate | date:\'medium\'}}</span></dd><dt><span data-translate="tmgApp.intervention.dateMailImport">Date Mail Import</span></dt><dd><span>{{vm.intervention.dateMailImport | date:\'yyyy-MM-dd\'}}</span></dd><dt><span data-translate="tmgApp.intervention.filename">Filename</span></dt><dd><span>{{vm.intervention.filename}}</span></dd><dt ng-if="vm.intervention.previousPraxedoId!=null"><span>Intervention pr\xE9c\xE9dente</span></dt><dd ng-if="vm.intervention.previousPraxedoId!=null"><span><a ui-sref="intervention-detail({id:vm.intervention.previousPraxedoId})">{{vm.intervention.previousPraxedoId}}</a></span></dd><dt ng-if="vm.intervention.nextPraxedoId!=null"><span>Intervention suivante</span></dt><dd ng-if="vm.intervention.nextPraxedoId!=null"><span><a ui-sref="intervention-detail({id:vm.intervention.nextPraxedoId})">{{vm.intervention.nextPraxedoId}}</a></span></dd></dl></div><div class="jumbotron"><dl class="dl-horizontal jh-entity-details"><dt style="line-height: 29px"><span data-translate="tmgApp.intervention.date">Date</span></dt><dd><span ng-if="!vm.editDate">{{vm.intervention.date | date:\'mediumDate\'}}</span><div class="input-group" ng-if="vm.editDate"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.intervention.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-success" ng-click="vm.saveNewDate()" ng-if="vm.editDate"><span class="glyphicon glyphicon-save"></span> <span class="hidden-sm-down">Sauvegarder</span></button></span></div><button type="button" class="btn btn-default btn-sm" ng-click="vm.editDate=true;vm.openCalendar(\'date\')" ng-if="!vm.editDate"><span class="glyphicon glyphicon-edit"></span> <span class="hidden-sm-down">Editer la date</span></button></dd><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.date.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></dl></div></div><div class="col-sd-12 col-md-6"><div class="jumbotron"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.intervention.clientNom">Client Nom</span></dt><dd><span>{{vm.intervention.clientNom}}</span></dd><dt><span data-translate="tmgApp.intervention.siteTel">Site Tel</span></dt><dd><span>{{vm.intervention.siteTel}}</span></dd><dt><span data-translate="tmgApp.intervention.actProd">Act/Prod</span></dt><dd><span>{{vm.intervention.actProd}}</span></dd><dt><span data-translate="tmgApp.intervention.siteAdress">Adresse</span></dt><dd><span>{{vm.intervention.siteCP}}</span> <span>{{vm.intervention.siteAdress}}</span></dd><dt><span data-translate="tmgApp.intervention.siteVille">Site Ville</span></dt><dd><span>{{vm.intervention.siteVille}}</span></dd><dt><span>Central PC</span></dt><dd><span>{{vm.intervention.centralPC}}</span></dd><dt><span>Client Tel</span></dt><dd><span>{{vm.intervention.clientTel}}</span></dd></dl></div></div></div><div class="row"><div class="col-md-12"><div class="jumbotron"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.intervention.otFini">Ot Fini</span></dt><dd><span>{{vm.intervention.otFini}}</span></dd><dt><span data-translate="tmgApp.intervention.typeIntervention">Type d\'intervention</span></dt><dd><span>{{vm.intervention.typeIntervention}}</span></dd><dt><span data-translate="tmgApp.intervention.tailleEquipe">Taille Equipe</span></dt><dd><span>{{vm.intervention.tailleEquipe}}</span></dd><dt><span data-translate="tmgApp.intervention.equipes">Equipes</span></dt><dd><div class="tech-percentage"><div class="edit-bloc"><div ng-repeat="technicienIntervention in vm.intervention.techniciens">{{technicienIntervention.technicien}} <span ng-if="!vm.editTechPercentage">- {{technicienIntervention.percentage}} %</span> <input ng-if="vm.editTechPercentage" class="form-control custom-form-inline" type="number" ng-model="technicienIntervention.percentage" min="0" max="100"> <a class="text-danger" ng-if="vm.checkIfCanDelete()" ng-click="vm.removeTech(technicienIntervention.technicien)"><span class="glyphicon glyphicon-trash"></span></a></div></div><div class="btns-tech-percentage"><a class="btn btn-primary" ng-if="!vm.editTechPercentage" ng-click="vm.toggleEditTechPercentage()">Modifier les pourcentages</a> <a class="btn btn-success" ng-if="vm.editTechPercentage" ng-click="vm.saveAllPercentages()">Valider</a> <a class="btn btn-danger" ng-if="vm.editTechPercentage" ng-click="vm.toggleEditTechPercentage()">Annuler</a></div></div><div><small ng-if="vm.techPercentageError" class="text-red">La somme des pourcentages n\'est pas \xE9gale \xE0 100%</small></div></dd><dd><div class="col-xs-8 col-md-6 no-padding"><select class="form-control" name="technicien" ng-model="vm.conges.technicien" id="field_technicien" required><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select></div><div class="col-xs-4 col-md-6"><button type="button" class="btn btn-default btn-sm" ng-click="vm.addTech()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter le technicien</span></button></div></dd><dt><span data-translate="tmgApp.intervention.duree">Duree</span></dt><dd><span>{{vm.intervention.duree}}</span></dd><dt><span data-translate="tmgApp.intervention.article">Article</span></dt><dd><table class="table"><thead><tr><th>Qty</th><th>Code</th><th>Prix moyen technicien</th><th>Prix factur\xE9</th><th>Facturation Status</th><th>Date de cr\xE9ation</th><th>Auteur</th></tr></thead><tbody><tr ng-repeat="activitie in vm.intervention.activities"><td>{{activitie.qty}}</td><td><span class="activity-{{activitie.status}}">{{activitie.code}}</span></td><td><span ng-class="{\'text-green\': activitie.caTechnicien, \'text-red\': !activitie.caTechnicien}"><span class="glyphicon" ng-class="{\r\n                                                      \'glyphicon-ok\': activitie.caTechnicien,\r\n                                                      \'glyphicon-remove\': !activitie.caTechnicien,\r\n                                                      \'non-clickable\': !vm.isInMonthRange()}" ng-click="vm.isInMonthRange() && vm.changeCaTechnicienForActivity(activitie)"></span> </span><span style="margin-left: 1rem" ng-if="activitie.point && activitie.point.averagePrice">{{vm.getPrixMoyenTechnicien(activitie) | number:2}}\u20AC </span><span style="margin-left: 1rem" ng-if="!activitie.point || !activitie.point.averagePrice">0 \u20AC</span></td><td><span ng-class="{\'text-green\': activitie.facture, \'text-red\': !activitie.facture}"><span class="glyphicon" ng-class="{\r\n                                                      \'glyphicon-ok\': activitie.facture,\r\n                                                      \'glyphicon-remove\': !activitie.facture,\r\n                                                      \'non-clickable\': !vm.isInMonthRange()}" ng-click="vm.isInMonthRange() && vm.changeFactureForActivity(activitie)"></span> </span><span style="margin-left: 1rem" ng-if="activitie.price">{{activitie.price}}\u20AC </span><span style="margin-left: 1rem" ng-if="!activitie.price">--\u20AC</span></td><td>{{activitie.status}}</td><td>{{activitie.creationDate | date:\'yyyy/MM/dd\' }}</td><td>{{activitie.createdBy}}</td><td><a class="text-danger" ng-click="vm.removeBonus(activitie)" ng-if="vm.isInMonthRange()"><span class="glyphicon glyphicon-trash"></span></a><div style="color: #C2AEAC" ng-if="!vm.isInMonthRange()"><span class="glyphicon glyphicon-trash"></span></div></td><td ng-if="vm.isAdmin"><button type="button" class="btn btn-default btn-sm" ng-disabled="!activitie.point || !activitie.point.averagePrice" ui-sref="intervention-detail.regul({id: vm.intervention.id, activityCode: activitie.code})"><span class="hidden-sm-down">R\xE9guler l\'activit\xE9</span></button></td></tr></tbody></table><div class="row"><div class="col-xs-1 col-md-1"><div class="form-group"><input class="form-control" style="width:100px" type="number" ng-model="vm.bonus.qty" required ng-disabled="!vm.isInMonthRange()"></div></div><div class="col-xs-7 col-md-5 no-padding"><div class="form-group"><select class="form-control" name="newPoint" ng-model="vm.bonus.point" id="field_newPoint" required ng-disabled="!vm.isInMonthRange()"><option ng-repeat="point in vm.pointsTMG">{{ point }}</option></select></div></div><div class="col-xs-4 col-md-5"><button type="button" class="btn btn-default btn-sm" ng-disabled="!vm.bonus.point || !vm.bonus.qty || !vm.isInMonthRange()" ng-click="vm.addBonus()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter l\'article</span></button></div></div><div class="row" ng-if="!vm.isInMonthRange()"><span class="text-red" style="padding-left: 2rem">Mois pass\xE9, merci d\'utiliser la r\xE9gulation</span></div></dd><dt><span data-translate="tmgApp.intervention.bonusMalus">Bonus Malus</span></dt><dd><span>{{vm.intervention.bonusMalus}}</span></dd><dt><span data-translate="tmgApp.intervention.libelle">Libelle</span></dt><dd><span>{{vm.intervention.libelle}}</span></dd><dt><span data-translate="tmgApp.intervention.crint">Crint</span></dt><dd><span>{{vm.intervention.crint}}</span></dd><dt><span>Charges</span></dt><dd><table class="table"><thead><tr><th>Type</th><th>Date</th><th>Prix</th><th>Description</th><th></th></tr></thead><tbody><tr ng-repeat="charge in vm.chargesTechnicien"><td><span>{{charge.type}}</span></td><td><span>{{charge.date}}</span></td><td><span style="text-align: right" ng-class="{\'text-green\': charge.charge < 0, \'text-red\': charge.charge > 0}">{{charge.charge}} \u20AC</span></td><td><a ui-sref="charge-technicien-detail({id:charge.id})">{{charge.description}}</a></td><td ng-if="vm.isAdmin"><div class="text-danger" ng-if="vm.isDateFuture(charge.date)"><span class="glyphicon glyphicon-trash clickable" ng-click="vm.removeCharge(charge)"></span></div><div style="color: #C2AEAC" ng-if="!vm.isDateFuture(charge.date)"><span class="glyphicon glyphicon-trash"></span></div></td><td ng-if="!vm.isAdmin"></td></tr></tbody></table><div class="row"><div class="col-xs-2 col-md-2"><div class="form-group"><label for="field_charge_price">Prix</label><input class="form-control" type="number" ng-model="vm.newCharge.charge" id="field_charge_price" required></div></div><div class="col-xs-2 col-md-2"><div class="form-group"><label class="control-label" for="field_charge_type" required>Type</label><div><select id="field_charge_type" class="form-control" name="type" ng-model="vm.newCharge.type"><option value="SALAIRE">SALAIRE</option><option value="OUTIL">OUTIL</option><option value="ACTIVITE">ACTIVITE</option><option value="CHARGE">CHARGE</option><option value="ASTREINTE">ASTREINTE</option><option value="REGUL">REGUL</option></select></div></div></div><div class="col-xs-4 col-md-5 no-padding"><div class="form-group"><label for="field_charge_description">Description</label><textarea id="field_charge_description" class="form-control" ng-model="vm.newCharge.description"></textarea></div></div><div class="col-xs-2 col-md-2" style="margin-top: 22px"><button type="button" class="btn btn-default btn-sm" ng-click="vm.addCharge()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter la charge</span></button></div></div></dd><dt><span>Bons de commandes</span></dt><dd><ul><li ng-repeat="bonDeCommande in vm.intervention.bonDeCommandes track by $index"><div>{{bonDeCommande}} <a class="text-danger" ng-if="vm.isAdmin" ng-click="vm.removeBonDeCommande(bonDeCommande)"><span class="glyphicon glyphicon-trash"></span></a></div></li></ul><div class="col-xs-4 col-md-5 no-padding"><div class="form-group"><label for="field_new_bon_de_commande">Bon de commande</label><input class="form-control" type="text" ng-model="vm.newBonDeCommande" id="field_new_bon_de_commande" required></div></div><div class="col-xs-6 col-md-5 no-padding"><div class="form-group"><label for="field_new_bon_de_commande_comment">Commentaire (optionnel)</label><input class="form-control" type="text" ng-model="vm.newBonDeCommandeComment" id="field_new_bon_de_commande_comment"></div></div><div class="col-xs-2 col-md-2" style="margin-top: 22px"><button type="button" class="btn btn-default btn-sm" ng-disabled="vm.newBonDeCommande == null" ng-click="vm.addBonDeCommande()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter un bon de commande</span></button></div></dd><dt class="dl-horizontal jh-entity-details"><span data-translate="tmgApp.intervention.commentary">Commentaire</span></dt><dd><ul><li ng-repeat="commentary in vm.intervention.listCommentary track by $index">{{commentary}} <a class="text-danger" ng-if="vm.isAdmin" ng-click="vm.removeCommentary(commentary)"><span class="glyphicon glyphicon-trash"></span></a></li></ul></dd></dl></div></div></div><div class="row"><div class="col-md-12"><div class="jumbotron"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.intervention.description">Description</span></dt><dd><span class="wrap">{{vm.intervention.description}}</span></dd></dl></div></div></div><div class="row"><div class="col-md-12"><div class="jumbotron"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.intervention.constructelFilename">Constructel Filename</span></dt><dd><span>{{vm.intervention.constructelFilename}}</span></dd><dt><span>Status</span></dt><dd><span>{{vm.intervention.comparaisonStatus}}</span></dd><dt><span>Prix pay\xE9</span></dt><dd><span>{{vm.intervention.paidPrice}} \u20AC</span></dd><dt><span data-translate="tmgApp.intervention.prix">Prix</span></dt><dd><span>{{vm.intervention.price}} \u20AC</span></dd></dl></div></div></div><div class="row"><div class="col-md-12"><div class="jumbotron"><dl class="dl-horizontal jh-entity-details"><dl ng-repeat="(key,value) in vm.intervention.params" ng-if="value!=null"><dt>{{key}}</dt><dd><span>{{value}}</span></dd></dl></dl></div></div></div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ng-click="vm.manualClose(vm.intervention.id)" class="btn btn-default btn-sm" ng-if="vm.intervention.comparaisonStatus !=\'CLOSE_MANUEL\' &&\r\n                    vm.intervention.comparaisonStatus !=\'CLOSE_AUTO\' &&\r\n                    vm.intervention.comparaisonStatus !=\'CLOSE_NOT_FACTURABLE\'\r\n             "><span class="glyphicon glyphicon-eye-close"></span> <span class="hidden-sm-down">Ignore</span></button> <button type="button" ng-click="vm.facturationFight(vm.intervention.id)" class="btn btn-default btn-sm" ng-if="vm.intervention.comparaisonStatus !=\'CLOSE_MANUEL\' &&\r\n                    vm.intervention.comparaisonStatus !=\'CLOSE_AUTO\' &&\r\n                    vm.intervention.comparaisonStatus !=\'CLOSE_NOT_FACTURABLE\' &&\r\n                    vm.intervention.comparaisonStatus !=\'FACTURATION_FIGHT\'\r\n             "><span class="glyphicon glyphicon-flash"></span> <span class="hidden-sm-down">Contester</span></button> <button type="button" ui-sref="intervention-detail.commentary({id:vm.intervention.id})" class="btn btn-primary" ng-if="vm.isAdmin"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter Commentaire</span></button> <button type="button" ng-if="vm.intervention.creationManuelle" ui-sref="intervention-detail.edit({id:vm.intervention.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Editer</span></button> <button ng-if="vm.intervention.creationManuelle" type="button" ui-sref="intervention.delete({id:vm.intervention.id})" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down">Supprimer l\'intervention</span></button></div>');
$templateCache.put('app/entities/intervention/intervention-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="modal-dialog"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInterventionLabel" data-translate="tmgApp.intervention.home.createOrEditLabel">Create or edit a Intervention</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.intervention.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.intervention.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.praxedoId" for="field_praxedoId">Praxedo Id</label><input type="text" class="form-control praxedo-id-input" name="praxedoId" id="field_praxedoId" ng-model="vm.intervention.praxedoId" required><div ng-show="editForm.praxedoId.$invalid"><p class="help-block" ng-show="editForm.praxedoId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="intervention-form-part1"><div class="form-block block-1"><div class="group group1"><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.agenceNom" for="field_agenceNom">Agency name</label><input type="text" class="form-control" name="agenceNom" id="field_agenceNom" ng-model="vm.intervention.agenceNom"></div><div class="form-group"><label for="field_status" data-translate="tmgApp.intervention.status" class="control-label">Status</label><select name="status" ng-model="vm.intervention.status" id="field_status" class="form-control"><option value="TERMINEE_OK">TERMINEE_OK</option><option value="TERMINEE_NOK">TERMINEE_NOK</option><option value="TRAVAUX_CLIENT">TRAVAUX_CLIENT</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="group group2"><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" datetime-picker="{{dateformat}}" ng-model="vm.intervention.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.date.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div></div></div><div class="form-block block-2"><div class="group group3"><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.clientNom" for="field_clientNom">Client Nom</label><input type="text" class="form-control" name="clientNom" id="field_clientNom" ng-model="vm.intervention.clientNom" required><div ng-show="editForm.clientNom.$invalid"><p class="help-block" ng-show="editForm.clientNom.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.siteTel" for="field_siteTel">Site Tel</label><input type="text" class="form-control" name="siteTel" id="field_siteTel" ng-model="vm.intervention.siteTel"></div><div class="form-group"><label for="field_actProd" data-translate="tmgApp.intervention.actProd" class="control-label">Act/Prod</label><input type="text" class="form-control" name="actProd" id="field_actProd" ng-model="vm.intervention.actProd"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.siteAdress" for="field_siteAdress">Site Adress</label><input type="text" class="form-control" name="siteAdress" id="field_siteAdress" ng-model="vm.intervention.siteAdress"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.siteVille" for="field_siteVille">Site Ville</label><input type="text" class="form-control" name="siteVille" id="field_siteVille" ng-model="vm.intervention.siteVille"></div><div class="form-group"><label for="field_centralPC">Central PC</label><input type="text" class="form-control" name="centralPC" id="field_centralPC" ng-model="vm.intervention.centralPC"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.clientTel" for="field_clientTel">Client Tel</label><input type="text" class="form-control" name="clientTel" id="field_clientTel" ng-model="vm.intervention.clientTel" required><div ng-show="editForm.clientTel.$invalid"><p class="help-block" ng-show="editForm.clientTel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.siteCP" for="field_siteCP">Site CP</label><input type="text" class="form-control" name="siteCP" id="field_siteCP" ng-model="vm.intervention.siteCP"></div></div></div></div><div class="form-group form-technicien"><div class="technicien-label"><label class="control-label" data-translate="tmgApp.intervention.technicien" for="field_technicien">Technicien</label></div><div class="techniciens"><div ng-repeat="technicien in vm.intervention.equipes"><span>{{technicien}}</span> <a class="text-danger" ng-click="vm.removeTech(technicien)"><span class="glyphicon glyphicon-trash"></span></a></div><div class="new-technicien"><select class="form-control" name="technicien" ng-model="vm.newTech" id="field_technicien"><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select><div class="form-group"><button type="button" class="btn btn-default btn-sm" ng-click="vm.addTech()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter</span></button></div></div><div class="form-group"><div ng-show="vm.intervention.tailleEquipe == 0"><p class="help-block">Veuillez selectionner au moins un technicien.</p></div></div></div></div><div class="form-group form-activity" ng-if="!vm.intervention.id"><div class="activity-label"><label for="field_activity" class="control-label" data-translate="tmgApp.intervention.articles">Articles</label></div><div class="activities"><div ng-repeat="activity in vm.intervention.activities"><span>{{activity.code}} x{{activity.qty}}</span> <a class="text-danger" ng-click="vm.removeBonus(activity)"><span class="glyphicon glyphicon-trash"></span></a></div><div class="new-activity"><div class="select-activity"><label for="field_activity" class="control-label" data-translate="tmgApp.intervention.article">Article</label><select class="form-control" name="activity" id="field_activity" ng-model="vm.bonus.point"><option ng-repeat="point in vm.pointsTMG">{{ point }}</option></select></div><div class="select-qty"><div><label for="field_bonusQty">Qty</label><input class="form-control" type="number" name="bonusQty" id="field_bonusQty" ng-model="vm.bonus.qty" required></div></div><div class="add-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.addBonus()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm-down">Ajouter</span></button></div></div><div class="form-group"><div ng-show="!vm.intervention.activities || vm.intervention.activities.length == 0"><p class="help-block">Veuillez selectionner au moins un article.</p></div></div></div></div><div class="group6"><div><label class="control-label" for="field_otFini">otFini</label><input type="checkbox" name="otFini" id="field_otFini" ng-model="vm.intervention.otFini"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.typeIntervention" for="field_typeIntervention">Type Inter</label><input type="text" class="form-control" name="typeIntervention" id="field_typeIntervention" ng-model="vm.intervention.typeIntervention"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.intervention.duree" for="field_duree">Duree</label><input type="number" class="form-control" name="duree" id="field_duree" ng-model="vm.intervention.duree"></div><div class="form-group"><label class="control-label" for="field_price">Prix</label><input type="number" class="form-control" name="price" id="field_price" ng-model="vm.intervention.price"></div></div><div class="form-group form-comment" ng-if="!vm.intervention.id"><label class="control-label" for="field_commentaire">Commentaire</label><textarea class="form-control" name="field_commentaire" id="field_commentaire" ng-model="vm.intervention.listCommentary[0]"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.customFormError" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/intervention/intervention-regul-dialog.html','<form name="regulForm" role="form" novalidate ng-submit="vm.regulCharge()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInterventionLabel">Regul {{vm.activityCode}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="qty">Quantit\xE9</label><input type="number" class="form-control" name="qty" id="qty" ng-model="vm.qty" max="{{vm.getActivity().qty}}" required><div ng-show="regulForm.qty.$invalid"><p class="help-block" ng-show="regulForm.qty.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div style="margin-bottom: 1rem"><span style="font-weight: bold">Ancienne activit\xE9 : </span><span>{{vm.activityCode}}</span></div><div class="form-group"><label for="field_newPoint" class="control-label">Nouvelle activit\xE9</label><select class="form-control" name="newPoint" ng-model="vm.newPoint" id="field_newPoint"><option ng-repeat="point in vm.pointsTMG">{{ point }}</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>R\xE9guler l\'activit\xE9</span></button></div></form>');
$templateCache.put('app/entities/intervention/interventions.html','<div><h2 data-translate="tmgApp.intervention.home.title">Interventions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterSearch">Rechercher</label><input type="text" class="form-control" id="filterSearch" ng-model="vm.filterSearch" ng-enter="vm.search()"></div></div><div class="col-xs-12 col-md-2" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterStatus">Status</label><select class="form-control" name="filterStatus" ng-model="vm.filterStatus" id="filterStatus" ng-change="vm.search()" multiple="multiple"><option value=""></option><option value="TERMINEE_OK">TERMINEE_OK</option><option value="TERMINEE_NOK">TERMINEE_NOK</option><option value="TRAVAUX_CLIENT">TRAVAUX_CLIENT</option></select></div><div class="form-group"><input type="checkbox" name="displayReo" ng-model="vm.displayReo"><label for="displayReo">Afficher REO</label></div></div><div class="col-xs-12 col-md-2" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterComparaisonStatus">Comparaison</label><select class="form-control" name="filterComparaisonStatus" ng-model="vm.filterComparaisonStatus" id="filterComparaisonStatus" ng-change="vm.search()" multiple="multiple" size="10"><option value=""></option><option value="FACTURATION_FOUND">Facture trouv\xE9e</option><option value="FACTURATION_FIGHT">Facture contest\xE9e</option><option value="FACTURATION_MISSING">Facture manquante</option><option value="FACTURATION_MISMATCH">Facture incoh\xE9rente</option><option value="PRODUCTION_MISSING">Non trouv\xE9 en production</option><option value="CLOSE_AUTO">Ferm\xE9e automatiquement</option><option value="CLOSE_MANUEL">Ferm\xE9e manuellement</option><option value="CLOSE_NOT_FACTURABLE">Non facturable</option><option value="PRAXEDO_MISSING">Non trouv\xE9 dans praxedo</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterDateFrom">Date From</label><div class="input-group"><input type="text" class="form-control" id="filterDateFrom" ng-model="vm.filterDateFrom" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><label for="filterDateTo">Date To</label><div class="input-group"><input type="text" class="form-control" id="filterDateTo" ng-model="vm.filterDateTo" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateTo\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-md-2" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select><label for="filterTechnicienEquipe">Equipier</label><select class="form-control" name="filterTechnicienEquipe" ng-model="vm.filterTechnicienEquipe" id="filterTechnicienEquipe"><option></option><option value="null">Null</option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select><label for="filterTechnicienRole">Role</label><select class="form-control" name="filterTechnicienRole" ng-model="vm.filterTechnicienRole" id="filterTechnicienRole" ng-change="vm.search()"><option></option><option>MONOME</option><option>CHEF_BINOME</option><option>SUPPORT_BINOME</option></select><label for="filterTailleEquipe">Taille</label><select class="form-control" name="filterTailleEquipe" ng-model="vm.filterTailleEquipe" id="filterTailleEquipe" ng-change="vm.search()"><option></option><option value="1">Monome</option><option value="2">Binome</option></select></div></div><div class="col-xs-12 col-md-2" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterConstructelFilename">Fichier de commande</label><input type="text" class="form-control" id="filterConstructelFilename" ng-model="vm.filterConstructelFilename" ng-enter="vm.search()"><label for="filterdateMailImport">Date Mail Import</label><input type="text" class="form-control" id="filterDateMailImport" ng-model="vm.filterDateMailImport" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" ng-enter="vm.search()"><label for="filterFilename">Filename</label><input type="text" class="form-control" id="filterFilename" ng-model="vm.filterFilename" ng-enter="vm.search()"><label for="filterBonDeCommande">Bon de commande</label><input type="text" class="form-control" id="filterBonDeCommande" ng-model="vm.filterBonDeCommande" ng-enter="vm.search()"><div class="checkbox" style="margin-top: 5px"><label><input type="checkbox" id="filterBonDeCommandeExclude" ng-model="vm.excludeBonDeCommande" ng-change="vm.search()" ng-disabled="!vm.filterBonDeCommande"> Exclure ce bon de commande</label></div></div></div></div><div class="row"><div class="col-xs-1"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div><div class="col-xs-1" has-authority="ROLE_ADMIN"><button class="btn btn-warning" ng-click="vm.reset()"><span class="glyphicon glyphicon-erase"></span> <span>Reset</span></button></div><div class="col-xs-1" has-authority="ROLE_ADMIN"><button class="btn btn-warning" ng-click="vm.resetBonusMalus()"><span class="glyphicon glyphicon-bitcoin"></span> <span>Reset Bonus</span></button></div></div><div class="row"><div class="col-xs-4" style="margin-top: 0.5rem"><button class="btn btn-primary" ui-sref="intervention.new"><span class="glyphicon glyphicon-plus"></span> Cr\xE9er une nouvelle intervention</button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="praxedoId"><span data-translate="tmgApp.intervention.praxedoId">Praxedo Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="clientNom"><span data-translate="tmgApp.intervention.clientNom">Client Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="siteTel"><span data-translate="tmgApp.intervention.siteTel">Site Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="siteVille"><span data-translate="tmgApp.intervention.siteVille">Site Ville</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span data-translate="tmgApp.intervention.technicien">Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="tmgApp.intervention.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="actProd"><span data-translate="tmgApp.intervention.actProd">actProd</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="typeIntervention"><span data-translate="tmgApp.intervention.typeIntervention">typeInterventions</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="activities" width="275px"><span data-translate="tmgApp.intervention.article">Article</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bonDeCommandes" width="275px"><span>Bons de commandes</span> <span class="glyphicon glyphicon-sort"></span></th><th has-authority="ROLE_ADMIN" jh-sort-by="comparaisonStatus"><span data-translate="tmgApp.intervention.comparaisonStatus">Comparaison</span> <span class="glyphicon glyphicon-sort"></span></th><th has-authority="ROLE_ADMIN" jh-sort-by="price"><span data-translate="tmgApp.intervention.prix">Price</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="intervention in vm.interventions track by intervention.id" ng-class="vm.getCssClass(intervention)" ng-show="!intervention.reo || vm.displayReo"><td><a ui-sref="intervention-detail({id:intervention.id})" has-authority="ROLE_ADMIN">{{intervention.praxedoId}}</a><span has-authority="ROLE_TECHNICIEN">{{intervention.praxedoId}}</span></td><td>{{intervention.clientNom}}</td><td><a ng-click="vm.selectPhoneNumber(intervention.siteTel)">{{ intervention.siteTel.length > 12 ? (intervention.siteTel | limitTo: 8) + \'(...)\' : intervention.siteTel }}</a></td><td>{{intervention.siteVille}}</td><td><div ng-repeat="technicien in intervention.equipes">{{technicien}}</div></td><td>{{intervention.date | date:\'yyyy-MM-dd\'}}</td><td>{{intervention.actProd}}</td><td>{{intervention.typeIntervention}}</td><td><div ng-repeat="activitie in intervention.activities" ng-show="!activitie.hide"><span class="activity-{{activitie.status}}">{{activitie.qty}} {{activitie.code}} <span ng-if="activitie.status!=\'OK\'">{{activitie.status}}</span></span> <span style="font-size:10px; display:inline-block; min-width:25px" class="label label-info" ng-if="activitie.point!=null && intervention.tailleEquipe<=1">{{activitie.point.pointChefMonome * activitie.qty}}</span> <span style="font-size:10px; display:inline-block; min-width:25px" class="label label-info" ng-if="activitie.point!=null && intervention.tailleEquipe>1">{{activitie.point.pointChefBinome * activitie.qty}} / {{activitie.point.pointSupportBinome * activitie.qty}}</span> <span style="font-size:10px; display:inline-block; min-width:25px" class="label label-success" ng-if="activitie.point!=null && activitie.point.pointObjectif>0">{{activitie.point.pointObjectif * activitie.qty}}</span></div></td><td><div ng-repeat="bonDeCommande in intervention.bonDeCommandes track by $index"><span>{{bonDeCommande}}</span><div class="text-muted" ng-if="vm.getBonDeCommandeComment(intervention, bonDeCommande)">{{ vm.getBonDeCommandeComment(intervention, bonDeCommande) }}</div></div></td><td has-authority="ROLE_ADMIN">{{intervention.comparaisonStatus}}</td><td has-authority="ROLE_ADMIN">{{intervention.price}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button has-authority="ROLE_ADMIN" type="submit" ui-sref="intervention-detail({id:intervention.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button has-authority="ROLE_ADMIN" type="button" ng-click="vm.manualClose(intervention.id)" class="btn btn-default btn-sm" ng-if="intervention.comparaisonStatus !=\'CLOSE_MANUEL\' &&\r\n                                           intervention.comparaisonStatus !=\'CLOSE_AUTO\' &&\r\n                                           intervention.comparaisonStatus !=\'CLOSE_NOT_FACTURABLE\'\r\n                                    "><span class="glyphicon glyphicon-eye-close"></span> <span class="hidden-sm-down">Ignore</span></button> <button has-authority="ROLE_ADMIN" type="button" ng-click="vm.facturationFight(intervention.id)" class="btn btn-default btn-sm" ng-if="intervention.comparaisonStatus != \'CLOSE_MANUEL\' &&\r\n                                           intervention.comparaisonStatus != \'CLOSE_AUTO\' &&\r\n                                           intervention.comparaisonStatus != \'CLOSE_NOT_FACTURABLE\' &&\r\n                                           intervention.comparaisonStatus != \'FACTURATION_FIGHT\'\r\n                                    "><span class="glyphicon glyphicon-flash"></span> <span class="hidden-sm-down">Contester</span></button><!--\r\n                            <button type="submit"\r\n                                    ui-sref="intervention.edit({id:intervention.id})"\r\n                                    class="btn btn-primary btn-sm">\r\n                                <span class="glyphicon glyphicon-pencil"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.edit"></span>\r\n                            </button>\r\n                            <button type="submit"\r\n                                    ui-sref="intervention.delete({id:intervention.id})"\r\n                                    class="btn btn-danger btn-sm">\r\n                                <span class="glyphicon glyphicon-remove-circle"></span>\r\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\r\n                            </button>\r\n                            --></div></td></tr></tbody><tfoot has-authority="ROLE_ADMIN"><tr><td colspan="8"></td><td><button type="button" ng-click="vm.resetBonusMalusIntervention()" class="btn btn-default btn-sm"><span class="glyphicon glyphicon-bitcoin"></span> <span class="hidden-sm-down">Bonus Malus</span></button></td><td></td><td><b>{{ vm.arround(vm.getTotalPrice()) }}</b></td><td></td></tr></tfoot></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div><div class="activity-PRAXEDO">Activit\xE9 non factur\xE9</div><div class="activity-CONSTRUCTEL">Activit\xE9 non pr\xE9sente dans praxedo ou avec une mauvaise quantit\xE9</div><div><span style="font-size:10px; display:inline-block; min-width:25px" class="label label-info">1</span> Stat technicien Monome</div><div><span style="font-size:10px; display:inline-block; min-width:25px" class="label label-info">1 / 1</span> Stat technicien Chef Binome / Support Binome</div><div><span style="font-size:10px; display:inline-block; min-width:25px" class="label label-success">1</span> Point Objectif</div></div></div>');
$templateCache.put('app/entities/paie/paie-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.paie.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.paie.delete.question" translate-values="{id: \'{{vm.paie.id}}\'}">Are you sure you want to delete this Paie?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/paie/paie-detail.html','<div><h2>Fiche de Salaire {{vm.paie.month | date:\'MMM yyyy\'}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Technicien</span></dt><dd><span>{{vm.paie.technicien}}</span></dd></dl><table class="jh-table table table-striped"><caption>Prime de {{vm.paie.monthPrime | date:\'MMM yyyy\'}}</caption><thead><tr><th><span>Code</span></th><th><span>Mois</span></th><th><span>Point</span></th><th><span>Monome</span></th><th><span>Chef Equipe</span></th><th><span>Support Equipe</span></th><th><span>Point</span></th></tr></thead><tbody><tr ng-repeat="paieActivity in vm.paie.activities"><td>{{paieActivity.activity}}</td><td>{{paieActivity.yearMonth}}</td><td><span style="font-size:10px">{{paieActivity.pointChefMonome}} / {{paieActivity.pointChefBinome}} / {{paieActivity.pointSupportBinome}}</span></td><td>{{paieActivity.qtyMonome}}</td><td>{{paieActivity.qtyChefEquipe}}</td><td>{{paieActivity.qtySupportEquipe}}</td><td>{{paieActivity.totalPoints}}</td></tr></tbody><tfoot ng-if="vm.statTechniciens.length>0"><tr><td colspan="5"></td><td><b>{{ vm.getTotalPoints() }}</b></td></tr></tfoot></table><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.paie.totalPoint">Total Point</span></dt><dd><span>{{vm.paie.totalPoint}}</span></dd><dt>Prime Coeff</dt><dd><span>{{vm.paie.primeCoeff}}</span></dd><dt><span data-translate="tmgApp.paie.primeRendement">Prime Rendement</span></dt><dd><span>{{vm.paie.primeRendement}}</span></dd><dt><span data-translate="tmgApp.paie.primeExceptionnelle">Prime Exceptionnelle</span></dt><dd><span>{{vm.paie.primeExceptionnelle}}</span></dd></dl><table class="jh-table table table-striped" ng-if="vm.astreintes.length>0"><caption>Astreinte</caption><thead><tr><th><span data-translate="tmgApp.astreinte.date">Date</span></th><th><span data-translate="tmgApp.astreinte.hours">Hours</span></th></tr></thead><tbody><tr ng-repeat="astreinte in vm.astreintes"><td>{{astreinte.date | date:\'mediumDate\'}}</td><td>{{astreinte.hours}}</td></tr></tbody></table><table class="jh-table table table-striped" ng-if="vm.conges.length>0"><caption>Conges</caption><thead><tr><th><span data-translate="tmgApp.conges.date">Date</span></th><th><span data-translate="tmgApp.conges.dateEnd">Date End</span></th><th><span data-translate="tmgApp.conges.type">Type</span></th></tr></thead><tbody><tr ng-repeat="conges in vm.conges track by conges.id"><td>{{conges.date | date:\'mediumDate\'}}</td><td>{{conges.dateEnd | date:\'mediumDate\'}}</td><td>{{conges.type}}</td></tr></tbody></table><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info hidden-print"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/paie/paie-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaieLabel" data-translate="tmgApp.paie.home.createOrEditLabel">Create or edit a Paie</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.paie.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.paie.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.paie.month" for="field_month">Month</label><div class="input-group"><input id="field_month" type="text" class="form-control" name="month" uib-datepicker-popup="{{dateformat}}" ng-model="vm.paie.month" is-open="vm.datePickerOpenStatus.month" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'month\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.month.$invalid"><p class="help-block" ng-show="editForm.month.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Produce</span></button></div></form>');
$templateCache.put('app/entities/paie/paies.html','<div><h2 data-translate="tmgApp.paie.home.title">Paies</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien" ng-change="vm.search()"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien.displayname }}</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterDateFrom">Date Paie</label><div class="input-group"><input type="text" class="form-control" id="filterDatePaie" ng-model="vm.filterDatePaie" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickers.filterDatePaie"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDatePaie\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterDateTo">Date Prime</label><div class="input-group"><input type="text" class="form-control" id="filterDatePrime" ng-model="vm.filterDatePrime" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickers.filterDatePrime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDatePrime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-xs-1"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="paie.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.paie.home.createLabel">G\xE9n\xE9rer les Paies</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="month"><span data-translate="tmgApp.paie.month">Month</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span data-translate="tmgApp.paie.technicien">Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="monthPrime"><span data-translate="tmgApp.paie.monthPrime">Month Prime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="totalPoint"><span data-translate="tmgApp.paie.totalPoint">Total Point</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="primeRendement"><span data-translate="tmgApp.paie.primeRendement">Prime Rendement</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="primeExceptionnelle"><span data-translate="tmgApp.paie.primeExceptionnelle">Prime Exceptionnelle</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="paie in vm.paies track by paie.id"><td><a ui-sref="paie-detail({id:paie.id})">{{paie.technicien}}-{{paie.month | date:\'yyyy-MM\'}}</a></td><td>{{paie.month | date:\'MMM yyyy\'}}</td><td>{{paie.technicien}}</td><td>{{paie.monthPrime | date:\'MMM yyyy\'}}</td><td>{{paie.totalPoint}}</td><td>{{paie.primeRendement}}</td><td>{{paie.primeExceptionnelle}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="paie-detail({id:paie.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="paie.delete({id:paie.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/import-constructel/import-constructel-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.importConstructel.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.importConstructel.delete.question" translate-values="{id: \'{{vm.importConstructel.id}}\'}">Are you sure you want to delete this Import Constructel?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/import-constructel/import-constructel-detail.html','<div><h2><span data-translate="tmgApp.importConstructel.detail.title">Import Constructel</span> {{vm.importConstructel.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.importConstructel.name">Name</span></dt><dd><span>{{vm.importConstructel.name}}</span></dd><dt><span>Type</span></dt><dd><span>{{vm.importConstructel.type}}</span></dd><dt><span data-translate="tmgApp.importConstructel.dateCreation">Date Creation</span></dt><dd><span>{{vm.importConstructel.dateCreation | date:\'medium\'}}</span></dd><dt><span data-translate="tmgApp.importConstructel.nbInterventions">Nb Interventions</span></dt><dd><span>{{vm.importConstructel.nbInterventionsError}} en erreur / {{vm.importConstructel.nbInterventions}} total</span></dd><dt><span>Status</span></dt><dd><span>{{vm.importConstructel.status}}</span></dd><dt><span data-translate="tmgApp.importConstructel.proceed">Proceed</span></dt><dd><span>{{vm.importConstructel.proceed}}</span></dd><dt>Fichier</dt><dd><a ng-click="vm.download()">Ouvrir</a> {{vm.importConstructel.name}}</dd><dt>Interventions non trouv\xE9es</dt><dd ng-if="vm.importConstructel.interventionsMissing.length == 0"><span>Aucune</span></dd><dd ng-if="vm.importConstructel.interventionsMissing.length > 0"><div><table class="table table-sm table-bordered" style="width: 100%"><thead><tr><th>Praxedo id</th><th>Site tel</th><th>Date</th><th>Prix</th><th>Status</th></tr></thead><tbody><tr ng-repeat="intervention in vm.importConstructel.interventionsMissing"><td>{{intervention.praxedoId}}</td><td>{{intervention.siteTel}}</td><td>{{intervention.date}}</td><td>{{intervention.paidPrice}} \u20AC</td><td>{{intervention.comparaisonStatus}}</td></tr></tbody></table></div></dd><dt>Interventions trouv\xE9es</dt><dd><div style="width: 30%" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterComparaisonStatus">Status</label><select class="form-control" name="filterComparaisonStatus" ng-model="vm.filterComparaisonStatus" id="filterComparaisonStatus" ng-change="vm.transition()" multiple="multiple" size="10"><option value=""></option><option value="FACTURATION_FOUND">Facture trouv\xE9e</option><option value="FACTURATION_MISSING">Facture manquante</option><option value="FACTURATION_MISMATCH">Facture incoh\xE9rente</option><option value="FACTURATION_FIGHT">Facture contest\xE9e</option><option value="PRODUCTION_MISSING">Non trouv\xE9 en production</option><option value="CLOSE_AUTO">Ferm\xE9e automatiquement</option><option value="CLOSE_MANUEL">Ferm\xE9e manuellement</option><option value="CLOSE_NOT_FACTURABLE">Non facturable</option><option value="PRAXEDO_MISSING">Non trouv\xE9 dans praxedo</option></select></div></div><div ng-if="vm.interventionsFound.length == 0"><span>Aucune</span></div><div ng-if="vm.interventionsFound.length > 0"><div><table class="jh-table table table-striped" style="width: 100%"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="praxedoId"><span>Praxedo Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="clientNom"><span>Client Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="siteTel"><span>Site Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="siteVille"><span>Site Ville</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span>Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span>Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="actProd"><span>actProd</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="typeIntervention"><span>typeInterventions</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="activities" width="275px"><span>Article</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="bonDeCommandes" width="275px"><span>Bons de commandes</span> <span class="glyphicon glyphicon-sort"></span></th><th has-authority="ROLE_ADMIN" jh-sort-by="comparaisonStatus"><span>Comparaison</span> <span class="glyphicon glyphicon-sort"></span></th><th has-authority="ROLE_ADMIN" jh-sort-by="price"><span>Price</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="intervention in vm.interventionsFound track by intervention.id" ng-class="vm.getCssClass(intervention)" ng-show="!intervention.reo || vm.displayReo"><td><a ui-sref="intervention-detail({id:intervention.id})" has-authority="ROLE_ADMIN">{{intervention.praxedoId}}</a><span has-authority="ROLE_TECHNICIEN">{{intervention.praxedoId}}</span></td><td>{{intervention.clientNom}}</td><td><a ng-click="vm.selectPhoneNumber(intervention.siteTel)">{{ intervention.siteTel.length > 12 ? (intervention.siteTel | limitTo: 8) + \'(...)\' : intervention.siteTel }}</a></td><td>{{intervention.siteVille}}</td><td><div ng-repeat="technicien in intervention.equipes">{{technicien}}</div></td><td>{{intervention.date | date:\'yyyy-MM-dd\'}}</td><td>{{intervention.actProd}}</td><td>{{intervention.typeIntervention}}</td><td><div ng-repeat="activitie in intervention.activities" ng-show="!activitie.hide"><span class="activity-{{activitie.status}}">{{activitie.qty}} {{activitie.code}} <span ng-if="activitie.status!=\'OK\'">{{activitie.status}}</span></span> <span style="font-size:10px; display:inline-block; min-width:25px" class="label label-info" ng-if="activitie.point!=null && intervention.tailleEquipe<=1">{{activitie.point.pointChefMonome * activitie.qty}}</span> <span style="font-size:10px; display:inline-block; min-width:25px" class="label label-info" ng-if="activitie.point!=null && intervention.tailleEquipe>1">{{activitie.point.pointChefBinome * activitie.qty}} / {{activitie.point.pointSupportBinome * activitie.qty}}</span> <span style="font-size:10px; display:inline-block; min-width:25px" class="label label-success" ng-if="activitie.point!=null && activitie.point.pointObjectif>0">{{activitie.point.pointObjectif * activitie.qty}}</span></div></td><td><div ng-repeat="bonDeCommande in intervention.bonDeCommandes"><span>{{bonDeCommande}}</span></div></td><td has-authority="ROLE_ADMIN">{{intervention.comparaisonStatus}}</td><td has-authority="ROLE_ADMIN">{{intervention.price}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button has-authority="ROLE_ADMIN" type="submit" ui-sref="intervention-detail({id:intervention.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button has-authority="ROLE_ADMIN" type="button" ng-click="vm.manualClose(intervention.id)" class="btn btn-default btn-sm" ng-if="intervention.comparaisonStatus !=\'CLOSE_MANUEL\' &&\r\n                                               intervention.comparaisonStatus !=\'CLOSE_AUTO\' &&\r\n                                               intervention.comparaisonStatus !=\'CLOSE_NOT_FACTURABLE\'\r\n                                        "><span class="glyphicon glyphicon-eye-close"></span> <span class="hidden-sm-down">Ignore</span></button> <button has-authority="ROLE_ADMIN" type="button" ng-click="vm.facturationFight(intervention.id)" class="btn btn-default btn-sm" ng-if="intervention.comparaisonStatus != \'CLOSE_MANUEL\' &&\r\n                                               intervention.comparaisonStatus != \'CLOSE_AUTO\' &&\r\n                                               intervention.comparaisonStatus != \'CLOSE_NOT_FACTURABLE\' &&\r\n                                               intervention.comparaisonStatus != \'FACTURATION_FIGHT\'\r\n                                        "><span class="glyphicon glyphicon-flash"></span> <span class="hidden-sm-down">Contester</span></button></div></td></tr></tbody></table></div></div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/import-constructel/import-constructel-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myImportConstructelLabel" data-translate="tmgApp.importConstructel.home.createOrEditLabel">Create or edit a Import Constructel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.importConstructel.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.importConstructel.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.importConstructel.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.importConstructel.name" required readonly="readonly"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setCsv($file, vm.importConstructel)"><label class="control-label" data-translate="tmgApp.importConstructel.csv" for="field_csv">Csv</label><div><div ng-if="vm.importConstructel.csv" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.importConstructel.csvContentType, vm.importConstructel.csv)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.importConstructel.csvContentType}}, {{vm.byteSize(vm.importConstructel.csv)}}</span> <button type="button" ng-click="vm.importConstructel.csv=null;vm.importConstructel.csvContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setCsv($file, vm.importConstructel)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="csv" id="field_csv" ng-model="vm.importConstructel.csv" required> <input type="hidden" class="form-control" name="csvContentType" id="field_csvContentType" ng-model="vm.importConstructel.csvContentType"><div ng-show="editForm.csv.$invalid"><p class="help-block" ng-show="editForm.csv.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/import-constructel/import-constructel-newFile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Importer un fichier de commande</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.importConstructel)"><label for="field_file">Fichiers</label><div><div ng-repeat="file in vm.importConstructel.files" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(file.fileContentType, file.file)" data-translate="entity.action.open"></a><br><span class="pull-left">{{file.fileName}}, {{vm.byteSize(file.file)}}</span> <button type="button" ng-click="vm.removeFile(file)" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select="vm.setFile($files, vm.importConstructel)" ngf-multiple="true" class="btn btn-default btn-block" ngf-change="vm.setFiles($files, vm.importConstructel)">Ajouter un fichier</button></div><input type="hidden" class="form-control" name="files" id="field_file" ng-model="vm.importConstructel.files" required></div><div class="form-group"><select name="typeImport" id="typeImport" ng-model="vm.importConstructel.typeImport" class="form-control" required><option value="SOGETREL">SOGETREL</option><option value="CONSTRUCTEL">CONSTRUCTEL</option><option value="KYNTUS">KYNTUS</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.importConstructel.files.length === 0" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/import-constructel/import-constructel.html','<div><h2>Import Commandes</h2><jhi-alert></jhi-alert><br><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterSearch">Rechercher</label><input type="text" class="form-control" id="filterSearch" ng-model="vm.filterSearch" ng-enter="vm.search()"></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterStatus">Status</label><select class="form-control" id="filterStatus" ng-model="vm.filterStatus" ng-change="vm.search()"><option></option><option>PROGRESS</option><option>PAID</option></select></div></div><div class="col-xs-12 col-md-2"><label class="control-label" for="field_type">Type</label><div><select id="field_type" class="form-control" name="type" ng-model="vm.filterType" ng-change="vm.search()"><option value=""></option><option value="CONSTRUCTEL">CONSTRUCTEL</option><option value="SOGETREL">SOGETREL</option><option value="KYNTUS">KYNTUS</option></select></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterDateFrom">Du</label><div class="input-group"><input type="text" class="form-control" id="filterDateFrom" ng-model="vm.filterDateFrom" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterDateTo">Au</label><div class="input-group"><input type="text" class="form-control" id="filterDateTo" ng-model="vm.filterDateTo" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateTo\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-xs-2"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div><div class="col-xs-2"><button class="btn btn-primary" ng-click="vm.resetProcess()"><span class="glyphicon glyphicon-refresh"></span> <span>Process again</span></button></div><div class="col-xs-2"><button class="btn btn-primary" ui-sref="import-constructel.newConstructel"><span class="glyphicon glyphicon-plus"></span> <span>Importer un fichier</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="tmgApp.importConstructel.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span>Type</span>Type<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateCreation"><span data-translate="tmgApp.importConstructel.dateCreation">Date Creation</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Date period</span></th><th jh-sort-by="nbInterventions"><span data-translate="tmgApp.importConstructel.nbInterventions">Nb Interventions</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Price</span></th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="importConstructel in vm.importConstructels track by importConstructel.id"><td><a ui-sref="import-constructel-detail({id:importConstructel.id})">{{importConstructel.name}}</a></td><td>{{importConstructel.type}}</td><td>{{importConstructel.dateCreation | date:\'medium\'}}</td><td>{{importConstructel.minDate | date:\'yyyy MMMM\'}} - {{importConstructel.maxDate | date:\'yyyy MMMM\' }}</td><td ng-if="importConstructel.nbInterventions && importConstructel.nbInterventionsError">{{importConstructel.nbInterventionsError}} en erreur / {{importConstructel.nbInterventions}} total</td><td ng-if="!importConstructel.nbInterventions || !importConstructel.nbInterventionsError"></td><td>{{importConstructel.totalPrice}} \u20AC</td><td>{{importConstructel.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="import-constructel-detail({id:importConstructel.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="button" ng-click="vm.process(importConstructel.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-sm-down" data-translate="process"></span></button> <button type="button" ng-click="vm.paid(importConstructel.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-euro"></span> <span class="hidden-sm-down">Pay\xE9</span></button> <button type="submit" ui-sref="import-constructel.delete({id:importConstructel.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="submit" ng-click="vm.openFile(importConstructel.csvContentType, importConstructel.csv)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download</span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/outil/outil-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.outil.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Etes-vous s\xFBr de vouloir supprimer cet outil?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/outil/outil-detail.html','<div><h2><span>Outil</span> {{vm.outil.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Id</span></dt><dd><span>{{vm.outil.id}}</span></dd><dt><span>Nom</span></dt><dd><span>{{vm.outil.name}}</span></dd><dt><span>Code</span></dt><dd><span>{{vm.outil.code}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.outil.description}}</span></dd><dt><span>Technicien</span></dt><dd><span>{{vm.outil.technicien}}</span></dd><dt><span>Actif</span></dt><dd ng-if="vm.outil.enabled"><span>Oui</span></dd><dd ng-if="!vm.outil.enabled"><span>Non</span></dd><dt><span>Afficher dans le planning</span></dt><dd ng-if="vm.outil.showPlanning"><span>Oui</span></dd><dd ng-if="!vm.outil.showPlanning"><span>Non</span></dd><dt><span>Prix mensuel</span></dt><dd><span>{{vm.outil.monthlyPrice | currency:\'\u20AC\':2 }}</span></dd><dt><span>Prix journalier</span></dt><dd><span>{{vm.outil.dailyPrice | currency:\'\u20AC\':2}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Retour</span></button></div>');
$templateCache.put('app/entities/outil/outil-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 ng-show="!vm.outil.id" class="modal-title">Ajouter un outil</h4><h4 ng-show="vm.outil.id" class="modal-title">Editer un outil</h4></div><div class="modal-body"><div class="form-group" ng-show="vm.outil.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.outil.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Nom</label><input type="text" class="form-control" id="field_name" name="name" ng-model="vm.outil.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label for="field_code" class="control-label">Code</label><input type="text" class="form-control" id="field_code" name="code" ng-model="vm.outil.code" maxlength="7" required><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea name="description" id="field_description" class="form-control" ng-model="vm.outil.description"></textarea></div><div class="form-group"><label for="field_technicien">Technicien</label><select class="form-control" id="field_technicien" name="field_technicien" ng-model="vm.outil.technicien"><option value=""></option><option ng-repeat="technicien in vm.techniciens" value="{{technicien.displayname}}">{{technicien.displayname}}</option></select></div><div class="form-group"><label class="control-label" for="field_enabled">Actif</label><input type="checkbox" name="enabled" id="field_enabled" ng-model="vm.outil.enabled"></div><div class="form-group"><label class="control-label" for="field_show_planning">Afficher dans le planning</label><input type="checkbox" name="show_planning" id="field_show_planning" ng-model="vm.outil.showPlanning"></div><div class="outil-prices"><div class="form-group"><label class="control-label" for="field_dailyPrice">Prix journalier</label><input type="number" class="form-control" name="dailyPrice" id="field_dailyPrice" ng-model="vm.outil.dailyPrice" required><div ng-show="editForm.dailyPrice.$invalid || editForm.monthlyPrice.$invalid"><p class="help-block" ng-show="editForm.dailyPrice.$error.required || editForm.monthlyPrice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="adaptPriceBtns"><div class="dailyToMonthlyBtn" ng-click="vm.dailyToMonthlyPrice()"><span><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><style>svg{fill:#005cc8}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span></div><div class="monthlyToDailyBtn" ng-click="vm.monthlyToDailyPrice()"><span><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><style>svg{fill:#005cc8}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></span></div></div><div class="form-group"><label class="control-label" for="field_monthlyPrice">Prix mensuel</label><input type="number" class="form-control" name="monthlyPrice" id="field_monthlyPrice" ng-model="vm.outil.monthlyPrice" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/outil/outil.html','<div><h2>Outil</h2><div class="row"><div class="col-xs-4"><button class="btn btn-primary" ui-sref="outil.new"><span class="glyphicon glyphicon-plus"></span> <span>Ajouter un outil</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Nom</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span>Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span>Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span>Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="enabled"><span>Actif</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="showPlanning"><span>Affichage planning</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="monthlyPrice"><span>Prix mensuel</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dailyPrice"><span>Prix journalier</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="outil in vm.outils track by outil.id"><td><a ui-sref="charge-technicien-detail({id:chargeTechnicien.id})">{{outil.id}}</a></td><td>{{outil.name}}</td><td>{{outil.code}}</td><td>{{ (outil.description.length > 40) ? (outil.description.substr(0, 40) + \' (...)\') : outil.description }}</td><td>{{ outil.technicien }}</td><td ng-if="outil.enabled">Oui</td><td ng-if="!outil.enabled">Non</td><td ng-if="outil.showPlanning">Oui</td><td ng-if="!outil.showPlanning">Non</td><td style="text-align: right">{{ outil.monthlyPrice | currency:\'\u20AC\':2 }}</td><td style="text-align: right">{{ outil.dailyPrice | currency:\'\u20AC\':2 }}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="outil-detail({id:outil.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="outil.edit({id:outil.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="outil.delete({id:outil.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/resultat-technicien/resultat-technicien.html','<h2>Resultats techniciens mensuels</h2><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien" ng-change="vm.search()"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label for="filterDateFrom">Date From</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.previousMonth()"><i class="glyphicon glyphicon-backward"></i></button> </span><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.previousDay()"><i class="glyphicon glyphicon-chevron-left"></i></button> </span><input type="text" class="form-control" id="filterDateFrom" ng-model="vm.filterDateFrom" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label for="filterDateFrom">Date To</label><div class="input-group"><input type="text" class="form-control" id="filterDateTo" ng-model="vm.filterDateTo" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateTo\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.nextDay()"><i class="glyphicon glyphicon-chevron-right"></i></button> </span><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.nextMonth()"><i class="glyphicon glyphicon-forward"></i></button></span></div></div></div><div class="col-xs-12 col-md-3"><label class="control-label" for="field_type">Type</label><div><select id="field_type" class="form-control" name="type" ng-model="vm.filterType"><option value=""></option><option value="SALAIRE">SALAIRE</option><option value="OUTIL">OUTIL</option><option value="ACTIVITE">ACTIVITE</option><option value="CHARGE">CHARGE</option><option value="ASTREINTE">ASTREINTE</option><option value="REGUL">REGUL</option></select></div></div></div><div><button class="btn btn-primary"><span class="glyphicon glyphicon-search"></span> <span ng-click="vm.search()">Rechercher</span></button> <button class="btn btn-danger" ng-disabled="vm.reportChargeBtnDisable"><span class="glyphicon glyphicon-plus"></span> <span ng-click="vm.addChargePreviousMonth()">Ajouter les charges du mois precedent</span></button></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Technicien</span></th><th><span>Mois</span></th><th><span>Description</span></th><th><span>Type</span></th><th><span>Quantit\xE9</span></th><th><span></span></th></tr></thead><tbody><tr ng-repeat="resultat in vm.resultatTechniciens"><td>{{resultat.technicienName}}</td><td>{{resultat.yearMonth}}</td><td>{{ (resultat.description.length > 40) ? (resultat.description.substr(0, 40) + \'(...)\') : resultat.description }}</td><td ng-click="vm.test(resultat)">{{resultat.type}}</td><td>{{resultat.qty}}</td><td ng-if="resultat.price" style="text-align: right" ng-class="{\'text-red\': resultat.price < 0, \'text-green\': resultat.price > 0}">{{ resultat.price | currency:\'\u20AC\':2 }}</td><td ng-if="!resultat.price" style="text-align: right">--</td></tr></tbody><tfoot ng-if="vm.resultatTechniciens.length>0"><tr><td colspan="5"></td><td style="text-align: right"><b>Chiffre d\'affaire: {{ vm.getCATotal()}} \u20AC</b></td></tr><tr><td colspan="5"></td><td style="text-align: right"><b>Charges: {{ vm.getChargeTotal()}} \u20AC</b></td></tr><tr><td colspan="5"></td><td style="text-align: right"><b>Total: {{ vm.getTotal()}} \u20AC</b></td></tr></tfoot></table></div></div>');
$templateCache.put('app/entities/stat-technicien/stat-techniciens.html','<div><h2 data-translate="tmgApp.statTechnicien.home.title">Stat Techniciens</h2><jhi-alert></jhi-alert><div class="alert alert-info" role="alert">Les statistiques technicien ne prennent en compte ques les interventions factur\xE9s par d\xE9faut.<br>Si la colonne points est vide, vous devez saisir le bar\xEAme de l\'activit\xE9 dans le menu "Point"</div><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien" ng-change="vm.search()"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label for="filterDateFrom">Date From</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.previousMonth()"><i class="glyphicon glyphicon-backward"></i></button> </span><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.previousDay()"><i class="glyphicon glyphicon-chevron-left"></i></button> </span><input type="text" class="form-control" id="filterDateFrom" ng-model="vm.filterDateFrom" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-md-3"><div class="form-group"><label for="filterDateFrom">Date To</label><div class="input-group"><input type="text" class="form-control" id="filterDateTo" ng-model="vm.filterDateTo" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateTo\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.nextDay()"><i class="glyphicon glyphicon-chevron-right"></i></button> </span><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.nextMonth()"><i class="glyphicon glyphicon-forward"></i></button></span></div></div></div><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterComparaisonStatus">Comparaison</label><select class="form-control" name="filterComparaisonStatus" ng-model="vm.filterComparaisonStatus" id="filterComparaisonStatus" ng-change="vm.search()" multiple="multiple" size="7"><option value=""></option><option value="PRAXEDO_MISSING" data-translate="tmgApp.comparaisonStatus.PRAXEDO_MISSING">PRAXEDO_MISSING</option><option value="FACTURATION_MISSING" data-translate="tmgApp.comparaisonStatus.FACTURATION_MISSING">FACTURATION_MISSING</option><option value="FACTURATION_MISMATCH" data-translate="tmgApp.comparaisonStatus.FACTURATION_MISMATCH">FACTURATION_MISMATCH</option><option value="CLOSE" data-translate="tmgApp.comparaisonStatus.CLOSE">CLOSE</option><option value="CLOSE_MANUEL" data-translate="tmgApp.comparaisonStatus.CLOSE_MANUAL">CLOSE_MANUAL</option><option value="CLOSE_NOT_FACTURABLE" data-translate="tmgApp.comparaisonStatus.CLOSE_NOT_FACTURABLE">CLOSE_NOT_FACTURABLEL</option></select></div></div></div><div class="row"><div class="col-xs-12"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="tmgApp.statTechnicien.technicien">Technicien</span></th><th><span data-translate="tmgApp.statTechnicien.yearMonth">Year Month</span></th><th><span data-translate="tmgApp.statTechnicien.code">Code</span></th><th><span>Point</span></th><th><span data-translate="tmgApp.statTechnicien.qtyMonome">qtyMonome</span></th><th><span data-translate="tmgApp.statTechnicien.qtyChefEquipe">qtyChefEquipe</span></th><th><span data-translate="tmgApp.statTechnicien.qtySupportEquipe">qtySupportEquipe</span></th><th><span data-translate="tmgApp.statTechnicien.totalPoints">Points</span></th><th ng-if="vm.isAdmin"><span data-translate="tmgApp.statTechnicien.ca">Chiffre d\'affaire</span></th></tr></thead><tbody><tr ng-repeat="statTechnicien in vm.statTechniciens"><td>{{statTechnicien.technicien}}</td><td>{{statTechnicien.yearMonth}}</td><td>{{statTechnicien.code}}</td><td><span style="font-size:10px">{{statTechnicien.point.pointChefMonome}} / {{statTechnicien.point.pointChefBinome}} / {{statTechnicien.point.pointSupportBinome}}</span></td><td><a ng-if="vm.isAdmin" ui-sref="intervention({technicien:statTechnicien.technicien,technicienRole:\'MONOME\',dateFrom:vm.filterDateFrom,dateTo:vm.filterDateTo,search:statTechnicien.code,comparaisonStatus:vm.filterComparaisonStatus})">{{statTechnicien.qtyMonome}}</a><p ng-if="!vm.isAdmin">{{statTechnicien.qtyMonome}}</p></td><td><a ng-if="vm.isAdmin" ui-sref="intervention({technicien:statTechnicien.technicien,technicienRole:\'CHEF_BINOME\',dateFrom:vm.filterDateFrom,dateTo:vm.filterDateTo,search:statTechnicien.code,comparaisonStatus:vm.filterComparaisonStatus})">{{statTechnicien.qtyChefEquipe}}</a><p ng-if="!vm.isAdmin">{{statTechnicien.qtyChefEquipe}}</p></td><td><a ng-if="vm.isAdmin" ui-sref="intervention({technicienEquipe:statTechnicien.technicien,technicienRole:\'SUPPORT_BINOME\',dateFrom:vm.filterDateFrom,dateTo:vm.filterDateTo,search:statTechnicien.code,comparaisonStatus:vm.filterComparaisonStatus})">{{statTechnicien.qtySupportEquipe}}</a><p ng-if="!vm.isAdmin">{{statTechnicien.qtySupportEquipe}}</p></td><td>{{statTechnicien.totalPoints}}</td><td ng-if="vm.isAdmin"><span ng-if="statTechnicien.price">{{ vm.numberWithSpace(statTechnicien.price) }} \u20AC</span></td></tr></tbody><tfoot ng-if="vm.statTechniciens.length>0"><tr><td colspan="7"></td><td><b>{{ vm.getTotalPoints() }}</b></td><td ng-if="vm.isAdmin"><b>{{ vm.getTotalChiffre() }} \u20AC</b></td></tr></tfoot></table></div></div>');
$templateCache.put('app/entities/stat-facturation-mensuel/stat-facturation-mensuels.html','<div><h2 data-translate="tmgApp.statFacturationMensuel.home.title">Stat Facturation Mensuels</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-2"><div class="form-group"><label for="filterDateFrom">Date From</label><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.previousMonth()"><i class="glyphicon glyphicon-backward"></i></button> </span><input type="text" class="form-control" id="filterDateFrom" ng-model="vm.filterDateFrom" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateFrom" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateFrom\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-2"><div class="form-group"><label for="filterDateTo">Date To</label><div class="input-group"><input type="text" class="form-control" id="filterDateTo" ng-model="vm.filterDateTo" datetime-picker="yyyy-MM-dd" enable-time="false" save-as="true" is-open="vm.datePickerOpenStatus.filterDateTo" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'filterDateTo\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.nextMonth()"><i class="glyphicon glyphicon-forward"></i></button></span></div></div></div></div><div class="row"><div class="col-xs-12"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span>Search</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="tmgApp.statFacturationMensuel.yearmonth">Year month</span></th><th><span data-translate="tmgApp.statFacturationMensuel.nbInterventions">Nb Interventions</span></th><th><span data-translate="tmgApp.statFacturationMensuel.comparaisonStatus">Comparaison Status</span></th><th><span data-translate="tmgApp.statFacturationMensuel.totalPrice">Total Price</span></th></tr></thead><tbody><tr ng-repeat="statFacturationMensuel in vm.statFacturationMensuels"><td>{{statFacturationMensuel.yearMonth}}</td><td>{{statFacturationMensuel.nbInterventions}}</td><td>{{statFacturationMensuel.comparaisonStatus}}</td><td>{{statFacturationMensuel.totalPrice}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/sfr-file/sfr-file-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sfrFile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.sfrFile.delete.question" translate-values="{id: \'{{vm.sfrFile.id}}\'}">Are you sure you want to delete this Sfr File?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sfr-file/sfr-file-detail.html','<div><h2><span data-translate="tmgApp.sfrFile.detail.title">Sfr File</span> {{vm.sfrFile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.sfrFile.date">Date</span></dt><dd><span>{{vm.sfrFile.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="tmgApp.sfrFile.fileName">fileName</span></dt><dd><span>{{vm.sfrFile.fileName}}</span></dd><dt><span data-translate="tmgApp.sfrFile.file">File</span></dt><dd><div ng-if="vm.sfrFile.file"><a ng-click="vm.openFile(vm.sfrFile.fileContentType, vm.sfrFile.file)" data-translate="entity.action.open">open</a> {{vm.sfrFile.fileContentType}}, {{vm.byteSize(vm.sfrFile.file)}}</div></dd><dt><span data-translate="tmgApp.sfrFile.nbInterventions">Nb Interventions</span></dt><dd><span>{{vm.sfrFile.nbInterventions}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sfr-file-detail.edit({id:vm.sfrFile.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/sfr-file/sfr-file-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySfrFileLabel" data-translate="tmgApp.sfrFile.home.createOrEditLabel">Create or edit a Sfr File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sfrFile.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sfrFile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.sfrFile.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.sfrFile.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.sfrFile)"><label class="control-label" data-translate="tmgApp.sfrFile.file" for="field_file">File</label><div><div ng-if="vm.sfrFile.file" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.sfrFile.fileContentType, vm.sfrFile.file)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.sfrFile.fileContentType}}, {{vm.byteSize(vm.sfrFile.file)}}</span> <button type="button" ng-click="vm.sfrFile.file=null;vm.sfrFile.fileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, vm.sfrFile)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.sfrFile.file" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.sfrFile.fileContentType"><div ng-show="editForm.file.$invalid"><p class="help-block" ng-show="editForm.file.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.sfrFile.fileName" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.sfrFile.fileName" required><div ng-show="editForm.fileName.$invalid"><p class="help-block" ng-show="editForm.fileName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sfr-file/sfr-files.html','<div><h2 data-translate="tmgApp.sfrFile.home.title">Sfr Files</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sfr-file.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.sfrFile.home.createLabel">Create new Sfr File</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="tmgApp.sfrFile.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileName"><span data-translate="tmgApp.sfrFile.fileName">FileName</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="file"><span data-translate="tmgApp.sfrFile.file">File</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nbInterventions"><span data-translate="tmgApp.sfrFile.nbInterventions">Nb Interventions</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="sfrFile in vm.sfrFiles track by sfrFile.id"><td><a ui-sref="sfr-file-detail({id:sfrFile.id})">{{sfrFile.id}}</a></td><td>{{sfrFile.date | date:\'mediumDate\'}}</td><td>{{sfrFile.fileName}}</td><td><a ng-if="sfrFile.file" ng-click="vm.openFile(sfrFile.fileContentType, sfrFile.file)" data-translate="entity.action.open">open</a> <span ng-if="sfrFile.file">{{sfrFile.fileContentType}}, {{vm.byteSize(sfrFile.file)}}</span></td><td>{{sfrFile.nbInterventions}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.process(sfrFile.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-sm-down" data-translate="process"></span></button> <button type="submit" ui-sref="sfr-file-detail({id:sfrFile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="sfr-file.edit({id:sfrFile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="sfr-file.delete({id:sfrFile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/technicien/technicien-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.technicien.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.technicien.delete.question" translate-values="{id: \'{{vm.technicien.id}}\'}">Are you sure you want to delete this Technicien?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/technicien/technicien-detail.html','<div><h2><span data-translate="tmgApp.technicien.detail.title">Technicien</span> {{vm.technicien.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.technicien.displayname">Displayname</span></dt><dd><span>{{vm.technicien.displayname}}</span></dd><dt><span data-translate="tmgApp.technicien.firstName">First Name</span></dt><dd><span>{{vm.technicien.firstName}}</span></dd><dt><span data-translate="tmgApp.technicien.lastName">Last Name</span></dt><dd><span>{{vm.technicien.lastName}}</span></dd><dt><span data-translate="tmgApp.technicien.email">Email</span></dt><dd><span>{{vm.technicien.email}}</span></dd><dt><span data-translate="tmgApp.technicien.enabled">Enabled</span></dt><dd><span>{{vm.technicien.enabled}}</span></dd><dt><span data-translate="tmgApp.technicien.order">Order</span></dt><dd><span>{{vm.technicien.order}}</span></dd><dt><span data-translate="tmgApp.technicien.matricule">Matricule</span></dt><dd><span>{{vm.technicien.matricule}}</span></dd><dt><span data-translate="tmgApp.technicien.aliases">Aliases</span></dt><dd><div ng-repeat="alias in vm.technicien.aliases track by $index">{{vm.technicien.aliases[$index]}}</div></dd><dt><span>Co\xFBt mensuel</span></dt><dd><span>{{vm.technicien.cost | currency:\'\u20AC\':2 }}</span></dd><dt><span>Co\xFBt horaire astreinte</span></dt><dd><span>{{vm.technicien.astreinteCost | currency:\'\u20AC\':2 }}</span></dd><dt><span>Detail du salaire</span></dt><dd><span>{{vm.technicien.costDetail}}</span></dd><dt><span>Afficher dans le planning equipes</span></dt><dd ng-if="vm.technicien.planningEquipe"><span>Oui</span></dd><dd ng-if="!vm.technicien.planningEquipe"><span>Non</span></dd><dt><span>Afficher la barre de progression</span></dt><dd ng-if="vm.technicien.displayProgressBar"><span>Oui</span></dd><dd ng-if="!vm.technicien.displayProgressBar"><span>Non</span></dd><br></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="technicien-detail.edit({id:vm.technicien.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button type="button" class="btn btn-warning" ng-click="vm.verifyAliase()"><span class="glyphicon glyphicon-refresh"></span> <span class="hidden-sm-down">Verify Aliases</span></button></div>');
$templateCache.put('app/entities/technicien/technicien-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTechnicienLabel" data-translate="tmgApp.technicien.home.createOrEditLabel">Create or edit a Technicien</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.technicien.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.technicien.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.displayname" for="field_displayname">Displayname</label><input type="text" class="form-control" name="displayname" id="field_displayname" ng-model="vm.technicien.displayname" required><div ng-show="editForm.displayname.$invalid"><p class="help-block" ng-show="editForm.displayname.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.technicien.firstName" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.technicien.lastName" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.technicien.email"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.enabled" for="field_enabled">Enabled</label><input type="checkbox" name="enabled" id="field_enabled" ng-model="vm.technicien.enabled"><div ng-show="editForm.enabled.$invalid"><p class="help-block" ng-show="editForm.enabled.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.enabled.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.enabled.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.displayInObjectif" for="field_DisplayInObjectif">Display In Objectif</label><input type="checkbox" name="displayInObjectif" name="displayInObjectif" id="field_DisplayInObjectif" ng-model="vm.technicien.displayInObjectif"></div><div class="form-group"><label for="field_order" class="control-label" data-translate="tmgApp.technicien.order">Order</label><input type="number" name="order" id="field_order" class="form-control" ng-model="vm.technicien.order"><div ng-show="editForm.order.$invalid"><p class="help-block" ng-show="editForm.order.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.order.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label for="field_matricule" class="control-label" data-translate="tmgApp.technicien.matricule">Matricule</label><input type="number" name="matricule" id="field_matricule" class="form-control" ng-model="vm.technicien.matricule"><div ng-show="editForm.hours.$invalid"><p class="help-block" ng-show="editForm.order.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.order.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.aliases" for="field_aliases">Aliases</label><dd ng-repeat="alias in vm.technicien.aliases track by $index"><div class="input-group"><input type="text" class="form-control" ng-model="vm.technicien.aliases[$index]" ng-trim="false"> <span class="input-group-addon" ng-click="vm.removeAlias($index)"><span class="glyphicon glyphicon-remove"></span></span></div></dd><button type="button" class="btn btn-default" ng-click="vm.addAlias()"><span class="glyphicon glyphicon-plus"></span></button></div><div class="form-group"><label for="field_cost" class="control-label">Co\xFBt mensuel</label><input type="number" name="cost" id="field_cost" class="form-control" ng-model="vm.technicien.cost"></div><div class="form-group"><label for="field_astreinte_cost" class="control-label">Co\xFBt horaire astreinte</label><input type="number" name="astreinteCost" id="field_astreinte_cost" class="form-control" ng-model="vm.technicien.astreinteCost"></div><div class="form-group"><label class="control-label" for="field_cost_detail">Details du salaire</label><textarea name="cost_detail" id="field_cost_detail" class="form-control" ng-model="vm.technicien.costDetail"></textarea></div><div class="form-groupe"><label class="control-label" for="field_planningEquipe">Afficher dans le planning \xE9quipes</label><input type="checkbox" name="planningEquipe" id="field_planningEquipe" ng-model="vm.technicien.planningEquipe"><div ng-show="editForm.planningEquipe.$invalid"><p class="help-block" ng-show="editForm.planningEquipe.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.technicien.fleetDailySubstraction" for="field_fleetDailySubstraction">Soustraction quotidienne flotte (heures)</label><input type="number" step="0.01" name="fleetDailySubstraction" id="field_fleetDailySubstraction" class="form-control" ng-model="vm.technicien.fleetDailySubstraction"><p class="help-block">Nombre d\'heures \xE0 soustraire chaque jour (pause d\xE9jeuner et trajets non compt\xE9s). D\xE9faut&nbsp;: 0,5.</p></div><div class="form-groupe"><label class="control-label" for="field_displayProgressBar">Afficher la barre de progression</label><input type="checkbox" name="displayProgressBar" id="field_displayProgressBar" ng-model="vm.technicien.displayProgressBar"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/technicien/techniciens.html','<div><h2 data-translate="tmgApp.technicien.home.title">Techniciens</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-12 col-md-2"><div class="form-group"><label for="filterSearch">Display Name</label><input type="text" class="form-control" id="filterSearch" ng-model="vm.filterSearch" ng-enter="vm.search()"></div></div></div><div class="row"><div class="col-xs-1"><button class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon gliphycon-search"></span> <span>Search</span></button></div><div class="col-xs-1"><button class="btn btn-warning" ng-click="vm.reset()"><span class="glyphicon glyphicon-erase"></span> <span>Reset</span></button></div></div><div class="row"><div class="col-xs-1" style="margin-top: 1rem"><button class="btn btn-primary" ui-sref="technicien.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.technicien.home.createLabel">Create new Technicien</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="displayname"><span data-translate="tmgApp.technicien.displayname">Displayname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="tmgApp.technicien.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="enabled"><span data-translate="tmgApp.technicien.enabled">Enabled</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="order"><span data-translate="tmgApp.technicien.order">Order</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="matricule"><span data-translate="tmgApp.technicien.matricule">Matricule</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="displayInObjectif"><span>Appara\xEEtre dans objectif</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cost"><span>Co\xFBt mensuel</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="astreinteCost"><span>Co\xFBt horaire astreinte</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="technicien in vm.techniciens track by technicien.id"><td><a ui-sref="technicien-detail({id:technicien.id})">{{technicien.id}}</a></td><td>{{technicien.displayname}}</td><td>{{technicien.email}}</td><td>{{technicien.enabled}}</td><td>{{technicien.order}}</td><td>{{technicien.matricule}}</td><td>{{technicien.displayInObjectif}}</td><td style="text-align: right">{{technicien.cost | currency:\'\u20AC\':2 }}</td><td style="text-align: right">{{technicien.astreinteCost | currency:\'\u20AC\':2 }}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="technicien-detail({id:technicien.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="technicien.edit({id:technicien.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="technicien.delete({id:technicien.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/valorisation/valorisation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.valorisation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="tmgApp.valorisation.delete.question" translate-values="{id: \'{{vm.valorisation.id}}\'}">Are you sure you want to delete this valorisation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/valorisation/valorisation-detail.html','<div><h2><span data-translate="tmgApp.valorisation.detail.title">Valorisation</span> {{vm.valorisation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="tmgApp.conges.technicien">Technicien</span></dt><dd><span>{{vm.valorisation.technicien}}</span></dd><dt><span data-translate="tmgApp.valorisation.date">Date</span></dt><dd><span>{{vm.valorisation.date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="type">Type</span></dt><dd><span>{{vm.valorisation.type}}</span></dd><dt><span data-translate="tmgApp.valorisation.point">Point</span></dt><dd><span>{{vm.valorisation.point}}</span></dd><dt><span data-translate="tmgApp.valorisation.commentary">Commentary</span></dt><dd><span>{{ vm.valorisation.commentary }}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/valorisation/valorisation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAstreinteLabel" data-translate="tmgApp.valorisation.home.createOrEditLabel">Create or edit a valorisation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.valorisation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.valorisation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="tmgApp.valorisation.technicien" for="field_technicien">Technicien</label><select class="form-control" name="technicien" ng-model="vm.valorisation.technicien" id="field_technicien" required><option ng-repeat="technicien in vm.techniciens">{{ technicien.displayname }}</option></select><div ng-show="editForm.technicien.$invalid"><p class="help-block" ng-show="editForm.technicien.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.valorisation.date" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-value="vm.valorisation.date" ng-model="vm.valorisation.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block" ng-show="editForm.date.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="tmgApp.valorisation.type" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.valorisation.type" id="field_type" required><option value="PRIME_OBJECTIF">PRIME OBJECTIF</option><option value="PRIME_REALISEE">PRIME REALISEE</option><option value="STAT_TECHNICIEN">STAT_TECHNICIEN</option></select><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.valorisation.point" for="field_point">Point</label><input type="number" class="form-control" name="point" id="field_point" ng-model="vm.valorisation.point" required><div ng-show="editForm.point.$invalid"><p class="help-block" ng-show="editForm.point.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="tmgApp.valorisation.commentaire" for="field_commentaire">Commentaire</label><input type="text" class="form-control" name="commentary" id="field_commentaire" ng-model="vm.valorisation.commentary"></div></div><div class="modal-footer"><button type="button" ng-if="vm.valorisation.id != null" class="btn btn-danger" ng-click="vm.deleteValorisation(vm.valorisation.id)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/valorisation/valorisation.html','<div><h2>Valorisation</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-6 col-md-3" has-authority="ROLE_ADMIN"><div class="form-group"><label for="filterTechnicien">Technicien</label><select class="form-control" name="filterTechnicien" ng-model="vm.filterTechnicien" id="filterTechnicien" ng-change="vm.search()"><option></option><option ng-repeat="technicien in vm.techniciens">{{ technicien }}</option></select></div></div><div class="col-xs-6 col-md-3"><div class="form-group"><label for="filterType">Type</label><select class="form-control" name="filterType" ng-model="vm.filterType" id="filterType" ng-change="vm.search()"><option></option><option ng-repeat="type in vm.typeDispo">{{ type }}</option></select></div></div><div class="col-xs-6 col-md-3"><div class="form-group"><label for="filterAnnee">Ann\xE9e</label><select class="form-control" name="filterAnnee" ng-model="vm.filterAnnee" id="filterAnnee" ng-change="vm.search()"><option></option><option ng-repeat="annee in vm.yearDispo">{{ annee }}</option></select></div></div><div class="col-xs-6 col-md-3"><div class="form-group"><label for="filterSemaine">Semaine</label><select class="form-control" name="filterSemaine" ng-model="vm.filterSemaine" id="filterSemaine" ng-change="vm.search()"><option></option><option ng-repeat="semaine in vm.semaineDispo">{{ semaine }}</option></select></div></div></div><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="valorisation.new" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span data-translate="tmgApp.valorisation.home.createLabel">Create new valorisation</span></button></div></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="type"><span data-translate="tmgApp.valorisation.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="technicien"><span data-translate="tmgApp.valorisation.technicien">Technicien</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="date"><span data-translate="tmgApp.valorisation.date">Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="point"><span data-translate="tmgApp.valorisation.point ">Point </span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="valorisation in vm.valorisations track by valorisation.id"><td><a ui-sref="valorisation-detail({id:valorisation.id})">{{valorisation.id}}</a></td><td>{{valorisation.type}}</td><td>{{valorisation.technicien}}</td><td>{{valorisation.date}}</td><td>{{valorisation.point}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!-- <button type="submit"\r\n                                ui-sref="valorisation-detail({id:valorisation.id})"\r\n                                class="btn btn-info">\r\n                            <span class="glyphicon glyphicon-eye-open"></span>\r\n                            <span class="hidden-sm-down" data-translate="entity.action.view"></span>\r\n                        </button> --> <button type="submit" has-authority="ROLE_ADMIN" ui-sref="valorisation.edit({id:valorisation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="valorisation.delete({id:valorisation.id})" has-authority="ROLE_ADMIN" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">Tmg</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'technicienMenu\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="technicien-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.technicien">Technicien </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="stat-technicien" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.statTechnicien">Stats Technicien</span></a></li><li ui-sref-active="active"><a ui-sref="astreinte" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.astreinte">Astreinte</span></a></li><li ui-sref-active="active"><a ui-sref="conges" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.conges">Cong\xE9s et autres</span></a></li><li ui-sref-active="active"><a ui-sref="intervention" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.intervention">Intervention</span></a></li><li ui-sref-active="active"><a ui-sref="astreinte-planifie" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.astreintePlanifie">Astreinte planifi\xE9</span></a></li><li ui-sref-active="active"><a ui-sref="calendar" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.calendar">Calendar</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="valorisation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.valorisation">Valorisation</span></a></li><li ui-sref-active="active"><a ui-sref="bonusObjWeek" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.BonusObjWeek">Objectif Semaine</span></a></li><li ui-sref-active="active"><a ui-sref="bonusObjMonth" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.BonusObjMonth">Objectif Mois</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'import\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="import-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.import">Import </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="export-praxedo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.exportPraxedo">Import</span></a></li><li ui-sref-active="active"><a ui-sref="import-constructel" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Import Commandes</span></a></li><li ui-sref-active="active"><a ui-sref="sfr-file" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.sfrFile">Sfr File</span></a></li><li ui-sref-active="active"><a ui-sref="indicator-file" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.indicatorFile">Indicator File</span></a></li><li ui-sref-active="active"><a ui-sref="fleet-daily-trip" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.fleetDailyTrip">Trajet Journalier</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'gestion\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="gestion-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.gestion">Gestion </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="technicien" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.technicien">Technicien</span></a></li><li ui-sref-active="active"><a ui-sref="charge-technicien" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span> <span>Charge technicien</span></a></li><li ui-sref-active="active"><a ui-sref="resultat-technicien" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span> <span>Resultats techniciens</span></a></li><li ui-sref-active="active"><a ui-sref="paie" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.paie">Paie</span></a></li><li ui-sref-active="active"><a ui-sref="point" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.pointarticle">Point article</span></a></li><li ui-sref-active="active"><a ui-sref="outil" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Outil</span></a></li><li ui-sref-active="active"><a ui-sref="config" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.config">Config</span></a></li><li ui-sref-active="active"><a ui-sref="equipe" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.equipe">Equipe</span></a></li><li ui-sref-active="active"><a ui-sref="groupe-planning" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span> <span data-translate="global.menu.entities.groupePlanning">Planning group</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/account/social/directive/social.html','<form action="{{ providerURL }}" method="POST"><button type="submit" class="btn btn-block jh-btn-social jh-btn-{{ provider }}"><span data-translate="social.btnLabel" translate-values="{ label: label }">Sign in with {{ label }}</span></button> <input name="scope" type="hidden" value="{{\xA0providerSetting }}"> <input name="_csrf" type="hidden" value="{{\xA0csrf }}"></form>');}]);})();